// Generated from ./util_cohort_builder_grammar/stable/StudyPeriod.g4 by ANTLR 4.13.1

import * as antlr from "antlr4ng";
import { Token } from "antlr4ng";

import { StudyPeriodListener } from "./StudyPeriodListener.js";
import { StudyPeriodVisitor } from "./StudyPeriodVisitor.js";

// for running tests with parameters, TODO: discuss strategy for typed parameters in CI
// eslint-disable-next-line no-unused-vars
type int = number;


export class StudyPeriod extends antlr.Parser {
    public static readonly STUDY_PERIOD = 1;
    public static readonly BASELINE = 2;
    public static readonly FOLLOW_UP = 3;
    public static readonly INDEX_DATE = 4;
    public static readonly EVENT = 5;
    public static readonly CALENDAR_DATE = 6;
    public static readonly UPPER_DATE_BOUND = 7;
    public static readonly LOWER_DATE_BOUND = 8;
    public static readonly DERIVED_EVENT_DATE = 9;
    public static readonly CONSTRAINTS = 10;
    public static readonly ANY_ORDER = 11;
    public static readonly IS_EVENT_DATE = 12;
    public static readonly TC = 13;
    public static readonly TEMPORAL_CONSTRAINT_ABBR = 14;
    public static readonly TEMPORAL_CONSTRAINT = 15;
    public static readonly POSITION = 16;
    public static readonly CF = 17;
    public static readonly CONCEPT_FILTER = 18;
    public static readonly CONCEPT_FILTER_ABBR = 19;
    public static readonly NF = 20;
    public static readonly NUMERIC_FILTER = 21;
    public static readonly NUMERIC_FILTER_ABBR = 22;
    public static readonly SF = 23;
    public static readonly STRING_FILTER = 24;
    public static readonly STRING_FILTER_ABBR = 25;
    public static readonly UF = 26;
    public static readonly UNIQUENESS_FILTER = 27;
    public static readonly UNIQUENESS_FILTER_ABBR = 28;
    public static readonly RF = 29;
    public static readonly RELATED_ENTITY_FILTER = 30;
    public static readonly RELATED_ENTITY_FILTER_ABBR = 31;
    public static readonly QUALIFIED_CARE_SITE_ALIAS = 32;
    public static readonly QUALIFIED_CONDITION_OCCURRENCE_ALIAS = 33;
    public static readonly QUALIFIED_DRUG_EXPOSURE_ALIAS = 34;
    public static readonly QUALIFIED_MEASUREMENT_ALIAS = 35;
    public static readonly QUALIFIED_OBSERVATION_ALIAS = 36;
    public static readonly QUALIFIED_PERSON_ALIAS = 37;
    public static readonly QUALIFIED_PROCEDURE_OCCURRENCE_ALIAS = 38;
    public static readonly QUALIFIED_PROVIDER_ALIAS = 39;
    public static readonly QUALIFIED_VISIT_OCCURRENCE_ALIAS = 40;
    public static readonly QUALIFIED_DERIVED_EVENT_NAME = 41;
    public static readonly SUBJECT_VARIABLE_CARE_SITE_ALIAS = 42;
    public static readonly SUBJECT_VARIABLE_CONDITION_OCCURRENCE_ALIAS = 43;
    public static readonly SUBJECT_VARIABLE_DRUG_EXPOSURE_ALIAS = 44;
    public static readonly SUBJECT_VARIABLE_MEASUREMENT_ALIAS = 45;
    public static readonly SUBJECT_VARIABLE_OBSERVATION_ALIAS = 46;
    public static readonly SUBJECT_VARIABLE_PROCEDURE_OCCURRENCE_ALIAS = 47;
    public static readonly SUBJECT_VARIABLE_PROVIDER_ALIAS = 48;
    public static readonly SUBJECT_VARIABLE_VISIT_OCCURRENCE_ALIAS = 49;
    public static readonly SUBJECT_VARIABLE_DERIVED_EVENT_NAME = 50;
    public static readonly CONCEPT_GROUP = 51;
    public static readonly CARE_SITE_ALIAS = 52;
    public static readonly CONDITION_OCCURRENCE_ALIAS = 53;
    public static readonly DRUG_EXPOSURE_ALIAS = 54;
    public static readonly MEASUREMENT_ALIAS = 55;
    public static readonly OBSERVATION_ALIAS = 56;
    public static readonly PERSON_ALIAS = 57;
    public static readonly PROCEDURE_OCCURRENCE_ALIAS = 58;
    public static readonly PROVIDER_ALIAS = 59;
    public static readonly VISIT_OCCURRENCE_ALIAS = 60;
    public static readonly MERGED_EVENT_NAME = 61;
    public static readonly SEQUENCE_EVENT_NAME = 62;
    public static readonly INSTANCE_EVENT_NAME = 63;
    public static readonly SUBJECTS_VARIABLE_NAME = 64;
    public static readonly NAMESPACE_QUALIFIER = 65;
    public static readonly SUBJECTS_VARIABLE = 66;
    public static readonly CONCEPT = 67;
    public static readonly QUALIFIED_MERGED_EVENT = 68;
    public static readonly QUALIFIED_SEQUENCE_EVENT = 69;
    public static readonly QUALIFIED_INSTANCE_EVENT = 70;
    public static readonly SUBJECT_VARIABLE_MERGED_EVENT = 71;
    public static readonly SUBJECT_VARIABLE_SEQUENCE_EVENT = 72;
    public static readonly SUBJECT_VARIABLE_INSTANCE_EVENT = 73;
    public static readonly MERGED_EVENT = 74;
    public static readonly SEQUENCE_EVENT = 75;
    public static readonly INSTANCE_EVENT = 76;
    public static readonly DERIVED_EVENT = 77;
    public static readonly LINE_COMMENT = 78;
    public static readonly INT = 79;
    public static readonly M = 80;
    public static readonly D = 81;
    public static readonly Y = 82;
    public static readonly DATE = 83;
    public static readonly OPEN_PAREN = 84;
    public static readonly CLOSE_PAREN = 85;
    public static readonly SEMICOLON = 86;
    public static readonly COMMA = 87;
    public static readonly EQ = 88;
    public static readonly MULTIPLY = 89;
    public static readonly DIVIDE = 90;
    public static readonly ADD = 91;
    public static readonly SUBTRACT = 92;
    public static readonly CONTAINS = 93;
    public static readonly NEQ = 94;
    public static readonly LTE = 95;
    public static readonly GTE = 96;
    public static readonly LT = 97;
    public static readonly GT = 98;
    public static readonly MAX = 99;
    public static readonly MIN = 100;
    public static readonly AVG = 101;
    public static readonly COUNT = 102;
    public static readonly LEAST = 103;
    public static readonly GREATEST = 104;
    public static readonly IN = 105;
    public static readonly AND = 106;
    public static readonly OR = 107;
    public static readonly NOT = 108;
    public static readonly COMPLEMENT = 109;
    public static readonly UNION = 110;
    public static readonly INTERSECTION = 111;
    public static readonly DIFFERENCE = 112;
    public static readonly INDEX = 113;
    public static readonly TIME_UNIT = 114;
    public static readonly DAYS = 115;
    public static readonly WEEKS = 116;
    public static readonly MONTHS = 117;
    public static readonly YEARS = 118;
    public static readonly MINIMUM_BETWEEN = 119;
    public static readonly MAXIMUM_BETWEEN = 120;
    public static readonly TOTAL_BETWEEN = 121;
    public static readonly FIXED_WINDOW = 122;
    public static readonly ROLLING_WINDOW = 123;
    public static readonly PERIOD = 124;
    public static readonly WS = 125;
    public static readonly CARE_SITE = 126;
    public static readonly CONDITION_OCCURRENCE = 127;
    public static readonly DRUG_EXPOSURE = 128;
    public static readonly MEASUREMENT = 129;
    public static readonly OBSERVATION = 130;
    public static readonly PERSON = 131;
    public static readonly PROCEDURE_OCCURRENCE = 132;
    public static readonly PROVIDER = 133;
    public static readonly VISIT_OCCURRENCE = 134;
    public static readonly QUALIFIED_CARE_SITE = 135;
    public static readonly QUALIFIED_CONDITION_OCCURRENCE = 136;
    public static readonly QUALIFIED_DRUG_EXPOSURE = 137;
    public static readonly QUALIFIED_MEASUREMENT = 138;
    public static readonly QUALIFIED_OBSERVATION = 139;
    public static readonly QUALIFIED_PERSON = 140;
    public static readonly QUALIFIED_PROCEDURE_OCCURRENCE = 141;
    public static readonly QUALIFIED_PROVIDER = 142;
    public static readonly QUALIFIED_VISIT_OCCURRENCE = 143;
    public static readonly SUBJECT_VARIABLE_CARE_SITE = 144;
    public static readonly SUBJECT_VARIABLE_CONDITION_OCCURRENCE = 145;
    public static readonly SUBJECT_VARIABLE_DRUG_EXPOSURE = 146;
    public static readonly SUBJECT_VARIABLE_MEASUREMENT = 147;
    public static readonly SUBJECT_VARIABLE_OBSERVATION = 148;
    public static readonly SUBJECT_VARIABLE_PERSON = 149;
    public static readonly SUBJECT_VARIABLE_PROCEDURE_OCCURRENCE = 150;
    public static readonly SUBJECT_VARIABLE_PROVIDER = 151;
    public static readonly SUBJECT_VARIABLE_VISIT_OCCURRENCE = 152;
    public static readonly CONDITION_OCCURRENCE_DATE_ATTRIBUTE = 153;
    public static readonly DRUG_EXPOSURE_DATE_ATTRIBUTE = 154;
    public static readonly MEASUREMENT_DATE_ATTRIBUTE = 155;
    public static readonly OBSERVATION_DATE_ATTRIBUTE = 156;
    public static readonly PROCEDURE_OCCURRENCE_DATE_ATTRIBUTE = 157;
    public static readonly VISIT_OCCURRENCE_DATE_ATTRIBUTE = 158;
    public static readonly PERSON_DATE_TIME_ATTRIBUTE = 159;
    public static readonly DRUG_EXPOSURE_INT_ATTRIBUTE = 160;
    public static readonly MEASUREMENT_FLOAT_ATTRIBUTE = 161;
    public static readonly PERSON_INT_ATTRIBUTE = 162;
    public static readonly COMMON_NUMERIC_FLOAT_ATTRIBUTE = 163;
    public static readonly QUANTITY = 164;
    public static readonly CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE = 165;
    public static readonly DRUG_EXPOSURE_CONCEPT_ATTRIBUTE = 166;
    public static readonly MEASUREMENT_CONCEPT_ATTRIBUTE = 167;
    public static readonly OBSERVATION_CONCEPT_ATTRIBUTE = 168;
    public static readonly PERSON_CONCEPT_ATTRIBUTE = 169;
    public static readonly PROCEDURE_OCCURRENCE_CONCEPT_ATTRIBUTE = 170;
    public static readonly PROVIDER_CONCEPT_ATTRIBUTE = 171;
    public static readonly VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE = 172;
    public static readonly COMMON_CONCEPT_ATTRIBUTE = 173;
    public static readonly CARE_SITE_CONCEPT_ATTRIBUTE = 174;
    public static readonly COMMON_STRING_ATTRIBUTE = 175;
    public static readonly GENDER_SOURCE_VALUE = 176;
    public static readonly CARE_SITE_STRING_ATTRIBUTE = 177;
    public static readonly CONDITION_OCCURRENCE_STRING_ATTRIBUTE = 178;
    public static readonly DRUG_EXPOSURE_STRING_ATTRIBUTE = 179;
    public static readonly MEASUREMENT_STRING_ATTRIBUTE = 180;
    public static readonly OBSERVATION_STRING_ATTRIBUTE = 181;
    public static readonly PERSON_STRING_ATTRIBUTE = 182;
    public static readonly PROCEDURE_OCCURRENCE_STRING_ATTRIBUTE = 183;
    public static readonly PROVIDER_STRING_ATTRIBUTE = 184;
    public static readonly VISIT_OCCURRENCE_STRING_ATTRIBUTE = 185;
    public static readonly RULE_study_period_criteria = 0;
    public static readonly RULE_baseline_period_criteria = 1;
    public static readonly RULE_follow_up_period_criteria = 2;
    public static readonly RULE_overall_study_period = 3;
    public static readonly RULE_overall_study_period_error = 4;
    public static readonly RULE_overall_study_period_error2 = 5;
    public static readonly RULE_overall_study_period_error3 = 6;
    public static readonly RULE_baseline_period = 7;
    public static readonly RULE_baseline_period_error = 8;
    public static readonly RULE_follow_up_period = 9;
    public static readonly RULE_follow_up_period_error = 10;
    public static readonly RULE_subjects_variable = 11;
    public static readonly RULE_event_count_criteria = 12;
    public static readonly RULE_count_criteria = 13;
    public static readonly RULE_event_count_criteria_error = 14;
    public static readonly RULE_demographic_event_criteria = 15;
    public static readonly RULE_demographic_event_filters = 16;
    public static readonly RULE_demographic_event_filter = 17;
    public static readonly RULE_demographic_concept_filter = 18;
    public static readonly RULE_demographic_concept_group_filter = 19;
    public static readonly RULE_demographic_concept_id_filter = 20;
    public static readonly RULE_demographic_numeric_filter = 21;
    public static readonly RULE_demographic_int_filter = 22;
    public static readonly RULE_demographic_error_filter = 23;
    public static readonly RULE_subject_variable_event_name = 24;
    public static readonly RULE_index_date = 25;
    public static readonly RULE_index_date_definition = 26;
    public static readonly RULE_calendar_date = 27;
    public static readonly RULE_index_event_date = 28;
    public static readonly RULE_index_date_bounds = 29;
    public static readonly RULE_upper_date_bounds = 30;
    public static readonly RULE_lower_date_bounds = 31;
    public static readonly RULE_calendarError = 32;
    public static readonly RULE_index_event_date_error = 33;
    public static readonly RULE_lower_date_bounds_error = 34;
    public static readonly RULE_upper_date_bounds_error = 35;
    public static readonly RULE_derived_event = 36;
    public static readonly RULE_merged_event = 37;
    public static readonly RULE_merged_event_criteria = 38;
    public static readonly RULE_merged_event_criterion = 39;
    public static readonly RULE_merged_event_filter_criterion = 40;
    public static readonly RULE_merged_event_event = 41;
    public static readonly RULE_merged_event_filter = 42;
    public static readonly RULE_merged_event_uniqueness_filter = 43;
    public static readonly RULE_merged_event_uniqueness_filter_criteria = 44;
    public static readonly RULE_merged_event_filter_error = 45;
    public static readonly RULE_sequence_event = 46;
    public static readonly RULE_sequence_event_criteria = 47;
    public static readonly RULE_sequence_event_criterion = 48;
    public static readonly RULE_sequence_event_constraint = 49;
    public static readonly RULE_temporal_constraint = 50;
    public static readonly RULE_sequence_temporal_filter = 51;
    public static readonly RULE_sequence_event_event = 52;
    public static readonly RULE_selected_sequence_event = 53;
    public static readonly RULE_unselected_sequence_event = 54;
    public static readonly RULE_instance_event = 55;
    public static readonly RULE_instance_event_criteria = 56;
    public static readonly RULE_instance_event_criterion = 57;
    public static readonly RULE_instance_event_event = 58;
    public static readonly RULE_instance_event_position = 59;
    public static readonly RULE_aggregation_qualified = 60;
    public static readonly RULE_specific_instance = 61;
    public static readonly RULE_instance_event_position_error = 62;
    public static readonly RULE_qualified_simple_event = 63;
    public static readonly RULE_qualified_derived_event = 64;
    public static readonly RULE_sequence_event_constraint_error = 65;
    public static readonly RULE_derived_event_error = 66;
    public static readonly RULE_derived_uniqueness_filter = 67;
    public static readonly RULE_derived_uniqueness_filter_window = 68;
    public static readonly RULE_derived_fixed_window_uniqueness_filter = 69;
    public static readonly RULE_derived_rolling_window_uniqueness_filter = 70;
    public static readonly RULE_derived_event_int = 71;
    public static readonly RULE_simple_event = 72;
    public static readonly RULE_condition_occurrence_event = 73;
    public static readonly RULE_drug_exposure_event = 74;
    public static readonly RULE_measurement_event = 75;
    public static readonly RULE_observation_event = 76;
    public static readonly RULE_procedure_occurrence_event = 77;
    public static readonly RULE_visit_occurrence_event = 78;
    public static readonly RULE_condition_occurrence_event_definition = 79;
    public static readonly RULE_drug_exposure_event_definition = 80;
    public static readonly RULE_measurement_event_definition = 81;
    public static readonly RULE_observation_event_definition = 82;
    public static readonly RULE_procedure_occurrence_event_definition = 83;
    public static readonly RULE_visit_occurrence_event_definition = 84;
    public static readonly RULE_condition_occurrence_event_criteria = 85;
    public static readonly RULE_condition_occurrence_event_filter = 86;
    public static readonly RULE_condition_occurrence_concept_filters = 87;
    public static readonly RULE_condition_occurrence_concept_group_filter = 88;
    public static readonly RULE_condition_occurrence_concept_filter = 89;
    public static readonly RULE_condition_occurrence_uniqueness_filters = 90;
    public static readonly RULE_condition_occurrence_uniqueness_filter = 91;
    public static readonly RULE_condition_occurrence_related_entity_filters = 92;
    public static readonly RULE_condition_occurrence_related_entity_filter = 93;
    public static readonly RULE_condition_occurrence_sub_filter = 94;
    public static readonly RULE_condition_occurrence_error_sub_filter = 95;
    public static readonly RULE_condition_occurrence_error_filter = 96;
    public static readonly RULE_drug_exposure_event_criteria = 97;
    public static readonly RULE_drug_exposure_event_filter = 98;
    public static readonly RULE_drug_exposure_concept_filters = 99;
    public static readonly RULE_drug_exposure_concept_group_filter = 100;
    public static readonly RULE_drug_exposure_concept_filter = 101;
    public static readonly RULE_drug_exposure_numeric_filters = 102;
    public static readonly RULE_drug_exposure_float_filter = 103;
    public static readonly RULE_drug_exposure_int_filter = 104;
    public static readonly RULE_drug_exposure_uniqueness_filters = 105;
    public static readonly RULE_drug_exposure_uniqueness_filter = 106;
    public static readonly RULE_drug_exposure_related_entity_filters = 107;
    public static readonly RULE_drug_exposure_related_entity_filter = 108;
    public static readonly RULE_drug_exposure_error_filter = 109;
    public static readonly RULE_measurement_event_criteria = 110;
    public static readonly RULE_measurement_event_filter = 111;
    public static readonly RULE_measurement_concept_filters = 112;
    public static readonly RULE_measurement_concept_group_filter = 113;
    public static readonly RULE_measurement_concept_filter = 114;
    public static readonly RULE_measurement_numeric_filters = 115;
    public static readonly RULE_measurement_float_filter = 116;
    public static readonly RULE_measurement_uniqueness_filters = 117;
    public static readonly RULE_measurement_uniqueness_filter = 118;
    public static readonly RULE_measurement_related_entity_filters = 119;
    public static readonly RULE_measurement_related_entity_filter = 120;
    public static readonly RULE_measurement_error_filter = 121;
    public static readonly RULE_observation_event_criteria = 122;
    public static readonly RULE_observation_event_filter = 123;
    public static readonly RULE_observation_concept_filters = 124;
    public static readonly RULE_observation_concept_group_filter = 125;
    public static readonly RULE_observation_concept_filter = 126;
    public static readonly RULE_observation_numeric_filters = 127;
    public static readonly RULE_observation_float_filter = 128;
    public static readonly RULE_observation_uniqueness_filters = 129;
    public static readonly RULE_observation_uniqueness_filter = 130;
    public static readonly RULE_observation_related_entity_filters = 131;
    public static readonly RULE_observation_related_entity_filter = 132;
    public static readonly RULE_observation_error_filter = 133;
    public static readonly RULE_procedure_occurrence_event_criteria = 134;
    public static readonly RULE_procedure_occurrence_event_filter = 135;
    public static readonly RULE_procedure_occurrence_concept_filters = 136;
    public static readonly RULE_procedure_occurrence_concept_group_filter = 137;
    public static readonly RULE_procedure_occurrence_concept_filter = 138;
    public static readonly RULE_procedure_occurrence_numeric_filters = 139;
    public static readonly RULE_procedure_occurrence_int_filter = 140;
    public static readonly RULE_procedure_occurrence_uniqueness_filters = 141;
    public static readonly RULE_procedure_occurrence_uniqueness_filter = 142;
    public static readonly RULE_procedure_occurrence_related_entity_filters = 143;
    public static readonly RULE_procedure_occurrence_related_entity_filter = 144;
    public static readonly RULE_procedure_occurrence_error_filter = 145;
    public static readonly RULE_provider_concept_filters = 146;
    public static readonly RULE_provider_concept_group_filter = 147;
    public static readonly RULE_provider_concept_filter = 148;
    public static readonly RULE_provider_sub_filter = 149;
    public static readonly RULE_provider_error_sub_filter = 150;
    public static readonly RULE_visit_occurrence_event_criteria = 151;
    public static readonly RULE_visit_occurrence_event_filter = 152;
    public static readonly RULE_visit_occurrence_concept_filters = 153;
    public static readonly RULE_visit_occurrence_concept_group_filter = 154;
    public static readonly RULE_visit_occurrence_concept_filter = 155;
    public static readonly RULE_visit_occurrence_uniqueness_filters = 156;
    public static readonly RULE_visit_occurrence_uniqueness_filter = 157;
    public static readonly RULE_visit_occurrence_related_entity_filters = 158;
    public static readonly RULE_visit_occurrence_related_entity_filter = 159;
    public static readonly RULE_visit_occurrence_sub_filter = 160;
    public static readonly RULE_visit_occurrence_error_sub_filter = 161;
    public static readonly RULE_visit_occurrence_error_filter = 162;
    public static readonly RULE_comparison_op = 163;
    public static readonly RULE_simple_uniqueness_filter = 164;
    public static readonly RULE_simple_uniqueness_filter_window = 165;
    public static readonly RULE_fixed_window_uniqueness_filter = 166;
    public static readonly RULE_rolling_window_uniqueness_filter = 167;
    public static readonly RULE_simple_event_float = 168;
    public static readonly RULE_simple_event_int = 169;
    public static readonly RULE_concept_group_selection = 170;

    public static readonly literalNames = [
        null, "'STUDY_PERIOD'", "'BASELINE'", "'FOLLOW_UP'", "'INDEX_DATE'", 
        "'EVENT'", "'CALENDAR_DATE'", "'UPPER_DATE_BOUND'", "'LOWER_DATE_BOUND'", 
        "'derived_event_date'", "'CONSTRAINTS'", "'ANY_ORDER'", "'IS_EVENT_DATE'", 
        null, "'TC'", "'TEMPORAL_CONSTRAINT'", "'POSITION'", null, "'CONCEPT_FILTER'", 
        "'CF'", null, "'NUMERIC_FILTER'", "'NF'", null, "'STRING_FILTER'", 
        "'SF'", null, "'UNIQUENESS_FILTER'", "'UF'", null, "'RELATED_ENTITY_FILTER'", 
        "'RF'", null, null, null, null, null, null, null, null, null, null, 
        null, null, null, null, null, null, null, null, null, null, null, 
        null, null, null, null, null, null, null, null, null, null, null, 
        null, "'::'", "'SUBJECTS_VARIABLE'", null, "'QUALIFIED_MERGED_EVENT'", 
        "'QUALIFIED_SEQUENCE_EVENT'", "'QUALIFIED_INSTANCE_EVENT'", "'SUBJECT_VARIABLE_MERGED_EVENT'", 
        "'SUBJECT_VARIABLE_SEQUENCE_EVENT'", "'SUBJECT_VARIABLE_INSTANCE_EVENT'", 
        "'MERGED_EVENT'", "'SEQUENCE_EVENT'", "'INSTANCE_EVENT'", "'DERIVED_EVENT'", 
        null, null, null, null, null, null, "'('", "')'", "';'", "','", 
        "'='", "'*'", "'/'", "'+'", "'-'", "'CONTAINS'", "'!='", "'<='", 
        "'>='", "'<'", "'>'", "'MAX'", "'MIN'", "'AVG'", "'COUNT'", "'LEAST'", 
        "'GREATEST'", "'IN'", "'AND'", "'OR'", "'NOT'", "'COMPLEMENT'", 
        "'UNION'", "'INTERSECTION'", "'DIFFERENCE'", "'INDEX'", null, "'DAYS'", 
        "'WEEKS'", "'MONTHS'", "'YEARS'", "'MINIMUM_BETWEEN'", "'MAXIMUM_BETWEEN'", 
        "'TOTAL_BETWEEN'", "'FIXED_WINDOW'", "'ROLLING_WINDOW'", "'.'", 
        null, "'CARE_SITE'", "'CONDITION_OCCURRENCE'", "'DRUG_EXPOSURE'", 
        "'MEASUREMENT'", "'OBSERVATION'", "'PERSON'", "'PROCEDURE_OCCURRENCE'", 
        "'PROVIDER'", "'VISIT_OCCURRENCE'", "'QUALIFIED_CARE_SITE'", "'QUALIFIED_CONDITION_OCCURRENCE'", 
        "'QUALIFIED_DRUG_EXPOSURE'", "'QUALIFIED_MEASUREMENT'", "'QUALIFIED_OBSERVATION'", 
        "'QUALIFIED_PERSON'", "'QUALIFIED_PROCEDURE_OCCURRENCE'", "'QUALIFIED_PROVIDER'", 
        "'QUALIFIED_VISIT_OCCURRENCE'", "'SUBJECT_VARIABLE_CARE_SITE'", 
        "'SUBJECT_VARIABLE_CONDITION_OCCURRENCE'", "'SUBJECT_VARIABLE_DRUG_EXPOSURE'", 
        "'SUBJECT_VARIABLE_MEASUREMENT'", "'SUBJECT_VARIABLE_OBSERVATION'", 
        "'SUBJECT_VARIABLE_PERSON'", "'SUBJECT_VARIABLE_PROCEDURE_OCCURRENCE'", 
        "'SUBJECT_VARIABLE_PROVIDER'", "'SUBJECT_VARIABLE_VISIT_OCCURRENCE'", 
        null, null, "'measurement_date'", "'observation_date'", "'procedure_date'", 
        null, "'birth_datetime'", null, null, null, "'value_as_number'", 
        "'quantity'", null, null, null, null, null, null, "'specialty_concept'", 
        null, null, "'place_of_service_concept'", "'value_as_string'", "'gender_source_value'"
    ];

    public static readonly symbolicNames = [
        null, "STUDY_PERIOD", "BASELINE", "FOLLOW_UP", "INDEX_DATE", "EVENT", 
        "CALENDAR_DATE", "UPPER_DATE_BOUND", "LOWER_DATE_BOUND", "DERIVED_EVENT_DATE", 
        "CONSTRAINTS", "ANY_ORDER", "IS_EVENT_DATE", "TC", "TEMPORAL_CONSTRAINT_ABBR", 
        "TEMPORAL_CONSTRAINT", "POSITION", "CF", "CONCEPT_FILTER", "CONCEPT_FILTER_ABBR", 
        "NF", "NUMERIC_FILTER", "NUMERIC_FILTER_ABBR", "SF", "STRING_FILTER", 
        "STRING_FILTER_ABBR", "UF", "UNIQUENESS_FILTER", "UNIQUENESS_FILTER_ABBR", 
        "RF", "RELATED_ENTITY_FILTER", "RELATED_ENTITY_FILTER_ABBR", "QUALIFIED_CARE_SITE_ALIAS", 
        "QUALIFIED_CONDITION_OCCURRENCE_ALIAS", "QUALIFIED_DRUG_EXPOSURE_ALIAS", 
        "QUALIFIED_MEASUREMENT_ALIAS", "QUALIFIED_OBSERVATION_ALIAS", "QUALIFIED_PERSON_ALIAS", 
        "QUALIFIED_PROCEDURE_OCCURRENCE_ALIAS", "QUALIFIED_PROVIDER_ALIAS", 
        "QUALIFIED_VISIT_OCCURRENCE_ALIAS", "QUALIFIED_DERIVED_EVENT_NAME", 
        "SUBJECT_VARIABLE_CARE_SITE_ALIAS", "SUBJECT_VARIABLE_CONDITION_OCCURRENCE_ALIAS", 
        "SUBJECT_VARIABLE_DRUG_EXPOSURE_ALIAS", "SUBJECT_VARIABLE_MEASUREMENT_ALIAS", 
        "SUBJECT_VARIABLE_OBSERVATION_ALIAS", "SUBJECT_VARIABLE_PROCEDURE_OCCURRENCE_ALIAS", 
        "SUBJECT_VARIABLE_PROVIDER_ALIAS", "SUBJECT_VARIABLE_VISIT_OCCURRENCE_ALIAS", 
        "SUBJECT_VARIABLE_DERIVED_EVENT_NAME", "CONCEPT_GROUP", "CARE_SITE_ALIAS", 
        "CONDITION_OCCURRENCE_ALIAS", "DRUG_EXPOSURE_ALIAS", "MEASUREMENT_ALIAS", 
        "OBSERVATION_ALIAS", "PERSON_ALIAS", "PROCEDURE_OCCURRENCE_ALIAS", 
        "PROVIDER_ALIAS", "VISIT_OCCURRENCE_ALIAS", "MERGED_EVENT_NAME", 
        "SEQUENCE_EVENT_NAME", "INSTANCE_EVENT_NAME", "SUBJECTS_VARIABLE_NAME", 
        "NAMESPACE_QUALIFIER", "SUBJECTS_VARIABLE", "CONCEPT", "QUALIFIED_MERGED_EVENT", 
        "QUALIFIED_SEQUENCE_EVENT", "QUALIFIED_INSTANCE_EVENT", "SUBJECT_VARIABLE_MERGED_EVENT", 
        "SUBJECT_VARIABLE_SEQUENCE_EVENT", "SUBJECT_VARIABLE_INSTANCE_EVENT", 
        "MERGED_EVENT", "SEQUENCE_EVENT", "INSTANCE_EVENT", "DERIVED_EVENT", 
        "LINE_COMMENT", "INT", "M", "D", "Y", "DATE", "OPEN_PAREN", "CLOSE_PAREN", 
        "SEMICOLON", "COMMA", "EQ", "MULTIPLY", "DIVIDE", "ADD", "SUBTRACT", 
        "CONTAINS", "NEQ", "LTE", "GTE", "LT", "GT", "MAX", "MIN", "AVG", 
        "COUNT", "LEAST", "GREATEST", "IN", "AND", "OR", "NOT", "COMPLEMENT", 
        "UNION", "INTERSECTION", "DIFFERENCE", "INDEX", "TIME_UNIT", "DAYS", 
        "WEEKS", "MONTHS", "YEARS", "MINIMUM_BETWEEN", "MAXIMUM_BETWEEN", 
        "TOTAL_BETWEEN", "FIXED_WINDOW", "ROLLING_WINDOW", "PERIOD", "WS", 
        "CARE_SITE", "CONDITION_OCCURRENCE", "DRUG_EXPOSURE", "MEASUREMENT", 
        "OBSERVATION", "PERSON", "PROCEDURE_OCCURRENCE", "PROVIDER", "VISIT_OCCURRENCE", 
        "QUALIFIED_CARE_SITE", "QUALIFIED_CONDITION_OCCURRENCE", "QUALIFIED_DRUG_EXPOSURE", 
        "QUALIFIED_MEASUREMENT", "QUALIFIED_OBSERVATION", "QUALIFIED_PERSON", 
        "QUALIFIED_PROCEDURE_OCCURRENCE", "QUALIFIED_PROVIDER", "QUALIFIED_VISIT_OCCURRENCE", 
        "SUBJECT_VARIABLE_CARE_SITE", "SUBJECT_VARIABLE_CONDITION_OCCURRENCE", 
        "SUBJECT_VARIABLE_DRUG_EXPOSURE", "SUBJECT_VARIABLE_MEASUREMENT", 
        "SUBJECT_VARIABLE_OBSERVATION", "SUBJECT_VARIABLE_PERSON", "SUBJECT_VARIABLE_PROCEDURE_OCCURRENCE", 
        "SUBJECT_VARIABLE_PROVIDER", "SUBJECT_VARIABLE_VISIT_OCCURRENCE", 
        "CONDITION_OCCURRENCE_DATE_ATTRIBUTE", "DRUG_EXPOSURE_DATE_ATTRIBUTE", 
        "MEASUREMENT_DATE_ATTRIBUTE", "OBSERVATION_DATE_ATTRIBUTE", "PROCEDURE_OCCURRENCE_DATE_ATTRIBUTE", 
        "VISIT_OCCURRENCE_DATE_ATTRIBUTE", "PERSON_DATE_TIME_ATTRIBUTE", 
        "DRUG_EXPOSURE_INT_ATTRIBUTE", "MEASUREMENT_FLOAT_ATTRIBUTE", "PERSON_INT_ATTRIBUTE", 
        "COMMON_NUMERIC_FLOAT_ATTRIBUTE", "QUANTITY", "CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE", 
        "DRUG_EXPOSURE_CONCEPT_ATTRIBUTE", "MEASUREMENT_CONCEPT_ATTRIBUTE", 
        "OBSERVATION_CONCEPT_ATTRIBUTE", "PERSON_CONCEPT_ATTRIBUTE", "PROCEDURE_OCCURRENCE_CONCEPT_ATTRIBUTE", 
        "PROVIDER_CONCEPT_ATTRIBUTE", "VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE", 
        "COMMON_CONCEPT_ATTRIBUTE", "CARE_SITE_CONCEPT_ATTRIBUTE", "COMMON_STRING_ATTRIBUTE", 
        "GENDER_SOURCE_VALUE", "CARE_SITE_STRING_ATTRIBUTE", "CONDITION_OCCURRENCE_STRING_ATTRIBUTE", 
        "DRUG_EXPOSURE_STRING_ATTRIBUTE", "MEASUREMENT_STRING_ATTRIBUTE", 
        "OBSERVATION_STRING_ATTRIBUTE", "PERSON_STRING_ATTRIBUTE", "PROCEDURE_OCCURRENCE_STRING_ATTRIBUTE", 
        "PROVIDER_STRING_ATTRIBUTE", "VISIT_OCCURRENCE_STRING_ATTRIBUTE"
    ];
    public static readonly ruleNames = [
        "study_period_criteria", "baseline_period_criteria", "follow_up_period_criteria", 
        "overall_study_period", "overall_study_period_error", "overall_study_period_error2", 
        "overall_study_period_error3", "baseline_period", "baseline_period_error", 
        "follow_up_period", "follow_up_period_error", "subjects_variable", 
        "event_count_criteria", "count_criteria", "event_count_criteria_error", 
        "demographic_event_criteria", "demographic_event_filters", "demographic_event_filter", 
        "demographic_concept_filter", "demographic_concept_group_filter", 
        "demographic_concept_id_filter", "demographic_numeric_filter", "demographic_int_filter", 
        "demographic_error_filter", "subject_variable_event_name", "index_date", 
        "index_date_definition", "calendar_date", "index_event_date", "index_date_bounds", 
        "upper_date_bounds", "lower_date_bounds", "calendarError", "index_event_date_error", 
        "lower_date_bounds_error", "upper_date_bounds_error", "derived_event", 
        "merged_event", "merged_event_criteria", "merged_event_criterion", 
        "merged_event_filter_criterion", "merged_event_event", "merged_event_filter", 
        "merged_event_uniqueness_filter", "merged_event_uniqueness_filter_criteria", 
        "merged_event_filter_error", "sequence_event", "sequence_event_criteria", 
        "sequence_event_criterion", "sequence_event_constraint", "temporal_constraint", 
        "sequence_temporal_filter", "sequence_event_event", "selected_sequence_event", 
        "unselected_sequence_event", "instance_event", "instance_event_criteria", 
        "instance_event_criterion", "instance_event_event", "instance_event_position", 
        "aggregation_qualified", "specific_instance", "instance_event_position_error", 
        "qualified_simple_event", "qualified_derived_event", "sequence_event_constraint_error", 
        "derived_event_error", "derived_uniqueness_filter", "derived_uniqueness_filter_window", 
        "derived_fixed_window_uniqueness_filter", "derived_rolling_window_uniqueness_filter", 
        "derived_event_int", "simple_event", "condition_occurrence_event", 
        "drug_exposure_event", "measurement_event", "observation_event", 
        "procedure_occurrence_event", "visit_occurrence_event", "condition_occurrence_event_definition", 
        "drug_exposure_event_definition", "measurement_event_definition", 
        "observation_event_definition", "procedure_occurrence_event_definition", 
        "visit_occurrence_event_definition", "condition_occurrence_event_criteria", 
        "condition_occurrence_event_filter", "condition_occurrence_concept_filters", 
        "condition_occurrence_concept_group_filter", "condition_occurrence_concept_filter", 
        "condition_occurrence_uniqueness_filters", "condition_occurrence_uniqueness_filter", 
        "condition_occurrence_related_entity_filters", "condition_occurrence_related_entity_filter", 
        "condition_occurrence_sub_filter", "condition_occurrence_error_sub_filter", 
        "condition_occurrence_error_filter", "drug_exposure_event_criteria", 
        "drug_exposure_event_filter", "drug_exposure_concept_filters", "drug_exposure_concept_group_filter", 
        "drug_exposure_concept_filter", "drug_exposure_numeric_filters", 
        "drug_exposure_float_filter", "drug_exposure_int_filter", "drug_exposure_uniqueness_filters", 
        "drug_exposure_uniqueness_filter", "drug_exposure_related_entity_filters", 
        "drug_exposure_related_entity_filter", "drug_exposure_error_filter", 
        "measurement_event_criteria", "measurement_event_filter", "measurement_concept_filters", 
        "measurement_concept_group_filter", "measurement_concept_filter", 
        "measurement_numeric_filters", "measurement_float_filter", "measurement_uniqueness_filters", 
        "measurement_uniqueness_filter", "measurement_related_entity_filters", 
        "measurement_related_entity_filter", "measurement_error_filter", 
        "observation_event_criteria", "observation_event_filter", "observation_concept_filters", 
        "observation_concept_group_filter", "observation_concept_filter", 
        "observation_numeric_filters", "observation_float_filter", "observation_uniqueness_filters", 
        "observation_uniqueness_filter", "observation_related_entity_filters", 
        "observation_related_entity_filter", "observation_error_filter", 
        "procedure_occurrence_event_criteria", "procedure_occurrence_event_filter", 
        "procedure_occurrence_concept_filters", "procedure_occurrence_concept_group_filter", 
        "procedure_occurrence_concept_filter", "procedure_occurrence_numeric_filters", 
        "procedure_occurrence_int_filter", "procedure_occurrence_uniqueness_filters", 
        "procedure_occurrence_uniqueness_filter", "procedure_occurrence_related_entity_filters", 
        "procedure_occurrence_related_entity_filter", "procedure_occurrence_error_filter", 
        "provider_concept_filters", "provider_concept_group_filter", "provider_concept_filter", 
        "provider_sub_filter", "provider_error_sub_filter", "visit_occurrence_event_criteria", 
        "visit_occurrence_event_filter", "visit_occurrence_concept_filters", 
        "visit_occurrence_concept_group_filter", "visit_occurrence_concept_filter", 
        "visit_occurrence_uniqueness_filters", "visit_occurrence_uniqueness_filter", 
        "visit_occurrence_related_entity_filters", "visit_occurrence_related_entity_filter", 
        "visit_occurrence_sub_filter", "visit_occurrence_error_sub_filter", 
        "visit_occurrence_error_filter", "comparison_op", "simple_uniqueness_filter", 
        "simple_uniqueness_filter_window", "fixed_window_uniqueness_filter", 
        "rolling_window_uniqueness_filter", "simple_event_float", "simple_event_int", 
        "concept_group_selection",
    ];

    public get grammarFileName(): string { return "StudyPeriod.g4"; }
    public get literalNames(): (string | null)[] { return StudyPeriod.literalNames; }
    public get symbolicNames(): (string | null)[] { return StudyPeriod.symbolicNames; }
    public get ruleNames(): string[] { return StudyPeriod.ruleNames; }
    public get serializedATN(): number[] { return StudyPeriod._serializedATN; }

    protected createFailedPredicateException(predicate?: string, message?: string): antlr.FailedPredicateException {
        return new antlr.FailedPredicateException(this, predicate, message);
    }

    public constructor(input: antlr.TokenStream) {
        super(input);
        this.interpreter = new antlr.ParserATNSimulator(this, StudyPeriod._ATN, StudyPeriod.decisionsToDFA, new antlr.PredictionContextCache());
    }
    public study_period_criteria(): Study_period_criteriaContext {
        let localContext = new Study_period_criteriaContext(this.context, this.state);
        this.enterRule(localContext, 0, StudyPeriod.RULE_study_period_criteria);
        try {
            this.state = 346;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 0, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 342;
                this.overall_study_period();
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 343;
                this.overall_study_period_error();
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 344;
                this.overall_study_period_error2();
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 345;
                this.overall_study_period_error3();
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public baseline_period_criteria(): Baseline_period_criteriaContext {
        let localContext = new Baseline_period_criteriaContext(this.context, this.state);
        this.enterRule(localContext, 2, StudyPeriod.RULE_baseline_period_criteria);
        try {
            this.state = 350;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 1, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 348;
                this.baseline_period();
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 349;
                this.baseline_period_error();
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public follow_up_period_criteria(): Follow_up_period_criteriaContext {
        let localContext = new Follow_up_period_criteriaContext(this.context, this.state);
        this.enterRule(localContext, 4, StudyPeriod.RULE_follow_up_period_criteria);
        try {
            this.state = 354;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 2, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 352;
                this.follow_up_period();
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 353;
                this.follow_up_period_error();
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public overall_study_period(): Overall_study_periodContext {
        let localContext = new Overall_study_periodContext(this.context, this.state);
        this.enterRule(localContext, 6, StudyPeriod.RULE_overall_study_period);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 356;
            this.match(StudyPeriod.STUDY_PERIOD);
            this.state = 357;
            this.match(StudyPeriod.OPEN_PAREN);
            this.state = 358;
            this.match(StudyPeriod.DATE);
            this.state = 359;
            this.match(StudyPeriod.COMMA);
            this.state = 360;
            this.match(StudyPeriod.DATE);
            this.state = 361;
            this.match(StudyPeriod.CLOSE_PAREN);
            this.state = 362;
            this.match(StudyPeriod.SEMICOLON);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public overall_study_period_error(): Overall_study_period_errorContext {
        let localContext = new Overall_study_period_errorContext(this.context, this.state);
        this.enterRule(localContext, 8, StudyPeriod.RULE_overall_study_period_error);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 364;
            this.match(StudyPeriod.STUDY_PERIOD);
            this.state = 365;
            this.match(StudyPeriod.OPEN_PAREN);
            this.state = 366;
            this.match(StudyPeriod.CLOSE_PAREN);
            this.state = 367;
            this.match(StudyPeriod.SEMICOLON);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public overall_study_period_error2(): Overall_study_period_error2Context {
        let localContext = new Overall_study_period_error2Context(this.context, this.state);
        this.enterRule(localContext, 10, StudyPeriod.RULE_overall_study_period_error2);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 369;
            this.match(StudyPeriod.STUDY_PERIOD);
            this.state = 370;
            this.match(StudyPeriod.OPEN_PAREN);
            this.state = 371;
            this.match(StudyPeriod.DATE);
            this.state = 372;
            this.match(StudyPeriod.CLOSE_PAREN);
            this.state = 373;
            this.match(StudyPeriod.SEMICOLON);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public overall_study_period_error3(): Overall_study_period_error3Context {
        let localContext = new Overall_study_period_error3Context(this.context, this.state);
        this.enterRule(localContext, 12, StudyPeriod.RULE_overall_study_period_error3);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 375;
            this.match(StudyPeriod.STUDY_PERIOD);
            this.state = 376;
            this.match(StudyPeriod.OPEN_PAREN);
            this.state = 377;
            this.match(StudyPeriod.DATE);
            this.state = 378;
            this.match(StudyPeriod.COMMA);
            this.state = 379;
            this.match(StudyPeriod.CLOSE_PAREN);
            this.state = 380;
            this.match(StudyPeriod.SEMICOLON);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public baseline_period(): Baseline_periodContext {
        let localContext = new Baseline_periodContext(this.context, this.state);
        this.enterRule(localContext, 14, StudyPeriod.RULE_baseline_period);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 382;
            this.match(StudyPeriod.BASELINE);
            this.state = 383;
            this.match(StudyPeriod.OPEN_PAREN);
            this.state = 384;
            this.match(StudyPeriod.INT);
            this.state = 385;
            this.match(StudyPeriod.CLOSE_PAREN);
            this.state = 386;
            this.match(StudyPeriod.SEMICOLON);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public baseline_period_error(): Baseline_period_errorContext {
        let localContext = new Baseline_period_errorContext(this.context, this.state);
        this.enterRule(localContext, 16, StudyPeriod.RULE_baseline_period_error);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 388;
            this.match(StudyPeriod.BASELINE);
            this.state = 389;
            this.match(StudyPeriod.OPEN_PAREN);
            this.state = 390;
            this.match(StudyPeriod.CLOSE_PAREN);
            this.state = 391;
            this.match(StudyPeriod.SEMICOLON);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public follow_up_period(): Follow_up_periodContext {
        let localContext = new Follow_up_periodContext(this.context, this.state);
        this.enterRule(localContext, 18, StudyPeriod.RULE_follow_up_period);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 393;
            this.match(StudyPeriod.FOLLOW_UP);
            this.state = 394;
            this.match(StudyPeriod.OPEN_PAREN);
            this.state = 395;
            this.match(StudyPeriod.INT);
            this.state = 396;
            this.match(StudyPeriod.CLOSE_PAREN);
            this.state = 397;
            this.match(StudyPeriod.SEMICOLON);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public follow_up_period_error(): Follow_up_period_errorContext {
        let localContext = new Follow_up_period_errorContext(this.context, this.state);
        this.enterRule(localContext, 20, StudyPeriod.RULE_follow_up_period_error);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 399;
            this.match(StudyPeriod.FOLLOW_UP);
            this.state = 400;
            this.match(StudyPeriod.OPEN_PAREN);
            this.state = 401;
            this.match(StudyPeriod.CLOSE_PAREN);
            this.state = 402;
            this.match(StudyPeriod.SEMICOLON);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public subjects_variable(): Subjects_variableContext {
        let localContext = new Subjects_variableContext(this.context, this.state);
        this.enterRule(localContext, 22, StudyPeriod.RULE_subjects_variable);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 404;
            this.match(StudyPeriod.SUBJECTS_VARIABLE_NAME);
            this.state = 405;
            this.match(StudyPeriod.EQ);
            this.state = 409;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 3, this.context) ) {
            case 1:
                {
                this.state = 406;
                this.demographic_event_criteria();
                }
                break;
            case 2:
                {
                this.state = 407;
                this.event_count_criteria();
                }
                break;
            case 3:
                {
                this.state = 408;
                this.event_count_criteria_error();
                }
                break;
            }
            this.state = 411;
            this.match(StudyPeriod.SEMICOLON);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public event_count_criteria(): Event_count_criteriaContext {
        let localContext = new Event_count_criteriaContext(this.context, this.state);
        this.enterRule(localContext, 24, StudyPeriod.RULE_event_count_criteria);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 413;
            localContext._prefix = this.match(StudyPeriod.COUNT);
            this.state = 414;
            this.match(StudyPeriod.OPEN_PAREN);
            this.state = 415;
            localContext._criteria = this.count_criteria();
            this.state = 416;
            this.match(StudyPeriod.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public count_criteria(): Count_criteriaContext {
        let localContext = new Count_criteriaContext(this.context, this.state);
        this.enterRule(localContext, 26, StudyPeriod.RULE_count_criteria);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 418;
            this.subject_variable_event_name();
            this.state = 419;
            this.comparison_op();
            this.state = 420;
            this.match(StudyPeriod.INT);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public event_count_criteria_error(): Event_count_criteria_errorContext {
        let localContext = new Event_count_criteria_errorContext(this.context, this.state);
        this.enterRule(localContext, 28, StudyPeriod.RULE_event_count_criteria_error);
        try {
            this.state = 436;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 4, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 422;
                this.match(StudyPeriod.COUNT);
                this.state = 423;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 424;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 425;
                this.match(StudyPeriod.COUNT);
                this.state = 426;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 427;
                this.subject_variable_event_name();
                this.state = 428;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 430;
                this.match(StudyPeriod.COUNT);
                this.state = 431;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 432;
                this.subject_variable_event_name();
                this.state = 433;
                this.comparison_op();
                this.state = 434;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public demographic_event_criteria(): Demographic_event_criteriaContext {
        let localContext = new Demographic_event_criteriaContext(this.context, this.state);
        this.enterRule(localContext, 30, StudyPeriod.RULE_demographic_event_criteria);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 438;
            localContext._prefix = this.match(StudyPeriod.PERSON);
            this.state = 439;
            this.match(StudyPeriod.OPEN_PAREN);
            this.state = 441;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            if (_la === 17 || _la === 20) {
                {
                this.state = 440;
                this.demographic_event_filters();
                }
            }

            this.state = 443;
            this.match(StudyPeriod.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public demographic_event_filters(): Demographic_event_filtersContext {
        let localContext = new Demographic_event_filtersContext(this.context, this.state);
        this.enterRule(localContext, 32, StudyPeriod.RULE_demographic_event_filters);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 445;
            this.demographic_event_filter();
            this.state = 450;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            while (_la === 87) {
                {
                {
                this.state = 446;
                this.match(StudyPeriod.COMMA);
                this.state = 447;
                this.demographic_event_filter();
                }
                }
                this.state = 452;
                this.errorHandler.sync(this);
                _la = this.tokenStream.LA(1);
            }
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public demographic_event_filter(): Demographic_event_filterContext {
        let localContext = new Demographic_event_filterContext(this.context, this.state);
        this.enterRule(localContext, 34, StudyPeriod.RULE_demographic_event_filter);
        try {
            this.state = 456;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 7, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 453;
                this.demographic_concept_filter();
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 454;
                this.demographic_numeric_filter();
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 455;
                this.demographic_error_filter();
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public demographic_concept_filter(): Demographic_concept_filterContext {
        let localContext = new Demographic_concept_filterContext(this.context, this.state);
        this.enterRule(localContext, 36, StudyPeriod.RULE_demographic_concept_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 458;
            this.match(StudyPeriod.CF);
            this.state = 459;
            this.match(StudyPeriod.OPEN_PAREN);
            this.state = 462;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 8, this.context) ) {
            case 1:
                {
                this.state = 460;
                this.demographic_concept_group_filter();
                }
                break;
            case 2:
                {
                this.state = 461;
                this.demographic_concept_id_filter();
                }
                break;
            }
            this.state = 464;
            this.match(StudyPeriod.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public demographic_concept_group_filter(): Demographic_concept_group_filterContext {
        let localContext = new Demographic_concept_group_filterContext(this.context, this.state);
        this.enterRule(localContext, 38, StudyPeriod.RULE_demographic_concept_group_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 466;
            this.match(StudyPeriod.PERSON_CONCEPT_ATTRIBUTE);
            this.state = 467;
            this.match(StudyPeriod.IN);
            this.state = 468;
            this.concept_group_selection();
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public demographic_concept_id_filter(): Demographic_concept_id_filterContext {
        let localContext = new Demographic_concept_id_filterContext(this.context, this.state);
        this.enterRule(localContext, 40, StudyPeriod.RULE_demographic_concept_id_filter);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 470;
            this.match(StudyPeriod.PERSON_CONCEPT_ATTRIBUTE);
            this.state = 471;
            localContext._op = this.tokenStream.LT(1);
            _la = this.tokenStream.LA(1);
            if(!(_la === 88 || _la === 94)) {
                localContext._op = this.errorHandler.recoverInline(this);
            }
            else {
                this.errorHandler.reportMatch(this);
                this.consume();
            }
            this.state = 472;
            this.match(StudyPeriod.CONCEPT);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public demographic_numeric_filter(): Demographic_numeric_filterContext {
        let localContext = new Demographic_numeric_filterContext(this.context, this.state);
        this.enterRule(localContext, 42, StudyPeriod.RULE_demographic_numeric_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 474;
            this.match(StudyPeriod.NF);
            this.state = 475;
            this.match(StudyPeriod.OPEN_PAREN);
            {
            this.state = 476;
            this.demographic_int_filter();
            }
            this.state = 477;
            this.match(StudyPeriod.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public demographic_int_filter(): Demographic_int_filterContext {
        let localContext = new Demographic_int_filterContext(this.context, this.state);
        this.enterRule(localContext, 44, StudyPeriod.RULE_demographic_int_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 479;
            this.match(StudyPeriod.PERSON_INT_ATTRIBUTE);
            this.state = 480;
            this.comparison_op();
            this.state = 481;
            this.match(StudyPeriod.INT);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public demographic_error_filter(): Demographic_error_filterContext {
        let localContext = new Demographic_error_filterContext(this.context, this.state);
        this.enterRule(localContext, 46, StudyPeriod.RULE_demographic_error_filter);
        try {
            this.state = 508;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 9, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 483;
                this.match(StudyPeriod.CF);
                this.state = 484;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 485;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 486;
                this.match(StudyPeriod.CF);
                this.state = 487;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 488;
                this.match(StudyPeriod.PERSON_CONCEPT_ATTRIBUTE);
                this.state = 489;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 490;
                this.match(StudyPeriod.CF);
                this.state = 491;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 492;
                this.match(StudyPeriod.PERSON_CONCEPT_ATTRIBUTE);
                this.state = 493;
                this.match(StudyPeriod.IN);
                this.state = 494;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 495;
                this.match(StudyPeriod.NF);
                this.state = 496;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 497;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 5:
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 498;
                this.match(StudyPeriod.NF);
                this.state = 499;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 500;
                this.match(StudyPeriod.PERSON_INT_ATTRIBUTE);
                this.state = 501;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 6:
                this.enterOuterAlt(localContext, 6);
                {
                this.state = 502;
                this.match(StudyPeriod.NF);
                this.state = 503;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 504;
                this.match(StudyPeriod.PERSON_INT_ATTRIBUTE);
                this.state = 505;
                this.comparison_op();
                this.state = 506;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public subject_variable_event_name(): Subject_variable_event_nameContext {
        let localContext = new Subject_variable_event_nameContext(this.context, this.state);
        this.enterRule(localContext, 48, StudyPeriod.RULE_subject_variable_event_name);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 510;
            _la = this.tokenStream.LA(1);
            if(!(((((_la - 42)) & ~0x1F) === 0 && ((1 << (_la - 42)) & 511) !== 0))) {
            this.errorHandler.recoverInline(this);
            }
            else {
                this.errorHandler.reportMatch(this);
                this.consume();
            }
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public index_date(): Index_dateContext {
        let localContext = new Index_dateContext(this.context, this.state);
        this.enterRule(localContext, 50, StudyPeriod.RULE_index_date);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 512;
            this.match(StudyPeriod.INDEX_DATE);
            this.state = 513;
            this.match(StudyPeriod.EQ);
            this.state = 514;
            this.index_date_definition();
            this.state = 515;
            this.match(StudyPeriod.SEMICOLON);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public index_date_definition(): Index_date_definitionContext {
        let localContext = new Index_date_definitionContext(this.context, this.state);
        this.enterRule(localContext, 52, StudyPeriod.RULE_index_date_definition);
        try {
            this.state = 521;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 10, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 517;
                this.calendar_date();
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 518;
                this.calendarError();
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 519;
                this.index_event_date();
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 520;
                this.index_event_date_error();
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public calendar_date(): Calendar_dateContext {
        let localContext = new Calendar_dateContext(this.context, this.state);
        this.enterRule(localContext, 54, StudyPeriod.RULE_calendar_date);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 523;
            localContext._index_date_type = this.match(StudyPeriod.CALENDAR_DATE);
            this.state = 524;
            this.match(StudyPeriod.OPEN_PAREN);
            this.state = 525;
            this.match(StudyPeriod.DATE);
            this.state = 526;
            this.match(StudyPeriod.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public index_event_date(): Index_event_dateContext {
        let localContext = new Index_event_dateContext(this.context, this.state);
        this.enterRule(localContext, 56, StudyPeriod.RULE_index_event_date);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 528;
            localContext._index_date_type = this.match(StudyPeriod.EVENT);
            this.state = 529;
            this.match(StudyPeriod.OPEN_PAREN);
            this.state = 530;
            localContext._date = this.tokenStream.LT(1);
            _la = this.tokenStream.LA(1);
            if(!(_la === 63 || _la === 159)) {
                localContext._date = this.errorHandler.recoverInline(this);
            }
            else {
                this.errorHandler.reportMatch(this);
                this.consume();
            }
            this.state = 533;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            if (_la === 87) {
                {
                this.state = 531;
                this.match(StudyPeriod.COMMA);
                this.state = 532;
                this.index_date_bounds();
                }
            }

            this.state = 535;
            this.match(StudyPeriod.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public index_date_bounds(): Index_date_boundsContext {
        let localContext = new Index_date_boundsContext(this.context, this.state);
        this.enterRule(localContext, 58, StudyPeriod.RULE_index_date_bounds);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 539;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 12, this.context) ) {
            case 1:
                {
                this.state = 537;
                this.lower_date_bounds();
                }
                break;
            case 2:
                {
                this.state = 538;
                this.lower_date_bounds_error();
                }
                break;
            }
            this.state = 541;
            this.match(StudyPeriod.COMMA);
            this.state = 544;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 13, this.context) ) {
            case 1:
                {
                this.state = 542;
                this.upper_date_bounds();
                }
                break;
            case 2:
                {
                this.state = 543;
                this.upper_date_bounds_error();
                }
                break;
            }
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public upper_date_bounds(): Upper_date_boundsContext {
        let localContext = new Upper_date_boundsContext(this.context, this.state);
        this.enterRule(localContext, 60, StudyPeriod.RULE_upper_date_bounds);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 546;
            this.match(StudyPeriod.UPPER_DATE_BOUND);
            this.state = 547;
            this.match(StudyPeriod.OPEN_PAREN);
            this.state = 548;
            this.match(StudyPeriod.DATE);
            this.state = 549;
            this.match(StudyPeriod.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public lower_date_bounds(): Lower_date_boundsContext {
        let localContext = new Lower_date_boundsContext(this.context, this.state);
        this.enterRule(localContext, 62, StudyPeriod.RULE_lower_date_bounds);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 551;
            this.match(StudyPeriod.LOWER_DATE_BOUND);
            this.state = 552;
            this.match(StudyPeriod.OPEN_PAREN);
            this.state = 553;
            this.match(StudyPeriod.DATE);
            this.state = 554;
            this.match(StudyPeriod.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public calendarError(): CalendarErrorContext {
        let localContext = new CalendarErrorContext(this.context, this.state);
        this.enterRule(localContext, 64, StudyPeriod.RULE_calendarError);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 556;
            this.match(StudyPeriod.CALENDAR_DATE);
            this.state = 557;
            this.match(StudyPeriod.OPEN_PAREN);
            this.state = 558;
            this.match(StudyPeriod.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public index_event_date_error(): Index_event_date_errorContext {
        let localContext = new Index_event_date_errorContext(this.context, this.state);
        this.enterRule(localContext, 66, StudyPeriod.RULE_index_event_date_error);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 560;
            this.match(StudyPeriod.EVENT);
            this.state = 561;
            this.match(StudyPeriod.OPEN_PAREN);
            this.state = 562;
            this.match(StudyPeriod.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public lower_date_bounds_error(): Lower_date_bounds_errorContext {
        let localContext = new Lower_date_bounds_errorContext(this.context, this.state);
        this.enterRule(localContext, 68, StudyPeriod.RULE_lower_date_bounds_error);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 564;
            this.match(StudyPeriod.LOWER_DATE_BOUND);
            this.state = 565;
            this.match(StudyPeriod.OPEN_PAREN);
            this.state = 566;
            this.match(StudyPeriod.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public upper_date_bounds_error(): Upper_date_bounds_errorContext {
        let localContext = new Upper_date_bounds_errorContext(this.context, this.state);
        this.enterRule(localContext, 70, StudyPeriod.RULE_upper_date_bounds_error);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 568;
            this.match(StudyPeriod.UPPER_DATE_BOUND);
            this.state = 569;
            this.match(StudyPeriod.OPEN_PAREN);
            this.state = 570;
            this.match(StudyPeriod.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public derived_event(): Derived_eventContext {
        let localContext = new Derived_eventContext(this.context, this.state);
        this.enterRule(localContext, 72, StudyPeriod.RULE_derived_event);
        try {
            this.state = 575;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case StudyPeriod.MERGED_EVENT_NAME:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 572;
                this.merged_event();
                }
                break;
            case StudyPeriod.SEQUENCE_EVENT_NAME:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 573;
                this.sequence_event();
                }
                break;
            case StudyPeriod.INSTANCE_EVENT_NAME:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 574;
                this.instance_event();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public merged_event(): Merged_eventContext {
        let localContext = new Merged_eventContext(this.context, this.state);
        this.enterRule(localContext, 74, StudyPeriod.RULE_merged_event);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 577;
            this.match(StudyPeriod.MERGED_EVENT_NAME);
            this.state = 578;
            this.match(StudyPeriod.EQ);
            this.state = 579;
            this.match(StudyPeriod.MERGED_EVENT);
            this.state = 580;
            this.match(StudyPeriod.OPEN_PAREN);
            this.state = 581;
            this.merged_event_criteria();
            this.state = 584;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            if (_la === 87) {
                {
                this.state = 582;
                this.match(StudyPeriod.COMMA);
                this.state = 583;
                this.merged_event_filter_criterion();
                }
            }

            this.state = 586;
            this.match(StudyPeriod.CLOSE_PAREN);
            this.state = 587;
            this.match(StudyPeriod.SEMICOLON);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public merged_event_criteria(): Merged_event_criteriaContext {
        let localContext = new Merged_event_criteriaContext(this.context, this.state);
        this.enterRule(localContext, 76, StudyPeriod.RULE_merged_event_criteria);
        try {
            let alternative: number;
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 589;
            this.merged_event_criterion();
            this.state = 592;
            this.errorHandler.sync(this);
            alternative = 1;
            do {
                switch (alternative) {
                case 1:
                    {
                    {
                    this.state = 590;
                    this.match(StudyPeriod.COMMA);
                    this.state = 591;
                    this.merged_event_criterion();
                    }
                    }
                    break;
                default:
                    throw new antlr.NoViableAltException(this);
                }
                this.state = 594;
                this.errorHandler.sync(this);
                alternative = this.interpreter.adaptivePredict(this.tokenStream, 16, this.context);
            } while (alternative !== 2 && alternative !== antlr.ATN.INVALID_ALT_NUMBER);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public merged_event_criterion(): Merged_event_criterionContext {
        let localContext = new Merged_event_criterionContext(this.context, this.state);
        this.enterRule(localContext, 78, StudyPeriod.RULE_merged_event_criterion);
        try {
            this.state = 598;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 17, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 596;
                this.merged_event_event();
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 597;
                this.derived_event_error();
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public merged_event_filter_criterion(): Merged_event_filter_criterionContext {
        let localContext = new Merged_event_filter_criterionContext(this.context, this.state);
        this.enterRule(localContext, 80, StudyPeriod.RULE_merged_event_filter_criterion);
        try {
            this.state = 602;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 18, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 600;
                this.merged_event_filter();
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 601;
                this.merged_event_filter_error();
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public merged_event_event(): Merged_event_eventContext {
        let localContext = new Merged_event_eventContext(this.context, this.state);
        this.enterRule(localContext, 82, StudyPeriod.RULE_merged_event_event);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 604;
            this.match(StudyPeriod.DERIVED_EVENT);
            this.state = 605;
            this.match(StudyPeriod.OPEN_PAREN);
            this.state = 608;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case StudyPeriod.QUALIFIED_CONDITION_OCCURRENCE_ALIAS:
            case StudyPeriod.QUALIFIED_DRUG_EXPOSURE_ALIAS:
            case StudyPeriod.QUALIFIED_MEASUREMENT_ALIAS:
            case StudyPeriod.QUALIFIED_OBSERVATION_ALIAS:
            case StudyPeriod.QUALIFIED_PROCEDURE_OCCURRENCE_ALIAS:
            case StudyPeriod.QUALIFIED_VISIT_OCCURRENCE_ALIAS:
                {
                this.state = 606;
                this.qualified_simple_event();
                }
                break;
            case StudyPeriod.QUALIFIED_DERIVED_EVENT_NAME:
                {
                this.state = 607;
                this.qualified_derived_event();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
            this.state = 610;
            this.match(StudyPeriod.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public merged_event_filter(): Merged_event_filterContext {
        let localContext = new Merged_event_filterContext(this.context, this.state);
        this.enterRule(localContext, 84, StudyPeriod.RULE_merged_event_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 612;
            this.merged_event_uniqueness_filter();
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public merged_event_uniqueness_filter(): Merged_event_uniqueness_filterContext {
        let localContext = new Merged_event_uniqueness_filterContext(this.context, this.state);
        this.enterRule(localContext, 86, StudyPeriod.RULE_merged_event_uniqueness_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 614;
            this.match(StudyPeriod.UF);
            this.state = 615;
            this.match(StudyPeriod.OPEN_PAREN);
            this.state = 616;
            this.merged_event_uniqueness_filter_criteria();
            this.state = 617;
            this.match(StudyPeriod.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public merged_event_uniqueness_filter_criteria(): Merged_event_uniqueness_filter_criteriaContext {
        let localContext = new Merged_event_uniqueness_filter_criteriaContext(this.context, this.state);
        this.enterRule(localContext, 88, StudyPeriod.RULE_merged_event_uniqueness_filter_criteria);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 621;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case StudyPeriod.MINIMUM_BETWEEN:
                {
                this.state = 619;
                this.derived_uniqueness_filter();
                }
                break;
            case StudyPeriod.FIXED_WINDOW:
            case StudyPeriod.ROLLING_WINDOW:
                {
                this.state = 620;
                this.derived_uniqueness_filter_window();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
            this.state = 623;
            localContext._date_attr = this.match(StudyPeriod.DERIVED_EVENT_DATE);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public merged_event_filter_error(): Merged_event_filter_errorContext {
        let localContext = new Merged_event_filter_errorContext(this.context, this.state);
        this.enterRule(localContext, 90, StudyPeriod.RULE_merged_event_filter_error);
        try {
            this.state = 679;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 21, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 625;
                this.match(StudyPeriod.UF);
                this.state = 626;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 627;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 628;
                this.match(StudyPeriod.UF);
                this.state = 629;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 630;
                this.match(StudyPeriod.MINIMUM_BETWEEN);
                this.state = 631;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 632;
                this.match(StudyPeriod.UF);
                this.state = 633;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 634;
                this.match(StudyPeriod.MINIMUM_BETWEEN);
                this.state = 635;
                this.derived_event_int();
                this.state = 636;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 638;
                this.match(StudyPeriod.UF);
                this.state = 639;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 640;
                this.match(StudyPeriod.MINIMUM_BETWEEN);
                this.state = 641;
                this.derived_event_int();
                this.state = 642;
                this.match(StudyPeriod.TIME_UNIT);
                this.state = 643;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 5:
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 645;
                this.match(StudyPeriod.UF);
                this.state = 646;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 647;
                this.match(StudyPeriod.FIXED_WINDOW);
                this.state = 648;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 6:
                this.enterOuterAlt(localContext, 6);
                {
                this.state = 649;
                this.match(StudyPeriod.UF);
                this.state = 650;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 651;
                this.match(StudyPeriod.FIXED_WINDOW);
                this.state = 652;
                this.derived_event_int();
                this.state = 653;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 7:
                this.enterOuterAlt(localContext, 7);
                {
                this.state = 655;
                this.match(StudyPeriod.UF);
                this.state = 656;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 657;
                this.match(StudyPeriod.FIXED_WINDOW);
                this.state = 658;
                this.derived_event_int();
                this.state = 659;
                this.match(StudyPeriod.TIME_UNIT);
                this.state = 660;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 8:
                this.enterOuterAlt(localContext, 8);
                {
                this.state = 662;
                this.match(StudyPeriod.UF);
                this.state = 663;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 664;
                this.match(StudyPeriod.ROLLING_WINDOW);
                this.state = 665;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 9:
                this.enterOuterAlt(localContext, 9);
                {
                this.state = 666;
                this.match(StudyPeriod.UF);
                this.state = 667;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 668;
                this.match(StudyPeriod.ROLLING_WINDOW);
                this.state = 669;
                this.derived_event_int();
                this.state = 670;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 10:
                this.enterOuterAlt(localContext, 10);
                {
                this.state = 672;
                this.match(StudyPeriod.UF);
                this.state = 673;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 674;
                this.match(StudyPeriod.ROLLING_WINDOW);
                this.state = 675;
                this.derived_event_int();
                this.state = 676;
                this.match(StudyPeriod.TIME_UNIT);
                this.state = 677;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public sequence_event(): Sequence_eventContext {
        let localContext = new Sequence_eventContext(this.context, this.state);
        this.enterRule(localContext, 92, StudyPeriod.RULE_sequence_event);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 681;
            this.match(StudyPeriod.SEQUENCE_EVENT_NAME);
            this.state = 682;
            this.match(StudyPeriod.EQ);
            this.state = 683;
            this.match(StudyPeriod.SEQUENCE_EVENT);
            this.state = 684;
            this.match(StudyPeriod.OPEN_PAREN);
            this.state = 685;
            this.sequence_event_criteria();
            this.state = 686;
            this.match(StudyPeriod.CLOSE_PAREN);
            this.state = 687;
            this.match(StudyPeriod.SEMICOLON);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public sequence_event_criteria(): Sequence_event_criteriaContext {
        let localContext = new Sequence_event_criteriaContext(this.context, this.state);
        this.enterRule(localContext, 94, StudyPeriod.RULE_sequence_event_criteria);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 689;
            this.sequence_event_criterion();
            this.state = 694;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            while (_la === 87) {
                {
                {
                this.state = 690;
                this.match(StudyPeriod.COMMA);
                this.state = 691;
                this.sequence_event_criterion();
                }
                }
                this.state = 696;
                this.errorHandler.sync(this);
                _la = this.tokenStream.LA(1);
            }
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public sequence_event_criterion(): Sequence_event_criterionContext {
        let localContext = new Sequence_event_criterionContext(this.context, this.state);
        this.enterRule(localContext, 96, StudyPeriod.RULE_sequence_event_criterion);
        try {
            this.state = 701;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 23, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 697;
                this.sequence_event_constraint();
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 698;
                this.sequence_event_event();
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 699;
                this.sequence_event_constraint_error();
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 700;
                this.derived_event_error();
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public sequence_event_constraint(): Sequence_event_constraintContext {
        let localContext = new Sequence_event_constraintContext(this.context, this.state);
        this.enterRule(localContext, 98, StudyPeriod.RULE_sequence_event_constraint);
        try {
            this.state = 705;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case StudyPeriod.ANY_ORDER:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 703;
                this.match(StudyPeriod.ANY_ORDER);
                }
                break;
            case StudyPeriod.TC:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 704;
                this.temporal_constraint();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public temporal_constraint(): Temporal_constraintContext {
        let localContext = new Temporal_constraintContext(this.context, this.state);
        this.enterRule(localContext, 100, StudyPeriod.RULE_temporal_constraint);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 707;
            this.match(StudyPeriod.TC);
            this.state = 708;
            this.match(StudyPeriod.OPEN_PAREN);
            this.state = 709;
            this.sequence_temporal_filter();
            this.state = 710;
            this.match(StudyPeriod.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public sequence_temporal_filter(): Sequence_temporal_filterContext {
        let localContext = new Sequence_temporal_filterContext(this.context, this.state);
        this.enterRule(localContext, 102, StudyPeriod.RULE_sequence_temporal_filter);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 712;
            _la = this.tokenStream.LA(1);
            if(!(((((_la - 119)) & ~0x1F) === 0 && ((1 << (_la - 119)) & 7) !== 0))) {
            this.errorHandler.recoverInline(this);
            }
            else {
                this.errorHandler.reportMatch(this);
                this.consume();
            }
            this.state = 713;
            this.match(StudyPeriod.INT);
            this.state = 714;
            this.match(StudyPeriod.TIME_UNIT);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public sequence_event_event(): Sequence_event_eventContext {
        let localContext = new Sequence_event_eventContext(this.context, this.state);
        this.enterRule(localContext, 104, StudyPeriod.RULE_sequence_event_event);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 716;
            this.match(StudyPeriod.DERIVED_EVENT);
            this.state = 717;
            this.match(StudyPeriod.OPEN_PAREN);
            this.state = 720;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 25, this.context) ) {
            case 1:
                {
                this.state = 718;
                this.selected_sequence_event();
                }
                break;
            case 2:
                {
                this.state = 719;
                this.unselected_sequence_event();
                }
                break;
            }
            this.state = 722;
            this.match(StudyPeriod.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public selected_sequence_event(): Selected_sequence_eventContext {
        let localContext = new Selected_sequence_eventContext(this.context, this.state);
        this.enterRule(localContext, 106, StudyPeriod.RULE_selected_sequence_event);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 726;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case StudyPeriod.QUALIFIED_CONDITION_OCCURRENCE_ALIAS:
            case StudyPeriod.QUALIFIED_DRUG_EXPOSURE_ALIAS:
            case StudyPeriod.QUALIFIED_MEASUREMENT_ALIAS:
            case StudyPeriod.QUALIFIED_OBSERVATION_ALIAS:
            case StudyPeriod.QUALIFIED_PROCEDURE_OCCURRENCE_ALIAS:
            case StudyPeriod.QUALIFIED_VISIT_OCCURRENCE_ALIAS:
                {
                this.state = 724;
                this.qualified_simple_event();
                }
                break;
            case StudyPeriod.QUALIFIED_DERIVED_EVENT_NAME:
                {
                this.state = 725;
                this.qualified_derived_event();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
            this.state = 728;
            this.match(StudyPeriod.COMMA);
            this.state = 729;
            this.match(StudyPeriod.IS_EVENT_DATE);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public unselected_sequence_event(): Unselected_sequence_eventContext {
        let localContext = new Unselected_sequence_eventContext(this.context, this.state);
        this.enterRule(localContext, 108, StudyPeriod.RULE_unselected_sequence_event);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 733;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case StudyPeriod.QUALIFIED_CONDITION_OCCURRENCE_ALIAS:
            case StudyPeriod.QUALIFIED_DRUG_EXPOSURE_ALIAS:
            case StudyPeriod.QUALIFIED_MEASUREMENT_ALIAS:
            case StudyPeriod.QUALIFIED_OBSERVATION_ALIAS:
            case StudyPeriod.QUALIFIED_PROCEDURE_OCCURRENCE_ALIAS:
            case StudyPeriod.QUALIFIED_VISIT_OCCURRENCE_ALIAS:
                {
                this.state = 731;
                this.qualified_simple_event();
                }
                break;
            case StudyPeriod.QUALIFIED_DERIVED_EVENT_NAME:
                {
                this.state = 732;
                this.qualified_derived_event();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public instance_event(): Instance_eventContext {
        let localContext = new Instance_eventContext(this.context, this.state);
        this.enterRule(localContext, 110, StudyPeriod.RULE_instance_event);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 735;
            this.match(StudyPeriod.INSTANCE_EVENT_NAME);
            this.state = 736;
            this.match(StudyPeriod.EQ);
            this.state = 737;
            this.match(StudyPeriod.INSTANCE_EVENT);
            this.state = 738;
            this.match(StudyPeriod.OPEN_PAREN);
            this.state = 739;
            this.instance_event_criteria();
            this.state = 740;
            this.match(StudyPeriod.CLOSE_PAREN);
            this.state = 741;
            this.match(StudyPeriod.SEMICOLON);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public instance_event_criteria(): Instance_event_criteriaContext {
        let localContext = new Instance_event_criteriaContext(this.context, this.state);
        this.enterRule(localContext, 112, StudyPeriod.RULE_instance_event_criteria);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 743;
            this.instance_event_criterion();
            this.state = 746;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            do {
                {
                {
                this.state = 744;
                this.match(StudyPeriod.COMMA);
                this.state = 745;
                this.instance_event_criterion();
                }
                }
                this.state = 748;
                this.errorHandler.sync(this);
                _la = this.tokenStream.LA(1);
            } while (_la === 87);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public instance_event_criterion(): Instance_event_criterionContext {
        let localContext = new Instance_event_criterionContext(this.context, this.state);
        this.enterRule(localContext, 114, StudyPeriod.RULE_instance_event_criterion);
        try {
            this.state = 755;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 29, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                // tslint:disable-next-line:no-empty
                {
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 751;
                this.instance_event_event();
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 752;
                this.derived_event_error();
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 753;
                this.instance_event_position();
                }
                break;
            case 5:
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 754;
                this.instance_event_position_error();
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public instance_event_event(): Instance_event_eventContext {
        let localContext = new Instance_event_eventContext(this.context, this.state);
        this.enterRule(localContext, 116, StudyPeriod.RULE_instance_event_event);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 757;
            this.match(StudyPeriod.DERIVED_EVENT);
            this.state = 758;
            this.match(StudyPeriod.OPEN_PAREN);
            this.state = 761;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case StudyPeriod.QUALIFIED_CONDITION_OCCURRENCE_ALIAS:
            case StudyPeriod.QUALIFIED_DRUG_EXPOSURE_ALIAS:
            case StudyPeriod.QUALIFIED_MEASUREMENT_ALIAS:
            case StudyPeriod.QUALIFIED_OBSERVATION_ALIAS:
            case StudyPeriod.QUALIFIED_PROCEDURE_OCCURRENCE_ALIAS:
            case StudyPeriod.QUALIFIED_VISIT_OCCURRENCE_ALIAS:
                {
                this.state = 759;
                this.qualified_simple_event();
                }
                break;
            case StudyPeriod.QUALIFIED_DERIVED_EVENT_NAME:
                {
                this.state = 760;
                this.qualified_derived_event();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
            this.state = 763;
            this.match(StudyPeriod.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public instance_event_position(): Instance_event_positionContext {
        let localContext = new Instance_event_positionContext(this.context, this.state);
        this.enterRule(localContext, 118, StudyPeriod.RULE_instance_event_position);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 765;
            this.match(StudyPeriod.POSITION);
            this.state = 766;
            this.match(StudyPeriod.OPEN_PAREN);
            this.state = 769;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case StudyPeriod.MAX:
            case StudyPeriod.MIN:
                {
                this.state = 767;
                this.aggregation_qualified();
                }
                break;
            case StudyPeriod.INDEX:
                {
                this.state = 768;
                this.specific_instance();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
            this.state = 771;
            this.match(StudyPeriod.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public aggregation_qualified(): Aggregation_qualifiedContext {
        let localContext = new Aggregation_qualifiedContext(this.context, this.state);
        this.enterRule(localContext, 120, StudyPeriod.RULE_aggregation_qualified);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 773;
            localContext._op = this.tokenStream.LT(1);
            _la = this.tokenStream.LA(1);
            if(!(_la === 99 || _la === 100)) {
                localContext._op = this.errorHandler.recoverInline(this);
            }
            else {
                this.errorHandler.reportMatch(this);
                this.consume();
            }
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public specific_instance(): Specific_instanceContext {
        let localContext = new Specific_instanceContext(this.context, this.state);
        this.enterRule(localContext, 122, StudyPeriod.RULE_specific_instance);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 775;
            this.match(StudyPeriod.INDEX);
            this.state = 776;
            this.match(StudyPeriod.OPEN_PAREN);
            this.state = 777;
            this.match(StudyPeriod.INT);
            this.state = 778;
            this.match(StudyPeriod.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public instance_event_position_error(): Instance_event_position_errorContext {
        let localContext = new Instance_event_position_errorContext(this.context, this.state);
        this.enterRule(localContext, 124, StudyPeriod.RULE_instance_event_position_error);
        try {
            this.state = 789;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 32, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 780;
                this.match(StudyPeriod.POSITION);
                this.state = 781;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 782;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 783;
                this.match(StudyPeriod.POSITION);
                this.state = 784;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 785;
                this.match(StudyPeriod.INDEX);
                this.state = 786;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 787;
                this.match(StudyPeriod.CLOSE_PAREN);
                this.state = 788;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public qualified_simple_event(): Qualified_simple_eventContext {
        let localContext = new Qualified_simple_eventContext(this.context, this.state);
        this.enterRule(localContext, 126, StudyPeriod.RULE_qualified_simple_event);
        try {
            this.state = 809;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case StudyPeriod.QUALIFIED_CONDITION_OCCURRENCE_ALIAS:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 791;
                this.match(StudyPeriod.QUALIFIED_CONDITION_OCCURRENCE_ALIAS);
                this.state = 792;
                this.match(StudyPeriod.PERIOD);
                this.state = 793;
                this.match(StudyPeriod.CONDITION_OCCURRENCE_DATE_ATTRIBUTE);
                }
                break;
            case StudyPeriod.QUALIFIED_DRUG_EXPOSURE_ALIAS:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 794;
                this.match(StudyPeriod.QUALIFIED_DRUG_EXPOSURE_ALIAS);
                this.state = 795;
                this.match(StudyPeriod.PERIOD);
                this.state = 796;
                this.match(StudyPeriod.DRUG_EXPOSURE_DATE_ATTRIBUTE);
                }
                break;
            case StudyPeriod.QUALIFIED_MEASUREMENT_ALIAS:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 797;
                this.match(StudyPeriod.QUALIFIED_MEASUREMENT_ALIAS);
                this.state = 798;
                this.match(StudyPeriod.PERIOD);
                this.state = 799;
                this.match(StudyPeriod.MEASUREMENT_DATE_ATTRIBUTE);
                }
                break;
            case StudyPeriod.QUALIFIED_OBSERVATION_ALIAS:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 800;
                this.match(StudyPeriod.QUALIFIED_OBSERVATION_ALIAS);
                this.state = 801;
                this.match(StudyPeriod.PERIOD);
                this.state = 802;
                this.match(StudyPeriod.OBSERVATION_DATE_ATTRIBUTE);
                }
                break;
            case StudyPeriod.QUALIFIED_PROCEDURE_OCCURRENCE_ALIAS:
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 803;
                this.match(StudyPeriod.QUALIFIED_PROCEDURE_OCCURRENCE_ALIAS);
                this.state = 804;
                this.match(StudyPeriod.PERIOD);
                this.state = 805;
                this.match(StudyPeriod.PROCEDURE_OCCURRENCE_DATE_ATTRIBUTE);
                }
                break;
            case StudyPeriod.QUALIFIED_VISIT_OCCURRENCE_ALIAS:
                this.enterOuterAlt(localContext, 6);
                {
                this.state = 806;
                this.match(StudyPeriod.QUALIFIED_VISIT_OCCURRENCE_ALIAS);
                this.state = 807;
                this.match(StudyPeriod.PERIOD);
                this.state = 808;
                this.match(StudyPeriod.VISIT_OCCURRENCE_DATE_ATTRIBUTE);
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public qualified_derived_event(): Qualified_derived_eventContext {
        let localContext = new Qualified_derived_eventContext(this.context, this.state);
        this.enterRule(localContext, 128, StudyPeriod.RULE_qualified_derived_event);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 811;
            this.match(StudyPeriod.QUALIFIED_DERIVED_EVENT_NAME);
            this.state = 812;
            this.match(StudyPeriod.PERIOD);
            this.state = 813;
            this.match(StudyPeriod.DERIVED_EVENT_DATE);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public sequence_event_constraint_error(): Sequence_event_constraint_errorContext {
        let localContext = new Sequence_event_constraint_errorContext(this.context, this.state);
        this.enterRule(localContext, 130, StudyPeriod.RULE_sequence_event_constraint_error);
        let _la: number;
        try {
            this.state = 827;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 34, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 815;
                this.match(StudyPeriod.TC);
                this.state = 816;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 817;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 818;
                this.match(StudyPeriod.TC);
                this.state = 819;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 820;
                _la = this.tokenStream.LA(1);
                if(!(((((_la - 119)) & ~0x1F) === 0 && ((1 << (_la - 119)) & 7) !== 0))) {
                this.errorHandler.recoverInline(this);
                }
                else {
                    this.errorHandler.reportMatch(this);
                    this.consume();
                }
                this.state = 821;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 822;
                this.match(StudyPeriod.TC);
                this.state = 823;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 824;
                _la = this.tokenStream.LA(1);
                if(!(((((_la - 119)) & ~0x1F) === 0 && ((1 << (_la - 119)) & 7) !== 0))) {
                this.errorHandler.recoverInline(this);
                }
                else {
                    this.errorHandler.reportMatch(this);
                    this.consume();
                }
                this.state = 825;
                this.match(StudyPeriod.INT);
                this.state = 826;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public derived_event_error(): Derived_event_errorContext {
        let localContext = new Derived_event_errorContext(this.context, this.state);
        this.enterRule(localContext, 132, StudyPeriod.RULE_derived_event_error);
        let _la: number;
        try {
            this.state = 841;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 35, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 829;
                this.match(StudyPeriod.DERIVED_EVENT);
                this.state = 830;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 831;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 832;
                this.match(StudyPeriod.DERIVED_EVENT);
                this.state = 833;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 834;
                _la = this.tokenStream.LA(1);
                if(!(((((_la - 33)) & ~0x1F) === 0 && ((1 << (_la - 33)) & 431) !== 0))) {
                this.errorHandler.recoverInline(this);
                }
                else {
                    this.errorHandler.reportMatch(this);
                    this.consume();
                }
                this.state = 835;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 836;
                this.match(StudyPeriod.DERIVED_EVENT);
                this.state = 837;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 838;
                _la = this.tokenStream.LA(1);
                if(!(((((_la - 33)) & ~0x1F) === 0 && ((1 << (_la - 33)) & 431) !== 0))) {
                this.errorHandler.recoverInline(this);
                }
                else {
                    this.errorHandler.reportMatch(this);
                    this.consume();
                }
                this.state = 839;
                this.match(StudyPeriod.PERIOD);
                this.state = 840;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public derived_uniqueness_filter(): Derived_uniqueness_filterContext {
        let localContext = new Derived_uniqueness_filterContext(this.context, this.state);
        this.enterRule(localContext, 134, StudyPeriod.RULE_derived_uniqueness_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 843;
            this.match(StudyPeriod.MINIMUM_BETWEEN);
            this.state = 844;
            this.derived_event_int();
            this.state = 845;
            this.match(StudyPeriod.TIME_UNIT);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public derived_uniqueness_filter_window(): Derived_uniqueness_filter_windowContext {
        let localContext = new Derived_uniqueness_filter_windowContext(this.context, this.state);
        this.enterRule(localContext, 136, StudyPeriod.RULE_derived_uniqueness_filter_window);
        try {
            this.state = 849;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case StudyPeriod.FIXED_WINDOW:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 847;
                this.derived_fixed_window_uniqueness_filter();
                }
                break;
            case StudyPeriod.ROLLING_WINDOW:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 848;
                this.derived_rolling_window_uniqueness_filter();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public derived_fixed_window_uniqueness_filter(): Derived_fixed_window_uniqueness_filterContext {
        let localContext = new Derived_fixed_window_uniqueness_filterContext(this.context, this.state);
        this.enterRule(localContext, 138, StudyPeriod.RULE_derived_fixed_window_uniqueness_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 851;
            this.match(StudyPeriod.FIXED_WINDOW);
            this.state = 852;
            this.derived_event_int();
            this.state = 853;
            this.match(StudyPeriod.TIME_UNIT);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public derived_rolling_window_uniqueness_filter(): Derived_rolling_window_uniqueness_filterContext {
        let localContext = new Derived_rolling_window_uniqueness_filterContext(this.context, this.state);
        this.enterRule(localContext, 140, StudyPeriod.RULE_derived_rolling_window_uniqueness_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 855;
            this.match(StudyPeriod.ROLLING_WINDOW);
            this.state = 856;
            this.derived_event_int();
            this.state = 857;
            this.match(StudyPeriod.TIME_UNIT);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public derived_event_int(): Derived_event_intContext {
        let localContext = new Derived_event_intContext(this.context, this.state);
        this.enterRule(localContext, 142, StudyPeriod.RULE_derived_event_int);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 859;
            this.match(StudyPeriod.INT);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public simple_event(): Simple_eventContext {
        let localContext = new Simple_eventContext(this.context, this.state);
        this.enterRule(localContext, 144, StudyPeriod.RULE_simple_event);
        try {
            this.state = 867;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case StudyPeriod.CONDITION_OCCURRENCE_ALIAS:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 861;
                this.condition_occurrence_event();
                }
                break;
            case StudyPeriod.DRUG_EXPOSURE_ALIAS:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 862;
                this.drug_exposure_event();
                }
                break;
            case StudyPeriod.MEASUREMENT_ALIAS:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 863;
                this.measurement_event();
                }
                break;
            case StudyPeriod.OBSERVATION_ALIAS:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 864;
                this.observation_event();
                }
                break;
            case StudyPeriod.PROCEDURE_OCCURRENCE_ALIAS:
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 865;
                this.procedure_occurrence_event();
                }
                break;
            case StudyPeriod.VISIT_OCCURRENCE_ALIAS:
                this.enterOuterAlt(localContext, 6);
                {
                this.state = 866;
                this.visit_occurrence_event();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public condition_occurrence_event(): Condition_occurrence_eventContext {
        let localContext = new Condition_occurrence_eventContext(this.context, this.state);
        this.enterRule(localContext, 146, StudyPeriod.RULE_condition_occurrence_event);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 869;
            localContext._event_name = this.match(StudyPeriod.CONDITION_OCCURRENCE_ALIAS);
            this.state = 870;
            this.match(StudyPeriod.EQ);
            this.state = 871;
            localContext._event_definition = this.condition_occurrence_event_definition();
            this.state = 872;
            this.match(StudyPeriod.SEMICOLON);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public drug_exposure_event(): Drug_exposure_eventContext {
        let localContext = new Drug_exposure_eventContext(this.context, this.state);
        this.enterRule(localContext, 148, StudyPeriod.RULE_drug_exposure_event);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 874;
            localContext._event_name = this.match(StudyPeriod.DRUG_EXPOSURE_ALIAS);
            this.state = 875;
            this.match(StudyPeriod.EQ);
            this.state = 876;
            localContext._event_definition = this.drug_exposure_event_definition();
            this.state = 877;
            this.match(StudyPeriod.SEMICOLON);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public measurement_event(): Measurement_eventContext {
        let localContext = new Measurement_eventContext(this.context, this.state);
        this.enterRule(localContext, 150, StudyPeriod.RULE_measurement_event);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 879;
            localContext._event_name = this.match(StudyPeriod.MEASUREMENT_ALIAS);
            this.state = 880;
            this.match(StudyPeriod.EQ);
            this.state = 881;
            localContext._event_definition = this.measurement_event_definition();
            this.state = 882;
            this.match(StudyPeriod.SEMICOLON);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public observation_event(): Observation_eventContext {
        let localContext = new Observation_eventContext(this.context, this.state);
        this.enterRule(localContext, 152, StudyPeriod.RULE_observation_event);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 884;
            localContext._event_name = this.match(StudyPeriod.OBSERVATION_ALIAS);
            this.state = 885;
            this.match(StudyPeriod.EQ);
            this.state = 886;
            localContext._event_definition = this.observation_event_definition();
            this.state = 887;
            this.match(StudyPeriod.SEMICOLON);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public procedure_occurrence_event(): Procedure_occurrence_eventContext {
        let localContext = new Procedure_occurrence_eventContext(this.context, this.state);
        this.enterRule(localContext, 154, StudyPeriod.RULE_procedure_occurrence_event);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 889;
            localContext._event_name = this.match(StudyPeriod.PROCEDURE_OCCURRENCE_ALIAS);
            this.state = 890;
            this.match(StudyPeriod.EQ);
            this.state = 891;
            localContext._event_definition = this.procedure_occurrence_event_definition();
            this.state = 892;
            this.match(StudyPeriod.SEMICOLON);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public visit_occurrence_event(): Visit_occurrence_eventContext {
        let localContext = new Visit_occurrence_eventContext(this.context, this.state);
        this.enterRule(localContext, 156, StudyPeriod.RULE_visit_occurrence_event);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 894;
            localContext._event_name = this.match(StudyPeriod.VISIT_OCCURRENCE_ALIAS);
            this.state = 895;
            this.match(StudyPeriod.EQ);
            this.state = 896;
            localContext._event_definition = this.visit_occurrence_event_definition();
            this.state = 897;
            this.match(StudyPeriod.SEMICOLON);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public condition_occurrence_event_definition(): Condition_occurrence_event_definitionContext {
        let localContext = new Condition_occurrence_event_definitionContext(this.context, this.state);
        this.enterRule(localContext, 158, StudyPeriod.RULE_condition_occurrence_event_definition);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 899;
            localContext._prefix = this.match(StudyPeriod.CONDITION_OCCURRENCE);
            this.state = 900;
            this.match(StudyPeriod.OPEN_PAREN);
            this.state = 902;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            if ((((_la) & ~0x1F) === 0 && ((1 << _la) & 604110848) !== 0)) {
                {
                this.state = 901;
                localContext._criteria = this.condition_occurrence_event_criteria();
                }
            }

            this.state = 904;
            this.match(StudyPeriod.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public drug_exposure_event_definition(): Drug_exposure_event_definitionContext {
        let localContext = new Drug_exposure_event_definitionContext(this.context, this.state);
        this.enterRule(localContext, 160, StudyPeriod.RULE_drug_exposure_event_definition);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 906;
            localContext._prefix = this.match(StudyPeriod.DRUG_EXPOSURE);
            this.state = 907;
            this.match(StudyPeriod.OPEN_PAREN);
            this.state = 909;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            if ((((_la) & ~0x1F) === 0 && ((1 << _la) & 605159424) !== 0)) {
                {
                this.state = 908;
                localContext._criteria = this.drug_exposure_event_criteria();
                }
            }

            this.state = 911;
            this.match(StudyPeriod.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public measurement_event_definition(): Measurement_event_definitionContext {
        let localContext = new Measurement_event_definitionContext(this.context, this.state);
        this.enterRule(localContext, 162, StudyPeriod.RULE_measurement_event_definition);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 913;
            localContext._prefix = this.match(StudyPeriod.MEASUREMENT);
            this.state = 914;
            this.match(StudyPeriod.OPEN_PAREN);
            this.state = 916;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            if ((((_la) & ~0x1F) === 0 && ((1 << _la) & 605159424) !== 0)) {
                {
                this.state = 915;
                localContext._criteria = this.measurement_event_criteria();
                }
            }

            this.state = 918;
            this.match(StudyPeriod.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public observation_event_definition(): Observation_event_definitionContext {
        let localContext = new Observation_event_definitionContext(this.context, this.state);
        this.enterRule(localContext, 164, StudyPeriod.RULE_observation_event_definition);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 920;
            localContext._prefix = this.match(StudyPeriod.OBSERVATION);
            this.state = 921;
            this.match(StudyPeriod.OPEN_PAREN);
            this.state = 923;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            if ((((_la) & ~0x1F) === 0 && ((1 << _la) & 605159424) !== 0)) {
                {
                this.state = 922;
                localContext._criteria = this.observation_event_criteria();
                }
            }

            this.state = 925;
            this.match(StudyPeriod.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public procedure_occurrence_event_definition(): Procedure_occurrence_event_definitionContext {
        let localContext = new Procedure_occurrence_event_definitionContext(this.context, this.state);
        this.enterRule(localContext, 166, StudyPeriod.RULE_procedure_occurrence_event_definition);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 927;
            localContext._prefix = this.match(StudyPeriod.PROCEDURE_OCCURRENCE);
            this.state = 928;
            this.match(StudyPeriod.OPEN_PAREN);
            this.state = 930;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            if ((((_la) & ~0x1F) === 0 && ((1 << _la) & 605159424) !== 0)) {
                {
                this.state = 929;
                localContext._criteria = this.procedure_occurrence_event_criteria();
                }
            }

            this.state = 932;
            this.match(StudyPeriod.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public visit_occurrence_event_definition(): Visit_occurrence_event_definitionContext {
        let localContext = new Visit_occurrence_event_definitionContext(this.context, this.state);
        this.enterRule(localContext, 168, StudyPeriod.RULE_visit_occurrence_event_definition);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 934;
            localContext._prefix = this.match(StudyPeriod.VISIT_OCCURRENCE);
            this.state = 935;
            this.match(StudyPeriod.OPEN_PAREN);
            this.state = 937;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            if ((((_la) & ~0x1F) === 0 && ((1 << _la) & 604110848) !== 0)) {
                {
                this.state = 936;
                localContext._criteria = this.visit_occurrence_event_criteria();
                }
            }

            this.state = 939;
            this.match(StudyPeriod.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public condition_occurrence_event_criteria(): Condition_occurrence_event_criteriaContext {
        let localContext = new Condition_occurrence_event_criteriaContext(this.context, this.state);
        this.enterRule(localContext, 170, StudyPeriod.RULE_condition_occurrence_event_criteria);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 941;
            this.condition_occurrence_event_filter();
            this.state = 946;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            while (_la === 87) {
                {
                {
                this.state = 942;
                this.match(StudyPeriod.COMMA);
                this.state = 943;
                this.condition_occurrence_event_filter();
                }
                }
                this.state = 948;
                this.errorHandler.sync(this);
                _la = this.tokenStream.LA(1);
            }
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public condition_occurrence_event_filter(): Condition_occurrence_event_filterContext {
        let localContext = new Condition_occurrence_event_filterContext(this.context, this.state);
        this.enterRule(localContext, 172, StudyPeriod.RULE_condition_occurrence_event_filter);
        try {
            this.state = 953;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 45, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 949;
                this.condition_occurrence_concept_filters();
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 950;
                this.condition_occurrence_uniqueness_filters();
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 951;
                this.condition_occurrence_related_entity_filters();
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 952;
                this.condition_occurrence_error_filter();
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public condition_occurrence_concept_filters(): Condition_occurrence_concept_filtersContext {
        let localContext = new Condition_occurrence_concept_filtersContext(this.context, this.state);
        this.enterRule(localContext, 174, StudyPeriod.RULE_condition_occurrence_concept_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 955;
            this.match(StudyPeriod.CF);
            this.state = 956;
            this.match(StudyPeriod.OPEN_PAREN);
            this.state = 959;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 46, this.context) ) {
            case 1:
                {
                this.state = 957;
                this.condition_occurrence_concept_group_filter();
                }
                break;
            case 2:
                {
                this.state = 958;
                this.condition_occurrence_concept_filter();
                }
                break;
            }
            this.state = 961;
            this.match(StudyPeriod.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public condition_occurrence_concept_group_filter(): Condition_occurrence_concept_group_filterContext {
        let localContext = new Condition_occurrence_concept_group_filterContext(this.context, this.state);
        this.enterRule(localContext, 176, StudyPeriod.RULE_condition_occurrence_concept_group_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 963;
            this.match(StudyPeriod.CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE);
            this.state = 964;
            this.match(StudyPeriod.IN);
            this.state = 965;
            this.concept_group_selection();
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public condition_occurrence_concept_filter(): Condition_occurrence_concept_filterContext {
        let localContext = new Condition_occurrence_concept_filterContext(this.context, this.state);
        this.enterRule(localContext, 178, StudyPeriod.RULE_condition_occurrence_concept_filter);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 967;
            this.match(StudyPeriod.CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE);
            this.state = 968;
            localContext._op = this.tokenStream.LT(1);
            _la = this.tokenStream.LA(1);
            if(!(_la === 88 || _la === 94)) {
                localContext._op = this.errorHandler.recoverInline(this);
            }
            else {
                this.errorHandler.reportMatch(this);
                this.consume();
            }
            this.state = 969;
            this.match(StudyPeriod.CONCEPT);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public condition_occurrence_uniqueness_filters(): Condition_occurrence_uniqueness_filtersContext {
        let localContext = new Condition_occurrence_uniqueness_filtersContext(this.context, this.state);
        this.enterRule(localContext, 180, StudyPeriod.RULE_condition_occurrence_uniqueness_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 971;
            this.match(StudyPeriod.UF);
            this.state = 972;
            this.match(StudyPeriod.OPEN_PAREN);
            this.state = 973;
            this.condition_occurrence_uniqueness_filter();
            this.state = 974;
            this.match(StudyPeriod.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public condition_occurrence_uniqueness_filter(): Condition_occurrence_uniqueness_filterContext {
        let localContext = new Condition_occurrence_uniqueness_filterContext(this.context, this.state);
        this.enterRule(localContext, 182, StudyPeriod.RULE_condition_occurrence_uniqueness_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 978;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case StudyPeriod.MINIMUM_BETWEEN:
                {
                this.state = 976;
                this.simple_uniqueness_filter();
                }
                break;
            case StudyPeriod.FIXED_WINDOW:
            case StudyPeriod.ROLLING_WINDOW:
                {
                this.state = 977;
                this.simple_uniqueness_filter_window();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
            this.state = 980;
            localContext._date_attr = this.match(StudyPeriod.CONDITION_OCCURRENCE_DATE_ATTRIBUTE);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public condition_occurrence_related_entity_filters(): Condition_occurrence_related_entity_filtersContext {
        let localContext = new Condition_occurrence_related_entity_filtersContext(this.context, this.state);
        this.enterRule(localContext, 184, StudyPeriod.RULE_condition_occurrence_related_entity_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 982;
            this.match(StudyPeriod.RF);
            this.state = 983;
            this.match(StudyPeriod.OPEN_PAREN);
            this.state = 984;
            this.condition_occurrence_related_entity_filter();
            this.state = 985;
            this.match(StudyPeriod.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public condition_occurrence_related_entity_filter(): Condition_occurrence_related_entity_filterContext {
        let localContext = new Condition_occurrence_related_entity_filterContext(this.context, this.state);
        this.enterRule(localContext, 186, StudyPeriod.RULE_condition_occurrence_related_entity_filter);
        try {
            this.state = 989;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case StudyPeriod.PROVIDER:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 987;
                this.provider_sub_filter();
                }
                break;
            case StudyPeriod.VISIT_OCCURRENCE:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 988;
                this.visit_occurrence_sub_filter();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public condition_occurrence_sub_filter(): Condition_occurrence_sub_filterContext {
        let localContext = new Condition_occurrence_sub_filterContext(this.context, this.state);
        this.enterRule(localContext, 188, StudyPeriod.RULE_condition_occurrence_sub_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 991;
            this.match(StudyPeriod.CONDITION_OCCURRENCE);
            this.state = 994;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 49, this.context) ) {
            case 1:
                {
                this.state = 992;
                this.condition_occurrence_concept_group_filter();
                }
                break;
            case 2:
                {
                this.state = 993;
                this.condition_occurrence_concept_filter();
                }
                break;
            }
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public condition_occurrence_error_sub_filter(): Condition_occurrence_error_sub_filterContext {
        let localContext = new Condition_occurrence_error_sub_filterContext(this.context, this.state);
        this.enterRule(localContext, 190, StudyPeriod.RULE_condition_occurrence_error_sub_filter);
        let _la: number;
        try {
            this.state = 1006;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 50, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                // tslint:disable-next-line:no-empty
                {
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 997;
                this.match(StudyPeriod.CONDITION_OCCURRENCE);
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 998;
                this.match(StudyPeriod.CONDITION_OCCURRENCE);
                this.state = 999;
                this.match(StudyPeriod.CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE);
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 1000;
                this.match(StudyPeriod.CONDITION_OCCURRENCE);
                this.state = 1001;
                this.match(StudyPeriod.CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE);
                this.state = 1002;
                this.match(StudyPeriod.IN);
                }
                break;
            case 5:
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 1003;
                this.match(StudyPeriod.CONDITION_OCCURRENCE);
                this.state = 1004;
                this.match(StudyPeriod.CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE);
                this.state = 1005;
                localContext._op = this.tokenStream.LT(1);
                _la = this.tokenStream.LA(1);
                if(!(_la === 88 || _la === 94)) {
                    localContext._op = this.errorHandler.recoverInline(this);
                }
                else {
                    this.errorHandler.reportMatch(this);
                    this.consume();
                }
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public condition_occurrence_error_filter(): Condition_occurrence_error_filterContext {
        let localContext = new Condition_occurrence_error_filterContext(this.context, this.state);
        this.enterRule(localContext, 192, StudyPeriod.RULE_condition_occurrence_error_filter);
        let _la: number;
        try {
            this.state = 1092;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 51, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 1008;
                this.match(StudyPeriod.CF);
                this.state = 1009;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1010;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 1011;
                this.match(StudyPeriod.CF);
                this.state = 1012;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1013;
                this.match(StudyPeriod.CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE);
                this.state = 1014;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 1015;
                this.match(StudyPeriod.CF);
                this.state = 1016;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1017;
                this.match(StudyPeriod.CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE);
                this.state = 1018;
                this.match(StudyPeriod.IN);
                this.state = 1019;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 1020;
                this.match(StudyPeriod.CF);
                this.state = 1021;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1022;
                this.match(StudyPeriod.CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE);
                this.state = 1023;
                localContext._op = this.tokenStream.LT(1);
                _la = this.tokenStream.LA(1);
                if(!(_la === 88 || _la === 94)) {
                    localContext._op = this.errorHandler.recoverInline(this);
                }
                else {
                    this.errorHandler.reportMatch(this);
                    this.consume();
                }
                this.state = 1024;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 5:
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 1025;
                this.match(StudyPeriod.UF);
                this.state = 1026;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1027;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 6:
                this.enterOuterAlt(localContext, 6);
                {
                this.state = 1028;
                this.match(StudyPeriod.UF);
                this.state = 1029;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1030;
                this.match(StudyPeriod.MINIMUM_BETWEEN);
                this.state = 1031;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 7:
                this.enterOuterAlt(localContext, 7);
                {
                this.state = 1032;
                this.match(StudyPeriod.UF);
                this.state = 1033;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1034;
                this.match(StudyPeriod.MINIMUM_BETWEEN);
                this.state = 1035;
                this.simple_event_int();
                this.state = 1036;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 8:
                this.enterOuterAlt(localContext, 8);
                {
                this.state = 1038;
                this.match(StudyPeriod.UF);
                this.state = 1039;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1040;
                this.match(StudyPeriod.MINIMUM_BETWEEN);
                this.state = 1041;
                this.simple_event_int();
                this.state = 1042;
                this.match(StudyPeriod.TIME_UNIT);
                this.state = 1043;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 9:
                this.enterOuterAlt(localContext, 9);
                {
                this.state = 1045;
                this.match(StudyPeriod.UF);
                this.state = 1046;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1047;
                this.match(StudyPeriod.FIXED_WINDOW);
                this.state = 1048;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 10:
                this.enterOuterAlt(localContext, 10);
                {
                this.state = 1049;
                this.match(StudyPeriod.UF);
                this.state = 1050;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1051;
                this.match(StudyPeriod.FIXED_WINDOW);
                this.state = 1052;
                this.simple_event_int();
                this.state = 1053;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 11:
                this.enterOuterAlt(localContext, 11);
                {
                this.state = 1055;
                this.match(StudyPeriod.UF);
                this.state = 1056;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1057;
                this.match(StudyPeriod.FIXED_WINDOW);
                this.state = 1058;
                this.simple_event_int();
                this.state = 1059;
                this.match(StudyPeriod.TIME_UNIT);
                this.state = 1060;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 12:
                this.enterOuterAlt(localContext, 12);
                {
                this.state = 1062;
                this.match(StudyPeriod.UF);
                this.state = 1063;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1064;
                this.match(StudyPeriod.ROLLING_WINDOW);
                this.state = 1065;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 13:
                this.enterOuterAlt(localContext, 13);
                {
                this.state = 1066;
                this.match(StudyPeriod.UF);
                this.state = 1067;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1068;
                this.match(StudyPeriod.ROLLING_WINDOW);
                this.state = 1069;
                this.simple_event_int();
                this.state = 1070;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 14:
                this.enterOuterAlt(localContext, 14);
                {
                this.state = 1072;
                this.match(StudyPeriod.UF);
                this.state = 1073;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1074;
                this.match(StudyPeriod.ROLLING_WINDOW);
                this.state = 1075;
                this.simple_event_int();
                this.state = 1076;
                this.match(StudyPeriod.TIME_UNIT);
                this.state = 1077;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 15:
                this.enterOuterAlt(localContext, 15);
                {
                this.state = 1079;
                this.match(StudyPeriod.RF);
                this.state = 1080;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1081;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 16:
                this.enterOuterAlt(localContext, 16);
                {
                this.state = 1082;
                this.match(StudyPeriod.RF);
                this.state = 1083;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1084;
                this.provider_error_sub_filter();
                this.state = 1085;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 17:
                this.enterOuterAlt(localContext, 17);
                {
                this.state = 1087;
                this.match(StudyPeriod.RF);
                this.state = 1088;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1089;
                this.visit_occurrence_error_sub_filter();
                this.state = 1090;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public drug_exposure_event_criteria(): Drug_exposure_event_criteriaContext {
        let localContext = new Drug_exposure_event_criteriaContext(this.context, this.state);
        this.enterRule(localContext, 194, StudyPeriod.RULE_drug_exposure_event_criteria);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1094;
            this.drug_exposure_event_filter();
            this.state = 1099;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            while (_la === 87) {
                {
                {
                this.state = 1095;
                this.match(StudyPeriod.COMMA);
                this.state = 1096;
                this.drug_exposure_event_filter();
                }
                }
                this.state = 1101;
                this.errorHandler.sync(this);
                _la = this.tokenStream.LA(1);
            }
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public drug_exposure_event_filter(): Drug_exposure_event_filterContext {
        let localContext = new Drug_exposure_event_filterContext(this.context, this.state);
        this.enterRule(localContext, 196, StudyPeriod.RULE_drug_exposure_event_filter);
        try {
            this.state = 1107;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 53, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 1102;
                this.drug_exposure_concept_filters();
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 1103;
                this.drug_exposure_numeric_filters();
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 1104;
                this.drug_exposure_uniqueness_filters();
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 1105;
                this.drug_exposure_related_entity_filters();
                }
                break;
            case 5:
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 1106;
                this.drug_exposure_error_filter();
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public drug_exposure_concept_filters(): Drug_exposure_concept_filtersContext {
        let localContext = new Drug_exposure_concept_filtersContext(this.context, this.state);
        this.enterRule(localContext, 198, StudyPeriod.RULE_drug_exposure_concept_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1109;
            this.match(StudyPeriod.CF);
            this.state = 1110;
            this.match(StudyPeriod.OPEN_PAREN);
            this.state = 1113;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 54, this.context) ) {
            case 1:
                {
                this.state = 1111;
                this.drug_exposure_concept_group_filter();
                }
                break;
            case 2:
                {
                this.state = 1112;
                this.drug_exposure_concept_filter();
                }
                break;
            }
            this.state = 1115;
            this.match(StudyPeriod.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public drug_exposure_concept_group_filter(): Drug_exposure_concept_group_filterContext {
        let localContext = new Drug_exposure_concept_group_filterContext(this.context, this.state);
        this.enterRule(localContext, 200, StudyPeriod.RULE_drug_exposure_concept_group_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1117;
            this.match(StudyPeriod.DRUG_EXPOSURE_CONCEPT_ATTRIBUTE);
            this.state = 1118;
            this.match(StudyPeriod.IN);
            this.state = 1119;
            this.concept_group_selection();
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public drug_exposure_concept_filter(): Drug_exposure_concept_filterContext {
        let localContext = new Drug_exposure_concept_filterContext(this.context, this.state);
        this.enterRule(localContext, 202, StudyPeriod.RULE_drug_exposure_concept_filter);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1121;
            this.match(StudyPeriod.DRUG_EXPOSURE_CONCEPT_ATTRIBUTE);
            this.state = 1122;
            localContext._op = this.tokenStream.LT(1);
            _la = this.tokenStream.LA(1);
            if(!(_la === 88 || _la === 94)) {
                localContext._op = this.errorHandler.recoverInline(this);
            }
            else {
                this.errorHandler.reportMatch(this);
                this.consume();
            }
            this.state = 1123;
            this.match(StudyPeriod.CONCEPT);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public drug_exposure_numeric_filters(): Drug_exposure_numeric_filtersContext {
        let localContext = new Drug_exposure_numeric_filtersContext(this.context, this.state);
        this.enterRule(localContext, 204, StudyPeriod.RULE_drug_exposure_numeric_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1125;
            this.match(StudyPeriod.NF);
            this.state = 1126;
            this.match(StudyPeriod.OPEN_PAREN);
            this.state = 1129;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case StudyPeriod.QUANTITY:
                {
                this.state = 1127;
                this.drug_exposure_float_filter();
                }
                break;
            case StudyPeriod.DRUG_EXPOSURE_INT_ATTRIBUTE:
                {
                this.state = 1128;
                this.drug_exposure_int_filter();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
            this.state = 1131;
            this.match(StudyPeriod.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public drug_exposure_float_filter(): Drug_exposure_float_filterContext {
        let localContext = new Drug_exposure_float_filterContext(this.context, this.state);
        this.enterRule(localContext, 206, StudyPeriod.RULE_drug_exposure_float_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1133;
            this.match(StudyPeriod.QUANTITY);
            this.state = 1134;
            this.comparison_op();
            this.state = 1135;
            this.simple_event_float();
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public drug_exposure_int_filter(): Drug_exposure_int_filterContext {
        let localContext = new Drug_exposure_int_filterContext(this.context, this.state);
        this.enterRule(localContext, 208, StudyPeriod.RULE_drug_exposure_int_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1137;
            this.match(StudyPeriod.DRUG_EXPOSURE_INT_ATTRIBUTE);
            this.state = 1138;
            this.comparison_op();
            this.state = 1139;
            this.simple_event_int();
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public drug_exposure_uniqueness_filters(): Drug_exposure_uniqueness_filtersContext {
        let localContext = new Drug_exposure_uniqueness_filtersContext(this.context, this.state);
        this.enterRule(localContext, 210, StudyPeriod.RULE_drug_exposure_uniqueness_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1141;
            this.match(StudyPeriod.UF);
            this.state = 1142;
            this.match(StudyPeriod.OPEN_PAREN);
            this.state = 1143;
            this.drug_exposure_uniqueness_filter();
            this.state = 1144;
            this.match(StudyPeriod.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public drug_exposure_uniqueness_filter(): Drug_exposure_uniqueness_filterContext {
        let localContext = new Drug_exposure_uniqueness_filterContext(this.context, this.state);
        this.enterRule(localContext, 212, StudyPeriod.RULE_drug_exposure_uniqueness_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1148;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case StudyPeriod.MINIMUM_BETWEEN:
                {
                this.state = 1146;
                this.simple_uniqueness_filter();
                }
                break;
            case StudyPeriod.FIXED_WINDOW:
            case StudyPeriod.ROLLING_WINDOW:
                {
                this.state = 1147;
                this.simple_uniqueness_filter_window();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
            this.state = 1150;
            this.match(StudyPeriod.DRUG_EXPOSURE_DATE_ATTRIBUTE);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public drug_exposure_related_entity_filters(): Drug_exposure_related_entity_filtersContext {
        let localContext = new Drug_exposure_related_entity_filtersContext(this.context, this.state);
        this.enterRule(localContext, 214, StudyPeriod.RULE_drug_exposure_related_entity_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1152;
            this.match(StudyPeriod.RF);
            this.state = 1153;
            this.match(StudyPeriod.OPEN_PAREN);
            this.state = 1154;
            this.drug_exposure_related_entity_filter();
            this.state = 1155;
            this.match(StudyPeriod.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public drug_exposure_related_entity_filter(): Drug_exposure_related_entity_filterContext {
        let localContext = new Drug_exposure_related_entity_filterContext(this.context, this.state);
        this.enterRule(localContext, 216, StudyPeriod.RULE_drug_exposure_related_entity_filter);
        try {
            this.state = 1159;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case StudyPeriod.PROVIDER:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 1157;
                this.provider_sub_filter();
                }
                break;
            case StudyPeriod.VISIT_OCCURRENCE:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 1158;
                this.visit_occurrence_sub_filter();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public drug_exposure_error_filter(): Drug_exposure_error_filterContext {
        let localContext = new Drug_exposure_error_filterContext(this.context, this.state);
        this.enterRule(localContext, 218, StudyPeriod.RULE_drug_exposure_error_filter);
        let _la: number;
        try {
            this.state = 1268;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 58, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 1161;
                this.match(StudyPeriod.CF);
                this.state = 1162;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1163;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 1164;
                this.match(StudyPeriod.CF);
                this.state = 1165;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1166;
                this.match(StudyPeriod.DRUG_EXPOSURE_CONCEPT_ATTRIBUTE);
                this.state = 1167;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 1168;
                this.match(StudyPeriod.CF);
                this.state = 1169;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1170;
                this.match(StudyPeriod.DRUG_EXPOSURE_CONCEPT_ATTRIBUTE);
                this.state = 1171;
                this.match(StudyPeriod.IN);
                this.state = 1172;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 1173;
                this.match(StudyPeriod.CF);
                this.state = 1174;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1175;
                this.match(StudyPeriod.DRUG_EXPOSURE_CONCEPT_ATTRIBUTE);
                this.state = 1176;
                localContext._op = this.tokenStream.LT(1);
                _la = this.tokenStream.LA(1);
                if(!(_la === 88 || _la === 94)) {
                    localContext._op = this.errorHandler.recoverInline(this);
                }
                else {
                    this.errorHandler.reportMatch(this);
                    this.consume();
                }
                this.state = 1177;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 5:
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 1178;
                this.match(StudyPeriod.NF);
                this.state = 1179;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1180;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 6:
                this.enterOuterAlt(localContext, 6);
                {
                this.state = 1181;
                this.match(StudyPeriod.NF);
                this.state = 1182;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1183;
                this.match(StudyPeriod.QUANTITY);
                this.state = 1184;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 7:
                this.enterOuterAlt(localContext, 7);
                {
                this.state = 1185;
                this.match(StudyPeriod.NF);
                this.state = 1186;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1187;
                this.match(StudyPeriod.QUANTITY);
                this.state = 1188;
                this.comparison_op();
                this.state = 1189;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 8:
                this.enterOuterAlt(localContext, 8);
                {
                this.state = 1191;
                this.match(StudyPeriod.NF);
                this.state = 1192;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1193;
                this.match(StudyPeriod.DRUG_EXPOSURE_INT_ATTRIBUTE);
                this.state = 1194;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 9:
                this.enterOuterAlt(localContext, 9);
                {
                this.state = 1195;
                this.match(StudyPeriod.NF);
                this.state = 1196;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1197;
                this.match(StudyPeriod.DRUG_EXPOSURE_INT_ATTRIBUTE);
                this.state = 1198;
                this.comparison_op();
                this.state = 1199;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 10:
                this.enterOuterAlt(localContext, 10);
                {
                this.state = 1201;
                this.match(StudyPeriod.UF);
                this.state = 1202;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1203;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 11:
                this.enterOuterAlt(localContext, 11);
                {
                this.state = 1204;
                this.match(StudyPeriod.UF);
                this.state = 1205;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1206;
                this.match(StudyPeriod.MINIMUM_BETWEEN);
                this.state = 1207;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 12:
                this.enterOuterAlt(localContext, 12);
                {
                this.state = 1208;
                this.match(StudyPeriod.UF);
                this.state = 1209;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1210;
                this.match(StudyPeriod.MINIMUM_BETWEEN);
                this.state = 1211;
                this.simple_event_int();
                this.state = 1212;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 13:
                this.enterOuterAlt(localContext, 13);
                {
                this.state = 1214;
                this.match(StudyPeriod.UF);
                this.state = 1215;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1216;
                this.match(StudyPeriod.MINIMUM_BETWEEN);
                this.state = 1217;
                this.simple_event_int();
                this.state = 1218;
                this.match(StudyPeriod.TIME_UNIT);
                this.state = 1219;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 14:
                this.enterOuterAlt(localContext, 14);
                {
                this.state = 1221;
                this.match(StudyPeriod.UF);
                this.state = 1222;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1223;
                this.match(StudyPeriod.FIXED_WINDOW);
                this.state = 1224;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 15:
                this.enterOuterAlt(localContext, 15);
                {
                this.state = 1225;
                this.match(StudyPeriod.UF);
                this.state = 1226;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1227;
                this.match(StudyPeriod.FIXED_WINDOW);
                this.state = 1228;
                this.simple_event_int();
                this.state = 1229;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 16:
                this.enterOuterAlt(localContext, 16);
                {
                this.state = 1231;
                this.match(StudyPeriod.UF);
                this.state = 1232;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1233;
                this.match(StudyPeriod.FIXED_WINDOW);
                this.state = 1234;
                this.simple_event_int();
                this.state = 1235;
                this.match(StudyPeriod.TIME_UNIT);
                this.state = 1236;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 17:
                this.enterOuterAlt(localContext, 17);
                {
                this.state = 1238;
                this.match(StudyPeriod.UF);
                this.state = 1239;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1240;
                this.match(StudyPeriod.ROLLING_WINDOW);
                this.state = 1241;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 18:
                this.enterOuterAlt(localContext, 18);
                {
                this.state = 1242;
                this.match(StudyPeriod.UF);
                this.state = 1243;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1244;
                this.match(StudyPeriod.ROLLING_WINDOW);
                this.state = 1245;
                this.simple_event_int();
                this.state = 1246;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 19:
                this.enterOuterAlt(localContext, 19);
                {
                this.state = 1248;
                this.match(StudyPeriod.UF);
                this.state = 1249;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1250;
                this.match(StudyPeriod.ROLLING_WINDOW);
                this.state = 1251;
                this.simple_event_int();
                this.state = 1252;
                this.match(StudyPeriod.TIME_UNIT);
                this.state = 1253;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 20:
                this.enterOuterAlt(localContext, 20);
                {
                this.state = 1255;
                this.match(StudyPeriod.RF);
                this.state = 1256;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1257;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 21:
                this.enterOuterAlt(localContext, 21);
                {
                this.state = 1258;
                this.match(StudyPeriod.RF);
                this.state = 1259;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1260;
                this.provider_error_sub_filter();
                this.state = 1261;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 22:
                this.enterOuterAlt(localContext, 22);
                {
                this.state = 1263;
                this.match(StudyPeriod.RF);
                this.state = 1264;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1265;
                this.visit_occurrence_error_sub_filter();
                this.state = 1266;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public measurement_event_criteria(): Measurement_event_criteriaContext {
        let localContext = new Measurement_event_criteriaContext(this.context, this.state);
        this.enterRule(localContext, 220, StudyPeriod.RULE_measurement_event_criteria);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1270;
            this.measurement_event_filter();
            this.state = 1275;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            while (_la === 87) {
                {
                {
                this.state = 1271;
                this.match(StudyPeriod.COMMA);
                this.state = 1272;
                this.measurement_event_filter();
                }
                }
                this.state = 1277;
                this.errorHandler.sync(this);
                _la = this.tokenStream.LA(1);
            }
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public measurement_event_filter(): Measurement_event_filterContext {
        let localContext = new Measurement_event_filterContext(this.context, this.state);
        this.enterRule(localContext, 222, StudyPeriod.RULE_measurement_event_filter);
        try {
            this.state = 1283;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 60, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 1278;
                this.measurement_concept_filters();
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 1279;
                this.measurement_numeric_filters();
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 1280;
                this.measurement_uniqueness_filters();
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 1281;
                this.measurement_related_entity_filters();
                }
                break;
            case 5:
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 1282;
                this.measurement_error_filter();
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public measurement_concept_filters(): Measurement_concept_filtersContext {
        let localContext = new Measurement_concept_filtersContext(this.context, this.state);
        this.enterRule(localContext, 224, StudyPeriod.RULE_measurement_concept_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1285;
            this.match(StudyPeriod.CF);
            this.state = 1286;
            this.match(StudyPeriod.OPEN_PAREN);
            this.state = 1289;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 61, this.context) ) {
            case 1:
                {
                this.state = 1287;
                this.measurement_concept_group_filter();
                }
                break;
            case 2:
                {
                this.state = 1288;
                this.measurement_concept_filter();
                }
                break;
            }
            this.state = 1291;
            this.match(StudyPeriod.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public measurement_concept_group_filter(): Measurement_concept_group_filterContext {
        let localContext = new Measurement_concept_group_filterContext(this.context, this.state);
        this.enterRule(localContext, 226, StudyPeriod.RULE_measurement_concept_group_filter);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1293;
            localContext._attr = this.tokenStream.LT(1);
            _la = this.tokenStream.LA(1);
            if(!(_la === 167 || _la === 173)) {
                localContext._attr = this.errorHandler.recoverInline(this);
            }
            else {
                this.errorHandler.reportMatch(this);
                this.consume();
            }
            this.state = 1294;
            this.match(StudyPeriod.IN);
            this.state = 1295;
            this.concept_group_selection();
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public measurement_concept_filter(): Measurement_concept_filterContext {
        let localContext = new Measurement_concept_filterContext(this.context, this.state);
        this.enterRule(localContext, 228, StudyPeriod.RULE_measurement_concept_filter);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1297;
            localContext._attr = this.tokenStream.LT(1);
            _la = this.tokenStream.LA(1);
            if(!(_la === 167 || _la === 173)) {
                localContext._attr = this.errorHandler.recoverInline(this);
            }
            else {
                this.errorHandler.reportMatch(this);
                this.consume();
            }
            this.state = 1298;
            localContext._op = this.tokenStream.LT(1);
            _la = this.tokenStream.LA(1);
            if(!(_la === 88 || _la === 94)) {
                localContext._op = this.errorHandler.recoverInline(this);
            }
            else {
                this.errorHandler.reportMatch(this);
                this.consume();
            }
            this.state = 1299;
            this.match(StudyPeriod.CONCEPT);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public measurement_numeric_filters(): Measurement_numeric_filtersContext {
        let localContext = new Measurement_numeric_filtersContext(this.context, this.state);
        this.enterRule(localContext, 230, StudyPeriod.RULE_measurement_numeric_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1301;
            this.match(StudyPeriod.NF);
            this.state = 1302;
            this.match(StudyPeriod.OPEN_PAREN);
            this.state = 1303;
            this.measurement_float_filter();
            this.state = 1304;
            this.match(StudyPeriod.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public measurement_float_filter(): Measurement_float_filterContext {
        let localContext = new Measurement_float_filterContext(this.context, this.state);
        this.enterRule(localContext, 232, StudyPeriod.RULE_measurement_float_filter);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1306;
            _la = this.tokenStream.LA(1);
            if(!(_la === 161 || _la === 163)) {
            this.errorHandler.recoverInline(this);
            }
            else {
                this.errorHandler.reportMatch(this);
                this.consume();
            }
            this.state = 1307;
            this.comparison_op();
            this.state = 1308;
            this.simple_event_float();
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public measurement_uniqueness_filters(): Measurement_uniqueness_filtersContext {
        let localContext = new Measurement_uniqueness_filtersContext(this.context, this.state);
        this.enterRule(localContext, 234, StudyPeriod.RULE_measurement_uniqueness_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1310;
            this.match(StudyPeriod.UF);
            this.state = 1311;
            this.match(StudyPeriod.OPEN_PAREN);
            this.state = 1312;
            this.measurement_uniqueness_filter();
            this.state = 1313;
            this.match(StudyPeriod.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public measurement_uniqueness_filter(): Measurement_uniqueness_filterContext {
        let localContext = new Measurement_uniqueness_filterContext(this.context, this.state);
        this.enterRule(localContext, 236, StudyPeriod.RULE_measurement_uniqueness_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1317;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case StudyPeriod.MINIMUM_BETWEEN:
                {
                this.state = 1315;
                this.simple_uniqueness_filter();
                }
                break;
            case StudyPeriod.FIXED_WINDOW:
            case StudyPeriod.ROLLING_WINDOW:
                {
                this.state = 1316;
                this.simple_uniqueness_filter_window();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
            this.state = 1319;
            this.match(StudyPeriod.MEASUREMENT_DATE_ATTRIBUTE);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public measurement_related_entity_filters(): Measurement_related_entity_filtersContext {
        let localContext = new Measurement_related_entity_filtersContext(this.context, this.state);
        this.enterRule(localContext, 238, StudyPeriod.RULE_measurement_related_entity_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1321;
            this.match(StudyPeriod.RF);
            this.state = 1322;
            this.match(StudyPeriod.OPEN_PAREN);
            this.state = 1323;
            this.measurement_related_entity_filter();
            this.state = 1324;
            this.match(StudyPeriod.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public measurement_related_entity_filter(): Measurement_related_entity_filterContext {
        let localContext = new Measurement_related_entity_filterContext(this.context, this.state);
        this.enterRule(localContext, 240, StudyPeriod.RULE_measurement_related_entity_filter);
        try {
            this.state = 1328;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case StudyPeriod.PROVIDER:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 1326;
                this.provider_sub_filter();
                }
                break;
            case StudyPeriod.VISIT_OCCURRENCE:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 1327;
                this.visit_occurrence_sub_filter();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public measurement_error_filter(): Measurement_error_filterContext {
        let localContext = new Measurement_error_filterContext(this.context, this.state);
        this.enterRule(localContext, 242, StudyPeriod.RULE_measurement_error_filter);
        let _la: number;
        try {
            this.state = 1441;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 64, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 1330;
                this.match(StudyPeriod.CF);
                this.state = 1331;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1332;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 1333;
                this.match(StudyPeriod.CF);
                this.state = 1334;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1335;
                this.match(StudyPeriod.MEASUREMENT_CONCEPT_ATTRIBUTE);
                this.state = 1336;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 1337;
                this.match(StudyPeriod.CF);
                this.state = 1338;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1339;
                this.match(StudyPeriod.MEASUREMENT_CONCEPT_ATTRIBUTE);
                this.state = 1340;
                this.match(StudyPeriod.IN);
                this.state = 1341;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 1342;
                this.match(StudyPeriod.CF);
                this.state = 1343;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1344;
                this.match(StudyPeriod.MEASUREMENT_CONCEPT_ATTRIBUTE);
                this.state = 1345;
                localContext._op = this.tokenStream.LT(1);
                _la = this.tokenStream.LA(1);
                if(!(_la === 88 || _la === 94)) {
                    localContext._op = this.errorHandler.recoverInline(this);
                }
                else {
                    this.errorHandler.reportMatch(this);
                    this.consume();
                }
                this.state = 1346;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 5:
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 1347;
                this.match(StudyPeriod.CF);
                this.state = 1348;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1349;
                this.match(StudyPeriod.COMMON_CONCEPT_ATTRIBUTE);
                this.state = 1350;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 6:
                this.enterOuterAlt(localContext, 6);
                {
                this.state = 1351;
                this.match(StudyPeriod.CF);
                this.state = 1352;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1353;
                this.match(StudyPeriod.COMMON_CONCEPT_ATTRIBUTE);
                this.state = 1354;
                this.match(StudyPeriod.IN);
                this.state = 1355;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 7:
                this.enterOuterAlt(localContext, 7);
                {
                this.state = 1356;
                this.match(StudyPeriod.CF);
                this.state = 1357;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1358;
                this.match(StudyPeriod.COMMON_CONCEPT_ATTRIBUTE);
                this.state = 1359;
                localContext._op = this.tokenStream.LT(1);
                _la = this.tokenStream.LA(1);
                if(!(_la === 88 || _la === 94)) {
                    localContext._op = this.errorHandler.recoverInline(this);
                }
                else {
                    this.errorHandler.reportMatch(this);
                    this.consume();
                }
                this.state = 1360;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 8:
                this.enterOuterAlt(localContext, 8);
                {
                this.state = 1361;
                this.match(StudyPeriod.NF);
                this.state = 1362;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1363;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 9:
                this.enterOuterAlt(localContext, 9);
                {
                this.state = 1364;
                this.match(StudyPeriod.NF);
                this.state = 1365;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1366;
                _la = this.tokenStream.LA(1);
                if(!(_la === 161 || _la === 163)) {
                this.errorHandler.recoverInline(this);
                }
                else {
                    this.errorHandler.reportMatch(this);
                    this.consume();
                }
                this.state = 1367;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 10:
                this.enterOuterAlt(localContext, 10);
                {
                this.state = 1368;
                this.match(StudyPeriod.NF);
                this.state = 1369;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1370;
                _la = this.tokenStream.LA(1);
                if(!(_la === 161 || _la === 163)) {
                this.errorHandler.recoverInline(this);
                }
                else {
                    this.errorHandler.reportMatch(this);
                    this.consume();
                }
                this.state = 1371;
                this.comparison_op();
                this.state = 1372;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 11:
                this.enterOuterAlt(localContext, 11);
                {
                this.state = 1374;
                this.match(StudyPeriod.UF);
                this.state = 1375;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1376;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 12:
                this.enterOuterAlt(localContext, 12);
                {
                this.state = 1377;
                this.match(StudyPeriod.UF);
                this.state = 1378;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1379;
                this.match(StudyPeriod.MINIMUM_BETWEEN);
                this.state = 1380;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 13:
                this.enterOuterAlt(localContext, 13);
                {
                this.state = 1381;
                this.match(StudyPeriod.UF);
                this.state = 1382;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1383;
                this.match(StudyPeriod.MINIMUM_BETWEEN);
                this.state = 1384;
                this.simple_event_int();
                this.state = 1385;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 14:
                this.enterOuterAlt(localContext, 14);
                {
                this.state = 1387;
                this.match(StudyPeriod.UF);
                this.state = 1388;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1389;
                this.match(StudyPeriod.MINIMUM_BETWEEN);
                this.state = 1390;
                this.simple_event_int();
                this.state = 1391;
                this.match(StudyPeriod.TIME_UNIT);
                this.state = 1392;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 15:
                this.enterOuterAlt(localContext, 15);
                {
                this.state = 1394;
                this.match(StudyPeriod.UF);
                this.state = 1395;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1396;
                this.match(StudyPeriod.FIXED_WINDOW);
                this.state = 1397;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 16:
                this.enterOuterAlt(localContext, 16);
                {
                this.state = 1398;
                this.match(StudyPeriod.UF);
                this.state = 1399;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1400;
                this.match(StudyPeriod.FIXED_WINDOW);
                this.state = 1401;
                this.simple_event_int();
                this.state = 1402;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 17:
                this.enterOuterAlt(localContext, 17);
                {
                this.state = 1404;
                this.match(StudyPeriod.UF);
                this.state = 1405;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1406;
                this.match(StudyPeriod.FIXED_WINDOW);
                this.state = 1407;
                this.simple_event_int();
                this.state = 1408;
                this.match(StudyPeriod.TIME_UNIT);
                this.state = 1409;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 18:
                this.enterOuterAlt(localContext, 18);
                {
                this.state = 1411;
                this.match(StudyPeriod.UF);
                this.state = 1412;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1413;
                this.match(StudyPeriod.ROLLING_WINDOW);
                this.state = 1414;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 19:
                this.enterOuterAlt(localContext, 19);
                {
                this.state = 1415;
                this.match(StudyPeriod.UF);
                this.state = 1416;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1417;
                this.match(StudyPeriod.ROLLING_WINDOW);
                this.state = 1418;
                this.simple_event_int();
                this.state = 1419;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 20:
                this.enterOuterAlt(localContext, 20);
                {
                this.state = 1421;
                this.match(StudyPeriod.UF);
                this.state = 1422;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1423;
                this.match(StudyPeriod.ROLLING_WINDOW);
                this.state = 1424;
                this.simple_event_int();
                this.state = 1425;
                this.match(StudyPeriod.TIME_UNIT);
                this.state = 1426;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 21:
                this.enterOuterAlt(localContext, 21);
                {
                this.state = 1428;
                this.match(StudyPeriod.RF);
                this.state = 1429;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1430;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 22:
                this.enterOuterAlt(localContext, 22);
                {
                this.state = 1431;
                this.match(StudyPeriod.RF);
                this.state = 1432;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1433;
                this.provider_error_sub_filter();
                this.state = 1434;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 23:
                this.enterOuterAlt(localContext, 23);
                {
                this.state = 1436;
                this.match(StudyPeriod.RF);
                this.state = 1437;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1438;
                this.visit_occurrence_error_sub_filter();
                this.state = 1439;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public observation_event_criteria(): Observation_event_criteriaContext {
        let localContext = new Observation_event_criteriaContext(this.context, this.state);
        this.enterRule(localContext, 244, StudyPeriod.RULE_observation_event_criteria);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1443;
            this.observation_event_filter();
            this.state = 1448;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            while (_la === 87) {
                {
                {
                this.state = 1444;
                this.match(StudyPeriod.COMMA);
                this.state = 1445;
                this.observation_event_filter();
                }
                }
                this.state = 1450;
                this.errorHandler.sync(this);
                _la = this.tokenStream.LA(1);
            }
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public observation_event_filter(): Observation_event_filterContext {
        let localContext = new Observation_event_filterContext(this.context, this.state);
        this.enterRule(localContext, 246, StudyPeriod.RULE_observation_event_filter);
        try {
            this.state = 1456;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 66, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 1451;
                this.observation_concept_filters();
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 1452;
                this.observation_numeric_filters();
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 1453;
                this.observation_uniqueness_filters();
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 1454;
                this.observation_related_entity_filters();
                }
                break;
            case 5:
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 1455;
                this.observation_error_filter();
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public observation_concept_filters(): Observation_concept_filtersContext {
        let localContext = new Observation_concept_filtersContext(this.context, this.state);
        this.enterRule(localContext, 248, StudyPeriod.RULE_observation_concept_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1458;
            this.match(StudyPeriod.CF);
            this.state = 1459;
            this.match(StudyPeriod.OPEN_PAREN);
            this.state = 1462;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 67, this.context) ) {
            case 1:
                {
                this.state = 1460;
                this.observation_concept_group_filter();
                }
                break;
            case 2:
                {
                this.state = 1461;
                this.observation_concept_filter();
                }
                break;
            }
            this.state = 1464;
            this.match(StudyPeriod.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public observation_concept_group_filter(): Observation_concept_group_filterContext {
        let localContext = new Observation_concept_group_filterContext(this.context, this.state);
        this.enterRule(localContext, 250, StudyPeriod.RULE_observation_concept_group_filter);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1466;
            localContext._attr = this.tokenStream.LT(1);
            _la = this.tokenStream.LA(1);
            if(!(_la === 168 || _la === 173)) {
                localContext._attr = this.errorHandler.recoverInline(this);
            }
            else {
                this.errorHandler.reportMatch(this);
                this.consume();
            }
            this.state = 1467;
            this.match(StudyPeriod.IN);
            this.state = 1468;
            this.concept_group_selection();
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public observation_concept_filter(): Observation_concept_filterContext {
        let localContext = new Observation_concept_filterContext(this.context, this.state);
        this.enterRule(localContext, 252, StudyPeriod.RULE_observation_concept_filter);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1470;
            localContext._attr = this.tokenStream.LT(1);
            _la = this.tokenStream.LA(1);
            if(!(_la === 168 || _la === 173)) {
                localContext._attr = this.errorHandler.recoverInline(this);
            }
            else {
                this.errorHandler.reportMatch(this);
                this.consume();
            }
            this.state = 1471;
            localContext._op = this.tokenStream.LT(1);
            _la = this.tokenStream.LA(1);
            if(!(_la === 88 || _la === 94)) {
                localContext._op = this.errorHandler.recoverInline(this);
            }
            else {
                this.errorHandler.reportMatch(this);
                this.consume();
            }
            this.state = 1472;
            this.match(StudyPeriod.CONCEPT);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public observation_numeric_filters(): Observation_numeric_filtersContext {
        let localContext = new Observation_numeric_filtersContext(this.context, this.state);
        this.enterRule(localContext, 254, StudyPeriod.RULE_observation_numeric_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1474;
            this.match(StudyPeriod.NF);
            this.state = 1475;
            this.match(StudyPeriod.OPEN_PAREN);
            {
            this.state = 1476;
            this.observation_float_filter();
            }
            this.state = 1477;
            this.match(StudyPeriod.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public observation_float_filter(): Observation_float_filterContext {
        let localContext = new Observation_float_filterContext(this.context, this.state);
        this.enterRule(localContext, 256, StudyPeriod.RULE_observation_float_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1479;
            this.match(StudyPeriod.COMMON_NUMERIC_FLOAT_ATTRIBUTE);
            this.state = 1480;
            this.comparison_op();
            this.state = 1481;
            this.simple_event_float();
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public observation_uniqueness_filters(): Observation_uniqueness_filtersContext {
        let localContext = new Observation_uniqueness_filtersContext(this.context, this.state);
        this.enterRule(localContext, 258, StudyPeriod.RULE_observation_uniqueness_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1483;
            this.match(StudyPeriod.UF);
            this.state = 1484;
            this.match(StudyPeriod.OPEN_PAREN);
            this.state = 1485;
            this.observation_uniqueness_filter();
            this.state = 1486;
            this.match(StudyPeriod.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public observation_uniqueness_filter(): Observation_uniqueness_filterContext {
        let localContext = new Observation_uniqueness_filterContext(this.context, this.state);
        this.enterRule(localContext, 260, StudyPeriod.RULE_observation_uniqueness_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1490;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case StudyPeriod.MINIMUM_BETWEEN:
                {
                this.state = 1488;
                this.simple_uniqueness_filter();
                }
                break;
            case StudyPeriod.FIXED_WINDOW:
            case StudyPeriod.ROLLING_WINDOW:
                {
                this.state = 1489;
                this.simple_uniqueness_filter_window();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
            this.state = 1492;
            this.match(StudyPeriod.OBSERVATION_DATE_ATTRIBUTE);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public observation_related_entity_filters(): Observation_related_entity_filtersContext {
        let localContext = new Observation_related_entity_filtersContext(this.context, this.state);
        this.enterRule(localContext, 262, StudyPeriod.RULE_observation_related_entity_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1494;
            this.match(StudyPeriod.RF);
            this.state = 1495;
            this.match(StudyPeriod.OPEN_PAREN);
            this.state = 1496;
            this.observation_related_entity_filter();
            this.state = 1497;
            this.match(StudyPeriod.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public observation_related_entity_filter(): Observation_related_entity_filterContext {
        let localContext = new Observation_related_entity_filterContext(this.context, this.state);
        this.enterRule(localContext, 264, StudyPeriod.RULE_observation_related_entity_filter);
        try {
            this.state = 1501;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case StudyPeriod.PROVIDER:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 1499;
                this.provider_sub_filter();
                }
                break;
            case StudyPeriod.VISIT_OCCURRENCE:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 1500;
                this.visit_occurrence_sub_filter();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public observation_error_filter(): Observation_error_filterContext {
        let localContext = new Observation_error_filterContext(this.context, this.state);
        this.enterRule(localContext, 266, StudyPeriod.RULE_observation_error_filter);
        let _la: number;
        try {
            this.state = 1614;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 70, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 1503;
                this.match(StudyPeriod.CF);
                this.state = 1504;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1505;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 1506;
                this.match(StudyPeriod.CF);
                this.state = 1507;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1508;
                this.match(StudyPeriod.OBSERVATION_CONCEPT_ATTRIBUTE);
                this.state = 1509;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 1510;
                this.match(StudyPeriod.CF);
                this.state = 1511;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1512;
                this.match(StudyPeriod.OBSERVATION_CONCEPT_ATTRIBUTE);
                this.state = 1513;
                this.match(StudyPeriod.IN);
                this.state = 1514;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 1515;
                this.match(StudyPeriod.CF);
                this.state = 1516;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1517;
                this.match(StudyPeriod.OBSERVATION_CONCEPT_ATTRIBUTE);
                this.state = 1518;
                localContext._op = this.tokenStream.LT(1);
                _la = this.tokenStream.LA(1);
                if(!(_la === 88 || _la === 94)) {
                    localContext._op = this.errorHandler.recoverInline(this);
                }
                else {
                    this.errorHandler.reportMatch(this);
                    this.consume();
                }
                this.state = 1519;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 5:
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 1520;
                this.match(StudyPeriod.CF);
                this.state = 1521;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1522;
                this.match(StudyPeriod.COMMON_CONCEPT_ATTRIBUTE);
                this.state = 1523;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 6:
                this.enterOuterAlt(localContext, 6);
                {
                this.state = 1524;
                this.match(StudyPeriod.CF);
                this.state = 1525;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1526;
                this.match(StudyPeriod.COMMON_CONCEPT_ATTRIBUTE);
                this.state = 1527;
                this.match(StudyPeriod.IN);
                this.state = 1528;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 7:
                this.enterOuterAlt(localContext, 7);
                {
                this.state = 1529;
                this.match(StudyPeriod.CF);
                this.state = 1530;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1531;
                this.match(StudyPeriod.COMMON_CONCEPT_ATTRIBUTE);
                this.state = 1532;
                localContext._op = this.tokenStream.LT(1);
                _la = this.tokenStream.LA(1);
                if(!(_la === 88 || _la === 94)) {
                    localContext._op = this.errorHandler.recoverInline(this);
                }
                else {
                    this.errorHandler.reportMatch(this);
                    this.consume();
                }
                this.state = 1533;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 8:
                this.enterOuterAlt(localContext, 8);
                {
                this.state = 1534;
                this.match(StudyPeriod.NF);
                this.state = 1535;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1536;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 9:
                this.enterOuterAlt(localContext, 9);
                {
                this.state = 1537;
                this.match(StudyPeriod.NF);
                this.state = 1538;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1539;
                this.match(StudyPeriod.COMMON_NUMERIC_FLOAT_ATTRIBUTE);
                this.state = 1540;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 10:
                this.enterOuterAlt(localContext, 10);
                {
                this.state = 1541;
                this.match(StudyPeriod.NF);
                this.state = 1542;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1543;
                this.match(StudyPeriod.COMMON_NUMERIC_FLOAT_ATTRIBUTE);
                this.state = 1544;
                this.comparison_op();
                this.state = 1545;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 11:
                this.enterOuterAlt(localContext, 11);
                {
                this.state = 1547;
                this.match(StudyPeriod.UF);
                this.state = 1548;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1549;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 12:
                this.enterOuterAlt(localContext, 12);
                {
                this.state = 1550;
                this.match(StudyPeriod.UF);
                this.state = 1551;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1552;
                this.match(StudyPeriod.MINIMUM_BETWEEN);
                this.state = 1553;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 13:
                this.enterOuterAlt(localContext, 13);
                {
                this.state = 1554;
                this.match(StudyPeriod.UF);
                this.state = 1555;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1556;
                this.match(StudyPeriod.MINIMUM_BETWEEN);
                this.state = 1557;
                this.simple_event_int();
                this.state = 1558;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 14:
                this.enterOuterAlt(localContext, 14);
                {
                this.state = 1560;
                this.match(StudyPeriod.UF);
                this.state = 1561;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1562;
                this.match(StudyPeriod.MINIMUM_BETWEEN);
                this.state = 1563;
                this.simple_event_int();
                this.state = 1564;
                this.match(StudyPeriod.TIME_UNIT);
                this.state = 1565;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 15:
                this.enterOuterAlt(localContext, 15);
                {
                this.state = 1567;
                this.match(StudyPeriod.UF);
                this.state = 1568;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1569;
                this.match(StudyPeriod.FIXED_WINDOW);
                this.state = 1570;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 16:
                this.enterOuterAlt(localContext, 16);
                {
                this.state = 1571;
                this.match(StudyPeriod.UF);
                this.state = 1572;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1573;
                this.match(StudyPeriod.FIXED_WINDOW);
                this.state = 1574;
                this.simple_event_int();
                this.state = 1575;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 17:
                this.enterOuterAlt(localContext, 17);
                {
                this.state = 1577;
                this.match(StudyPeriod.UF);
                this.state = 1578;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1579;
                this.match(StudyPeriod.FIXED_WINDOW);
                this.state = 1580;
                this.simple_event_int();
                this.state = 1581;
                this.match(StudyPeriod.TIME_UNIT);
                this.state = 1582;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 18:
                this.enterOuterAlt(localContext, 18);
                {
                this.state = 1584;
                this.match(StudyPeriod.UF);
                this.state = 1585;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1586;
                this.match(StudyPeriod.ROLLING_WINDOW);
                this.state = 1587;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 19:
                this.enterOuterAlt(localContext, 19);
                {
                this.state = 1588;
                this.match(StudyPeriod.UF);
                this.state = 1589;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1590;
                this.match(StudyPeriod.ROLLING_WINDOW);
                this.state = 1591;
                this.simple_event_int();
                this.state = 1592;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 20:
                this.enterOuterAlt(localContext, 20);
                {
                this.state = 1594;
                this.match(StudyPeriod.UF);
                this.state = 1595;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1596;
                this.match(StudyPeriod.ROLLING_WINDOW);
                this.state = 1597;
                this.simple_event_int();
                this.state = 1598;
                this.match(StudyPeriod.TIME_UNIT);
                this.state = 1599;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 21:
                this.enterOuterAlt(localContext, 21);
                {
                this.state = 1601;
                this.match(StudyPeriod.RF);
                this.state = 1602;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1603;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 22:
                this.enterOuterAlt(localContext, 22);
                {
                this.state = 1604;
                this.match(StudyPeriod.RF);
                this.state = 1605;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1606;
                this.provider_error_sub_filter();
                this.state = 1607;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 23:
                this.enterOuterAlt(localContext, 23);
                {
                this.state = 1609;
                this.match(StudyPeriod.RF);
                this.state = 1610;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1611;
                this.visit_occurrence_error_sub_filter();
                this.state = 1612;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public procedure_occurrence_event_criteria(): Procedure_occurrence_event_criteriaContext {
        let localContext = new Procedure_occurrence_event_criteriaContext(this.context, this.state);
        this.enterRule(localContext, 268, StudyPeriod.RULE_procedure_occurrence_event_criteria);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1616;
            this.procedure_occurrence_event_filter();
            this.state = 1621;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            while (_la === 87) {
                {
                {
                this.state = 1617;
                this.match(StudyPeriod.COMMA);
                this.state = 1618;
                this.procedure_occurrence_event_filter();
                }
                }
                this.state = 1623;
                this.errorHandler.sync(this);
                _la = this.tokenStream.LA(1);
            }
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public procedure_occurrence_event_filter(): Procedure_occurrence_event_filterContext {
        let localContext = new Procedure_occurrence_event_filterContext(this.context, this.state);
        this.enterRule(localContext, 270, StudyPeriod.RULE_procedure_occurrence_event_filter);
        try {
            this.state = 1629;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 72, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 1624;
                this.procedure_occurrence_concept_filters();
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 1625;
                this.procedure_occurrence_numeric_filters();
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 1626;
                this.procedure_occurrence_uniqueness_filters();
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 1627;
                this.procedure_occurrence_related_entity_filters();
                }
                break;
            case 5:
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 1628;
                this.procedure_occurrence_error_filter();
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public procedure_occurrence_concept_filters(): Procedure_occurrence_concept_filtersContext {
        let localContext = new Procedure_occurrence_concept_filtersContext(this.context, this.state);
        this.enterRule(localContext, 272, StudyPeriod.RULE_procedure_occurrence_concept_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1631;
            this.match(StudyPeriod.CF);
            this.state = 1632;
            this.match(StudyPeriod.OPEN_PAREN);
            this.state = 1635;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 73, this.context) ) {
            case 1:
                {
                this.state = 1633;
                this.procedure_occurrence_concept_group_filter();
                }
                break;
            case 2:
                {
                this.state = 1634;
                this.procedure_occurrence_concept_filter();
                }
                break;
            }
            this.state = 1637;
            this.match(StudyPeriod.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public procedure_occurrence_concept_group_filter(): Procedure_occurrence_concept_group_filterContext {
        let localContext = new Procedure_occurrence_concept_group_filterContext(this.context, this.state);
        this.enterRule(localContext, 274, StudyPeriod.RULE_procedure_occurrence_concept_group_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1639;
            this.match(StudyPeriod.PROCEDURE_OCCURRENCE_CONCEPT_ATTRIBUTE);
            this.state = 1640;
            this.match(StudyPeriod.IN);
            this.state = 1641;
            this.concept_group_selection();
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public procedure_occurrence_concept_filter(): Procedure_occurrence_concept_filterContext {
        let localContext = new Procedure_occurrence_concept_filterContext(this.context, this.state);
        this.enterRule(localContext, 276, StudyPeriod.RULE_procedure_occurrence_concept_filter);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1643;
            this.match(StudyPeriod.PROCEDURE_OCCURRENCE_CONCEPT_ATTRIBUTE);
            this.state = 1644;
            localContext._op = this.tokenStream.LT(1);
            _la = this.tokenStream.LA(1);
            if(!(_la === 88 || _la === 94)) {
                localContext._op = this.errorHandler.recoverInline(this);
            }
            else {
                this.errorHandler.reportMatch(this);
                this.consume();
            }
            this.state = 1645;
            this.match(StudyPeriod.CONCEPT);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public procedure_occurrence_numeric_filters(): Procedure_occurrence_numeric_filtersContext {
        let localContext = new Procedure_occurrence_numeric_filtersContext(this.context, this.state);
        this.enterRule(localContext, 278, StudyPeriod.RULE_procedure_occurrence_numeric_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1647;
            this.match(StudyPeriod.NF);
            this.state = 1648;
            this.match(StudyPeriod.OPEN_PAREN);
            this.state = 1649;
            this.procedure_occurrence_int_filter();
            this.state = 1650;
            this.match(StudyPeriod.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public procedure_occurrence_int_filter(): Procedure_occurrence_int_filterContext {
        let localContext = new Procedure_occurrence_int_filterContext(this.context, this.state);
        this.enterRule(localContext, 280, StudyPeriod.RULE_procedure_occurrence_int_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1652;
            this.match(StudyPeriod.QUANTITY);
            this.state = 1653;
            this.comparison_op();
            this.state = 1654;
            this.simple_event_int();
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public procedure_occurrence_uniqueness_filters(): Procedure_occurrence_uniqueness_filtersContext {
        let localContext = new Procedure_occurrence_uniqueness_filtersContext(this.context, this.state);
        this.enterRule(localContext, 282, StudyPeriod.RULE_procedure_occurrence_uniqueness_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1656;
            this.match(StudyPeriod.UF);
            this.state = 1657;
            this.match(StudyPeriod.OPEN_PAREN);
            this.state = 1658;
            this.procedure_occurrence_uniqueness_filter();
            this.state = 1659;
            this.match(StudyPeriod.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public procedure_occurrence_uniqueness_filter(): Procedure_occurrence_uniqueness_filterContext {
        let localContext = new Procedure_occurrence_uniqueness_filterContext(this.context, this.state);
        this.enterRule(localContext, 284, StudyPeriod.RULE_procedure_occurrence_uniqueness_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1663;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case StudyPeriod.MINIMUM_BETWEEN:
                {
                this.state = 1661;
                this.simple_uniqueness_filter();
                }
                break;
            case StudyPeriod.FIXED_WINDOW:
            case StudyPeriod.ROLLING_WINDOW:
                {
                this.state = 1662;
                this.simple_uniqueness_filter_window();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
            this.state = 1665;
            this.match(StudyPeriod.PROCEDURE_OCCURRENCE_DATE_ATTRIBUTE);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public procedure_occurrence_related_entity_filters(): Procedure_occurrence_related_entity_filtersContext {
        let localContext = new Procedure_occurrence_related_entity_filtersContext(this.context, this.state);
        this.enterRule(localContext, 286, StudyPeriod.RULE_procedure_occurrence_related_entity_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1667;
            this.match(StudyPeriod.RF);
            this.state = 1668;
            this.match(StudyPeriod.OPEN_PAREN);
            this.state = 1669;
            this.procedure_occurrence_related_entity_filter();
            this.state = 1670;
            this.match(StudyPeriod.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public procedure_occurrence_related_entity_filter(): Procedure_occurrence_related_entity_filterContext {
        let localContext = new Procedure_occurrence_related_entity_filterContext(this.context, this.state);
        this.enterRule(localContext, 288, StudyPeriod.RULE_procedure_occurrence_related_entity_filter);
        try {
            this.state = 1674;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case StudyPeriod.PROVIDER:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 1672;
                this.provider_sub_filter();
                }
                break;
            case StudyPeriod.VISIT_OCCURRENCE:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 1673;
                this.visit_occurrence_sub_filter();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public procedure_occurrence_error_filter(): Procedure_occurrence_error_filterContext {
        let localContext = new Procedure_occurrence_error_filterContext(this.context, this.state);
        this.enterRule(localContext, 290, StudyPeriod.RULE_procedure_occurrence_error_filter);
        let _la: number;
        try {
            this.state = 1773;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 76, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 1676;
                this.match(StudyPeriod.CF);
                this.state = 1677;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1678;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 1679;
                this.match(StudyPeriod.CF);
                this.state = 1680;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1681;
                this.match(StudyPeriod.PROCEDURE_OCCURRENCE_CONCEPT_ATTRIBUTE);
                this.state = 1682;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 1683;
                this.match(StudyPeriod.CF);
                this.state = 1684;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1685;
                this.match(StudyPeriod.PROCEDURE_OCCURRENCE_CONCEPT_ATTRIBUTE);
                this.state = 1686;
                this.match(StudyPeriod.IN);
                this.state = 1687;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 1688;
                this.match(StudyPeriod.CF);
                this.state = 1689;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1690;
                this.match(StudyPeriod.PROCEDURE_OCCURRENCE_CONCEPT_ATTRIBUTE);
                this.state = 1691;
                localContext._op = this.tokenStream.LT(1);
                _la = this.tokenStream.LA(1);
                if(!(_la === 88 || _la === 94)) {
                    localContext._op = this.errorHandler.recoverInline(this);
                }
                else {
                    this.errorHandler.reportMatch(this);
                    this.consume();
                }
                this.state = 1692;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 5:
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 1693;
                this.match(StudyPeriod.NF);
                this.state = 1694;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1695;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 6:
                this.enterOuterAlt(localContext, 6);
                {
                this.state = 1696;
                this.match(StudyPeriod.NF);
                this.state = 1697;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1698;
                this.match(StudyPeriod.QUANTITY);
                this.state = 1699;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 7:
                this.enterOuterAlt(localContext, 7);
                {
                this.state = 1700;
                this.match(StudyPeriod.NF);
                this.state = 1701;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1702;
                this.match(StudyPeriod.QUANTITY);
                this.state = 1703;
                this.comparison_op();
                this.state = 1704;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 8:
                this.enterOuterAlt(localContext, 8);
                {
                this.state = 1706;
                this.match(StudyPeriod.UF);
                this.state = 1707;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1708;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 9:
                this.enterOuterAlt(localContext, 9);
                {
                this.state = 1709;
                this.match(StudyPeriod.UF);
                this.state = 1710;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1711;
                this.match(StudyPeriod.MINIMUM_BETWEEN);
                this.state = 1712;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 10:
                this.enterOuterAlt(localContext, 10);
                {
                this.state = 1713;
                this.match(StudyPeriod.UF);
                this.state = 1714;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1715;
                this.match(StudyPeriod.MINIMUM_BETWEEN);
                this.state = 1716;
                this.simple_event_int();
                this.state = 1717;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 11:
                this.enterOuterAlt(localContext, 11);
                {
                this.state = 1719;
                this.match(StudyPeriod.UF);
                this.state = 1720;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1721;
                this.match(StudyPeriod.MINIMUM_BETWEEN);
                this.state = 1722;
                this.simple_event_int();
                this.state = 1723;
                this.match(StudyPeriod.TIME_UNIT);
                this.state = 1724;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 12:
                this.enterOuterAlt(localContext, 12);
                {
                this.state = 1726;
                this.match(StudyPeriod.UF);
                this.state = 1727;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1728;
                this.match(StudyPeriod.FIXED_WINDOW);
                this.state = 1729;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 13:
                this.enterOuterAlt(localContext, 13);
                {
                this.state = 1730;
                this.match(StudyPeriod.UF);
                this.state = 1731;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1732;
                this.match(StudyPeriod.FIXED_WINDOW);
                this.state = 1733;
                this.simple_event_int();
                this.state = 1734;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 14:
                this.enterOuterAlt(localContext, 14);
                {
                this.state = 1736;
                this.match(StudyPeriod.UF);
                this.state = 1737;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1738;
                this.match(StudyPeriod.FIXED_WINDOW);
                this.state = 1739;
                this.simple_event_int();
                this.state = 1740;
                this.match(StudyPeriod.TIME_UNIT);
                this.state = 1741;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 15:
                this.enterOuterAlt(localContext, 15);
                {
                this.state = 1743;
                this.match(StudyPeriod.UF);
                this.state = 1744;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1745;
                this.match(StudyPeriod.ROLLING_WINDOW);
                this.state = 1746;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 16:
                this.enterOuterAlt(localContext, 16);
                {
                this.state = 1747;
                this.match(StudyPeriod.UF);
                this.state = 1748;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1749;
                this.match(StudyPeriod.ROLLING_WINDOW);
                this.state = 1750;
                this.simple_event_int();
                this.state = 1751;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 17:
                this.enterOuterAlt(localContext, 17);
                {
                this.state = 1753;
                this.match(StudyPeriod.UF);
                this.state = 1754;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1755;
                this.match(StudyPeriod.ROLLING_WINDOW);
                this.state = 1756;
                this.simple_event_int();
                this.state = 1757;
                this.match(StudyPeriod.TIME_UNIT);
                this.state = 1758;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 18:
                this.enterOuterAlt(localContext, 18);
                {
                this.state = 1760;
                this.match(StudyPeriod.RF);
                this.state = 1761;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1762;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 19:
                this.enterOuterAlt(localContext, 19);
                {
                this.state = 1763;
                this.match(StudyPeriod.RF);
                this.state = 1764;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1765;
                this.provider_error_sub_filter();
                this.state = 1766;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 20:
                this.enterOuterAlt(localContext, 20);
                {
                this.state = 1768;
                this.match(StudyPeriod.RF);
                this.state = 1769;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1770;
                this.visit_occurrence_error_sub_filter();
                this.state = 1771;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public provider_concept_filters(): Provider_concept_filtersContext {
        let localContext = new Provider_concept_filtersContext(this.context, this.state);
        this.enterRule(localContext, 292, StudyPeriod.RULE_provider_concept_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1775;
            this.match(StudyPeriod.CF);
            this.state = 1776;
            this.match(StudyPeriod.OPEN_PAREN);
            this.state = 1779;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 77, this.context) ) {
            case 1:
                {
                this.state = 1777;
                this.provider_concept_group_filter();
                }
                break;
            case 2:
                {
                this.state = 1778;
                this.provider_concept_filter();
                }
                break;
            }
            this.state = 1781;
            this.match(StudyPeriod.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public provider_concept_group_filter(): Provider_concept_group_filterContext {
        let localContext = new Provider_concept_group_filterContext(this.context, this.state);
        this.enterRule(localContext, 294, StudyPeriod.RULE_provider_concept_group_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1783;
            this.match(StudyPeriod.PROVIDER_CONCEPT_ATTRIBUTE);
            this.state = 1784;
            this.match(StudyPeriod.IN);
            this.state = 1785;
            this.concept_group_selection();
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public provider_concept_filter(): Provider_concept_filterContext {
        let localContext = new Provider_concept_filterContext(this.context, this.state);
        this.enterRule(localContext, 296, StudyPeriod.RULE_provider_concept_filter);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1787;
            this.match(StudyPeriod.PROVIDER_CONCEPT_ATTRIBUTE);
            this.state = 1788;
            localContext._op = this.tokenStream.LT(1);
            _la = this.tokenStream.LA(1);
            if(!(_la === 88 || _la === 94)) {
                localContext._op = this.errorHandler.recoverInline(this);
            }
            else {
                this.errorHandler.reportMatch(this);
                this.consume();
            }
            this.state = 1789;
            this.match(StudyPeriod.CONCEPT);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public provider_sub_filter(): Provider_sub_filterContext {
        let localContext = new Provider_sub_filterContext(this.context, this.state);
        this.enterRule(localContext, 298, StudyPeriod.RULE_provider_sub_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1791;
            this.match(StudyPeriod.PROVIDER);
            this.state = 1794;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 78, this.context) ) {
            case 1:
                {
                this.state = 1792;
                this.provider_concept_group_filter();
                }
                break;
            case 2:
                {
                this.state = 1793;
                this.provider_concept_filter();
                }
                break;
            }
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public provider_error_sub_filter(): Provider_error_sub_filterContext {
        let localContext = new Provider_error_sub_filterContext(this.context, this.state);
        this.enterRule(localContext, 300, StudyPeriod.RULE_provider_error_sub_filter);
        let _la: number;
        try {
            this.state = 1806;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 79, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                // tslint:disable-next-line:no-empty
                {
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 1797;
                this.match(StudyPeriod.PROVIDER);
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 1798;
                this.match(StudyPeriod.PROVIDER);
                this.state = 1799;
                this.match(StudyPeriod.PROVIDER_CONCEPT_ATTRIBUTE);
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 1800;
                this.match(StudyPeriod.PROVIDER);
                this.state = 1801;
                this.match(StudyPeriod.PROVIDER_CONCEPT_ATTRIBUTE);
                this.state = 1802;
                this.match(StudyPeriod.IN);
                }
                break;
            case 5:
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 1803;
                this.match(StudyPeriod.PROVIDER);
                this.state = 1804;
                this.match(StudyPeriod.PROVIDER_CONCEPT_ATTRIBUTE);
                this.state = 1805;
                localContext._op = this.tokenStream.LT(1);
                _la = this.tokenStream.LA(1);
                if(!(_la === 88 || _la === 94)) {
                    localContext._op = this.errorHandler.recoverInline(this);
                }
                else {
                    this.errorHandler.reportMatch(this);
                    this.consume();
                }
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public visit_occurrence_event_criteria(): Visit_occurrence_event_criteriaContext {
        let localContext = new Visit_occurrence_event_criteriaContext(this.context, this.state);
        this.enterRule(localContext, 302, StudyPeriod.RULE_visit_occurrence_event_criteria);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1808;
            this.visit_occurrence_event_filter();
            this.state = 1813;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            while (_la === 87) {
                {
                {
                this.state = 1809;
                this.match(StudyPeriod.COMMA);
                this.state = 1810;
                this.visit_occurrence_event_filter();
                }
                }
                this.state = 1815;
                this.errorHandler.sync(this);
                _la = this.tokenStream.LA(1);
            }
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public visit_occurrence_event_filter(): Visit_occurrence_event_filterContext {
        let localContext = new Visit_occurrence_event_filterContext(this.context, this.state);
        this.enterRule(localContext, 304, StudyPeriod.RULE_visit_occurrence_event_filter);
        try {
            this.state = 1820;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 81, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 1816;
                this.visit_occurrence_concept_filters();
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 1817;
                this.visit_occurrence_uniqueness_filters();
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 1818;
                this.visit_occurrence_related_entity_filters();
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 1819;
                this.visit_occurrence_error_filter();
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public visit_occurrence_concept_filters(): Visit_occurrence_concept_filtersContext {
        let localContext = new Visit_occurrence_concept_filtersContext(this.context, this.state);
        this.enterRule(localContext, 306, StudyPeriod.RULE_visit_occurrence_concept_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1822;
            this.match(StudyPeriod.CF);
            this.state = 1823;
            this.match(StudyPeriod.OPEN_PAREN);
            this.state = 1826;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 82, this.context) ) {
            case 1:
                {
                this.state = 1824;
                this.visit_occurrence_concept_group_filter();
                }
                break;
            case 2:
                {
                this.state = 1825;
                this.visit_occurrence_concept_filter();
                }
                break;
            }
            this.state = 1828;
            this.match(StudyPeriod.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public visit_occurrence_concept_group_filter(): Visit_occurrence_concept_group_filterContext {
        let localContext = new Visit_occurrence_concept_group_filterContext(this.context, this.state);
        this.enterRule(localContext, 308, StudyPeriod.RULE_visit_occurrence_concept_group_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1830;
            this.match(StudyPeriod.VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE);
            this.state = 1831;
            this.match(StudyPeriod.IN);
            this.state = 1832;
            this.concept_group_selection();
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public visit_occurrence_concept_filter(): Visit_occurrence_concept_filterContext {
        let localContext = new Visit_occurrence_concept_filterContext(this.context, this.state);
        this.enterRule(localContext, 310, StudyPeriod.RULE_visit_occurrence_concept_filter);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1834;
            this.match(StudyPeriod.VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE);
            this.state = 1835;
            localContext._op = this.tokenStream.LT(1);
            _la = this.tokenStream.LA(1);
            if(!(_la === 88 || _la === 94)) {
                localContext._op = this.errorHandler.recoverInline(this);
            }
            else {
                this.errorHandler.reportMatch(this);
                this.consume();
            }
            this.state = 1836;
            this.match(StudyPeriod.CONCEPT);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public visit_occurrence_uniqueness_filters(): Visit_occurrence_uniqueness_filtersContext {
        let localContext = new Visit_occurrence_uniqueness_filtersContext(this.context, this.state);
        this.enterRule(localContext, 312, StudyPeriod.RULE_visit_occurrence_uniqueness_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1838;
            this.match(StudyPeriod.UF);
            this.state = 1839;
            this.match(StudyPeriod.OPEN_PAREN);
            this.state = 1840;
            this.visit_occurrence_uniqueness_filter();
            this.state = 1841;
            this.match(StudyPeriod.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public visit_occurrence_uniqueness_filter(): Visit_occurrence_uniqueness_filterContext {
        let localContext = new Visit_occurrence_uniqueness_filterContext(this.context, this.state);
        this.enterRule(localContext, 314, StudyPeriod.RULE_visit_occurrence_uniqueness_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1845;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case StudyPeriod.MINIMUM_BETWEEN:
                {
                this.state = 1843;
                this.simple_uniqueness_filter();
                }
                break;
            case StudyPeriod.FIXED_WINDOW:
            case StudyPeriod.ROLLING_WINDOW:
                {
                this.state = 1844;
                this.simple_uniqueness_filter_window();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
            this.state = 1847;
            this.match(StudyPeriod.VISIT_OCCURRENCE_DATE_ATTRIBUTE);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public visit_occurrence_related_entity_filters(): Visit_occurrence_related_entity_filtersContext {
        let localContext = new Visit_occurrence_related_entity_filtersContext(this.context, this.state);
        this.enterRule(localContext, 316, StudyPeriod.RULE_visit_occurrence_related_entity_filters);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1849;
            this.match(StudyPeriod.RF);
            this.state = 1850;
            this.match(StudyPeriod.OPEN_PAREN);
            this.state = 1851;
            this.visit_occurrence_related_entity_filter();
            this.state = 1852;
            this.match(StudyPeriod.CLOSE_PAREN);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public visit_occurrence_related_entity_filter(): Visit_occurrence_related_entity_filterContext {
        let localContext = new Visit_occurrence_related_entity_filterContext(this.context, this.state);
        this.enterRule(localContext, 318, StudyPeriod.RULE_visit_occurrence_related_entity_filter);
        try {
            this.state = 1856;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case StudyPeriod.PROVIDER:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 1854;
                this.provider_sub_filter();
                }
                break;
            case StudyPeriod.CONDITION_OCCURRENCE:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 1855;
                this.condition_occurrence_sub_filter();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public visit_occurrence_sub_filter(): Visit_occurrence_sub_filterContext {
        let localContext = new Visit_occurrence_sub_filterContext(this.context, this.state);
        this.enterRule(localContext, 320, StudyPeriod.RULE_visit_occurrence_sub_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1858;
            this.match(StudyPeriod.VISIT_OCCURRENCE);
            this.state = 1861;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 85, this.context) ) {
            case 1:
                {
                this.state = 1859;
                this.visit_occurrence_concept_group_filter();
                }
                break;
            case 2:
                {
                this.state = 1860;
                this.visit_occurrence_concept_filter();
                }
                break;
            }
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public visit_occurrence_error_sub_filter(): Visit_occurrence_error_sub_filterContext {
        let localContext = new Visit_occurrence_error_sub_filterContext(this.context, this.state);
        this.enterRule(localContext, 322, StudyPeriod.RULE_visit_occurrence_error_sub_filter);
        let _la: number;
        try {
            this.state = 1873;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 86, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                // tslint:disable-next-line:no-empty
                {
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 1864;
                this.match(StudyPeriod.VISIT_OCCURRENCE);
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 1865;
                this.match(StudyPeriod.VISIT_OCCURRENCE);
                this.state = 1866;
                this.match(StudyPeriod.VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE);
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 1867;
                this.match(StudyPeriod.VISIT_OCCURRENCE);
                this.state = 1868;
                this.match(StudyPeriod.VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE);
                this.state = 1869;
                this.match(StudyPeriod.IN);
                }
                break;
            case 5:
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 1870;
                this.match(StudyPeriod.VISIT_OCCURRENCE);
                this.state = 1871;
                this.match(StudyPeriod.VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE);
                this.state = 1872;
                localContext._op = this.tokenStream.LT(1);
                _la = this.tokenStream.LA(1);
                if(!(_la === 88 || _la === 94)) {
                    localContext._op = this.errorHandler.recoverInline(this);
                }
                else {
                    this.errorHandler.reportMatch(this);
                    this.consume();
                }
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public visit_occurrence_error_filter(): Visit_occurrence_error_filterContext {
        let localContext = new Visit_occurrence_error_filterContext(this.context, this.state);
        this.enterRule(localContext, 324, StudyPeriod.RULE_visit_occurrence_error_filter);
        let _la: number;
        try {
            this.state = 1959;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 87, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 1875;
                this.match(StudyPeriod.CF);
                this.state = 1876;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1877;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 1878;
                this.match(StudyPeriod.CF);
                this.state = 1879;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1880;
                this.match(StudyPeriod.VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE);
                this.state = 1881;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 3:
                this.enterOuterAlt(localContext, 3);
                {
                this.state = 1882;
                this.match(StudyPeriod.CF);
                this.state = 1883;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1884;
                this.match(StudyPeriod.VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE);
                this.state = 1885;
                this.match(StudyPeriod.IN);
                this.state = 1886;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 4:
                this.enterOuterAlt(localContext, 4);
                {
                this.state = 1887;
                this.match(StudyPeriod.CF);
                this.state = 1888;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1889;
                this.match(StudyPeriod.VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE);
                this.state = 1890;
                localContext._op = this.tokenStream.LT(1);
                _la = this.tokenStream.LA(1);
                if(!(_la === 88 || _la === 94)) {
                    localContext._op = this.errorHandler.recoverInline(this);
                }
                else {
                    this.errorHandler.reportMatch(this);
                    this.consume();
                }
                this.state = 1891;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 5:
                this.enterOuterAlt(localContext, 5);
                {
                this.state = 1892;
                this.match(StudyPeriod.UF);
                this.state = 1893;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1894;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 6:
                this.enterOuterAlt(localContext, 6);
                {
                this.state = 1895;
                this.match(StudyPeriod.UF);
                this.state = 1896;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1897;
                this.match(StudyPeriod.MINIMUM_BETWEEN);
                this.state = 1898;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 7:
                this.enterOuterAlt(localContext, 7);
                {
                this.state = 1899;
                this.match(StudyPeriod.UF);
                this.state = 1900;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1901;
                this.match(StudyPeriod.MINIMUM_BETWEEN);
                this.state = 1902;
                this.simple_event_int();
                this.state = 1903;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 8:
                this.enterOuterAlt(localContext, 8);
                {
                this.state = 1905;
                this.match(StudyPeriod.UF);
                this.state = 1906;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1907;
                this.match(StudyPeriod.MINIMUM_BETWEEN);
                this.state = 1908;
                this.simple_event_int();
                this.state = 1909;
                this.match(StudyPeriod.TIME_UNIT);
                this.state = 1910;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 9:
                this.enterOuterAlt(localContext, 9);
                {
                this.state = 1912;
                this.match(StudyPeriod.UF);
                this.state = 1913;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1914;
                this.match(StudyPeriod.FIXED_WINDOW);
                this.state = 1915;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 10:
                this.enterOuterAlt(localContext, 10);
                {
                this.state = 1916;
                this.match(StudyPeriod.UF);
                this.state = 1917;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1918;
                this.match(StudyPeriod.FIXED_WINDOW);
                this.state = 1919;
                this.simple_event_int();
                this.state = 1920;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 11:
                this.enterOuterAlt(localContext, 11);
                {
                this.state = 1922;
                this.match(StudyPeriod.UF);
                this.state = 1923;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1924;
                this.match(StudyPeriod.FIXED_WINDOW);
                this.state = 1925;
                this.simple_event_int();
                this.state = 1926;
                this.match(StudyPeriod.TIME_UNIT);
                this.state = 1927;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 12:
                this.enterOuterAlt(localContext, 12);
                {
                this.state = 1929;
                this.match(StudyPeriod.UF);
                this.state = 1930;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1931;
                this.match(StudyPeriod.ROLLING_WINDOW);
                this.state = 1932;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 13:
                this.enterOuterAlt(localContext, 13);
                {
                this.state = 1933;
                this.match(StudyPeriod.UF);
                this.state = 1934;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1935;
                this.match(StudyPeriod.ROLLING_WINDOW);
                this.state = 1936;
                this.simple_event_int();
                this.state = 1937;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 14:
                this.enterOuterAlt(localContext, 14);
                {
                this.state = 1939;
                this.match(StudyPeriod.UF);
                this.state = 1940;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1941;
                this.match(StudyPeriod.ROLLING_WINDOW);
                this.state = 1942;
                this.simple_event_int();
                this.state = 1943;
                this.match(StudyPeriod.TIME_UNIT);
                this.state = 1944;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 15:
                this.enterOuterAlt(localContext, 15);
                {
                this.state = 1946;
                this.match(StudyPeriod.RF);
                this.state = 1947;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1948;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 16:
                this.enterOuterAlt(localContext, 16);
                {
                this.state = 1949;
                this.match(StudyPeriod.RF);
                this.state = 1950;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1951;
                this.provider_error_sub_filter();
                this.state = 1952;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            case 17:
                this.enterOuterAlt(localContext, 17);
                {
                this.state = 1954;
                this.match(StudyPeriod.RF);
                this.state = 1955;
                this.match(StudyPeriod.OPEN_PAREN);
                this.state = 1956;
                this.condition_occurrence_error_sub_filter();
                this.state = 1957;
                this.match(StudyPeriod.CLOSE_PAREN);
                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public comparison_op(): Comparison_opContext {
        let localContext = new Comparison_opContext(this.context, this.state);
        this.enterRule(localContext, 326, StudyPeriod.RULE_comparison_op);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1961;
            _la = this.tokenStream.LA(1);
            if(!(((((_la - 88)) & ~0x1F) === 0 && ((1 << (_la - 88)) & 1985) !== 0))) {
            this.errorHandler.recoverInline(this);
            }
            else {
                this.errorHandler.reportMatch(this);
                this.consume();
            }
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public simple_uniqueness_filter(): Simple_uniqueness_filterContext {
        let localContext = new Simple_uniqueness_filterContext(this.context, this.state);
        this.enterRule(localContext, 328, StudyPeriod.RULE_simple_uniqueness_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1963;
            this.match(StudyPeriod.MINIMUM_BETWEEN);
            this.state = 1964;
            this.simple_event_int();
            this.state = 1965;
            this.match(StudyPeriod.TIME_UNIT);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public simple_uniqueness_filter_window(): Simple_uniqueness_filter_windowContext {
        let localContext = new Simple_uniqueness_filter_windowContext(this.context, this.state);
        this.enterRule(localContext, 330, StudyPeriod.RULE_simple_uniqueness_filter_window);
        try {
            this.state = 1969;
            this.errorHandler.sync(this);
            switch (this.tokenStream.LA(1)) {
            case StudyPeriod.FIXED_WINDOW:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 1967;
                this.fixed_window_uniqueness_filter();
                }
                break;
            case StudyPeriod.ROLLING_WINDOW:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 1968;
                this.rolling_window_uniqueness_filter();
                }
                break;
            default:
                throw new antlr.NoViableAltException(this);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public fixed_window_uniqueness_filter(): Fixed_window_uniqueness_filterContext {
        let localContext = new Fixed_window_uniqueness_filterContext(this.context, this.state);
        this.enterRule(localContext, 332, StudyPeriod.RULE_fixed_window_uniqueness_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1971;
            this.match(StudyPeriod.FIXED_WINDOW);
            this.state = 1972;
            this.simple_event_int();
            this.state = 1973;
            this.match(StudyPeriod.TIME_UNIT);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public rolling_window_uniqueness_filter(): Rolling_window_uniqueness_filterContext {
        let localContext = new Rolling_window_uniqueness_filterContext(this.context, this.state);
        this.enterRule(localContext, 334, StudyPeriod.RULE_rolling_window_uniqueness_filter);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1975;
            this.match(StudyPeriod.ROLLING_WINDOW);
            this.state = 1976;
            this.simple_event_int();
            this.state = 1977;
            this.match(StudyPeriod.TIME_UNIT);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public simple_event_float(): Simple_event_floatContext {
        let localContext = new Simple_event_floatContext(this.context, this.state);
        this.enterRule(localContext, 336, StudyPeriod.RULE_simple_event_float);
        let _la: number;
        try {
            this.state = 1987;
            this.errorHandler.sync(this);
            switch (this.interpreter.adaptivePredict(this.tokenStream, 91, this.context) ) {
            case 1:
                this.enterOuterAlt(localContext, 1);
                {
                this.state = 1979;
                this.simple_event_int();
                }
                break;
            case 2:
                this.enterOuterAlt(localContext, 2);
                {
                this.state = 1981;
                this.errorHandler.sync(this);
                _la = this.tokenStream.LA(1);
                if (_la === 79) {
                    {
                    this.state = 1980;
                    this.match(StudyPeriod.INT);
                    }
                }

                this.state = 1983;
                this.match(StudyPeriod.PERIOD);
                this.state = 1985;
                this.errorHandler.sync(this);
                _la = this.tokenStream.LA(1);
                if (_la === 79) {
                    {
                    this.state = 1984;
                    this.match(StudyPeriod.INT);
                    }
                }

                }
                break;
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public simple_event_int(): Simple_event_intContext {
        let localContext = new Simple_event_intContext(this.context, this.state);
        this.enterRule(localContext, 338, StudyPeriod.RULE_simple_event_int);
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1989;
            this.match(StudyPeriod.INT);
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }
    public concept_group_selection(): Concept_group_selectionContext {
        let localContext = new Concept_group_selectionContext(this.context, this.state);
        this.enterRule(localContext, 340, StudyPeriod.RULE_concept_group_selection);
        let _la: number;
        try {
            this.enterOuterAlt(localContext, 1);
            {
            this.state = 1991;
            this.match(StudyPeriod.CONCEPT_GROUP);
            this.state = 1996;
            this.errorHandler.sync(this);
            _la = this.tokenStream.LA(1);
            while (_la === 87) {
                {
                {
                this.state = 1992;
                this.match(StudyPeriod.COMMA);
                this.state = 1993;
                this.match(StudyPeriod.CONCEPT_GROUP);
                }
                }
                this.state = 1998;
                this.errorHandler.sync(this);
                _la = this.tokenStream.LA(1);
            }
            }
        }
        catch (re) {
            if (re instanceof antlr.RecognitionException) {
                this.errorHandler.reportError(this, re);
                this.errorHandler.recover(this, re);
            } else {
                throw re;
            }
        }
        finally {
            this.exitRule();
        }
        return localContext;
    }

    public static readonly _serializedATN: number[] = [
        4,1,185,2000,2,0,7,0,2,1,7,1,2,2,7,2,2,3,7,3,2,4,7,4,2,5,7,5,2,6,
        7,6,2,7,7,7,2,8,7,8,2,9,7,9,2,10,7,10,2,11,7,11,2,12,7,12,2,13,7,
        13,2,14,7,14,2,15,7,15,2,16,7,16,2,17,7,17,2,18,7,18,2,19,7,19,2,
        20,7,20,2,21,7,21,2,22,7,22,2,23,7,23,2,24,7,24,2,25,7,25,2,26,7,
        26,2,27,7,27,2,28,7,28,2,29,7,29,2,30,7,30,2,31,7,31,2,32,7,32,2,
        33,7,33,2,34,7,34,2,35,7,35,2,36,7,36,2,37,7,37,2,38,7,38,2,39,7,
        39,2,40,7,40,2,41,7,41,2,42,7,42,2,43,7,43,2,44,7,44,2,45,7,45,2,
        46,7,46,2,47,7,47,2,48,7,48,2,49,7,49,2,50,7,50,2,51,7,51,2,52,7,
        52,2,53,7,53,2,54,7,54,2,55,7,55,2,56,7,56,2,57,7,57,2,58,7,58,2,
        59,7,59,2,60,7,60,2,61,7,61,2,62,7,62,2,63,7,63,2,64,7,64,2,65,7,
        65,2,66,7,66,2,67,7,67,2,68,7,68,2,69,7,69,2,70,7,70,2,71,7,71,2,
        72,7,72,2,73,7,73,2,74,7,74,2,75,7,75,2,76,7,76,2,77,7,77,2,78,7,
        78,2,79,7,79,2,80,7,80,2,81,7,81,2,82,7,82,2,83,7,83,2,84,7,84,2,
        85,7,85,2,86,7,86,2,87,7,87,2,88,7,88,2,89,7,89,2,90,7,90,2,91,7,
        91,2,92,7,92,2,93,7,93,2,94,7,94,2,95,7,95,2,96,7,96,2,97,7,97,2,
        98,7,98,2,99,7,99,2,100,7,100,2,101,7,101,2,102,7,102,2,103,7,103,
        2,104,7,104,2,105,7,105,2,106,7,106,2,107,7,107,2,108,7,108,2,109,
        7,109,2,110,7,110,2,111,7,111,2,112,7,112,2,113,7,113,2,114,7,114,
        2,115,7,115,2,116,7,116,2,117,7,117,2,118,7,118,2,119,7,119,2,120,
        7,120,2,121,7,121,2,122,7,122,2,123,7,123,2,124,7,124,2,125,7,125,
        2,126,7,126,2,127,7,127,2,128,7,128,2,129,7,129,2,130,7,130,2,131,
        7,131,2,132,7,132,2,133,7,133,2,134,7,134,2,135,7,135,2,136,7,136,
        2,137,7,137,2,138,7,138,2,139,7,139,2,140,7,140,2,141,7,141,2,142,
        7,142,2,143,7,143,2,144,7,144,2,145,7,145,2,146,7,146,2,147,7,147,
        2,148,7,148,2,149,7,149,2,150,7,150,2,151,7,151,2,152,7,152,2,153,
        7,153,2,154,7,154,2,155,7,155,2,156,7,156,2,157,7,157,2,158,7,158,
        2,159,7,159,2,160,7,160,2,161,7,161,2,162,7,162,2,163,7,163,2,164,
        7,164,2,165,7,165,2,166,7,166,2,167,7,167,2,168,7,168,2,169,7,169,
        2,170,7,170,1,0,1,0,1,0,1,0,3,0,347,8,0,1,1,1,1,3,1,351,8,1,1,2,
        1,2,3,2,355,8,2,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,3,1,4,1,4,1,4,1,4,
        1,4,1,5,1,5,1,5,1,5,1,5,1,5,1,6,1,6,1,6,1,6,1,6,1,6,1,6,1,7,1,7,
        1,7,1,7,1,7,1,7,1,8,1,8,1,8,1,8,1,8,1,9,1,9,1,9,1,9,1,9,1,9,1,10,
        1,10,1,10,1,10,1,10,1,11,1,11,1,11,1,11,1,11,3,11,410,8,11,1,11,
        1,11,1,12,1,12,1,12,1,12,1,12,1,13,1,13,1,13,1,13,1,14,1,14,1,14,
        1,14,1,14,1,14,1,14,1,14,1,14,1,14,1,14,1,14,1,14,1,14,3,14,437,
        8,14,1,15,1,15,1,15,3,15,442,8,15,1,15,1,15,1,16,1,16,1,16,5,16,
        449,8,16,10,16,12,16,452,9,16,1,17,1,17,1,17,3,17,457,8,17,1,18,
        1,18,1,18,1,18,3,18,463,8,18,1,18,1,18,1,19,1,19,1,19,1,19,1,20,
        1,20,1,20,1,20,1,21,1,21,1,21,1,21,1,21,1,22,1,22,1,22,1,22,1,23,
        1,23,1,23,1,23,1,23,1,23,1,23,1,23,1,23,1,23,1,23,1,23,1,23,1,23,
        1,23,1,23,1,23,1,23,1,23,1,23,1,23,1,23,1,23,1,23,1,23,3,23,509,
        8,23,1,24,1,24,1,25,1,25,1,25,1,25,1,25,1,26,1,26,1,26,1,26,3,26,
        522,8,26,1,27,1,27,1,27,1,27,1,27,1,28,1,28,1,28,1,28,1,28,3,28,
        534,8,28,1,28,1,28,1,29,1,29,3,29,540,8,29,1,29,1,29,1,29,3,29,545,
        8,29,1,30,1,30,1,30,1,30,1,30,1,31,1,31,1,31,1,31,1,31,1,32,1,32,
        1,32,1,32,1,33,1,33,1,33,1,33,1,34,1,34,1,34,1,34,1,35,1,35,1,35,
        1,35,1,36,1,36,1,36,3,36,576,8,36,1,37,1,37,1,37,1,37,1,37,1,37,
        1,37,3,37,585,8,37,1,37,1,37,1,37,1,38,1,38,1,38,4,38,593,8,38,11,
        38,12,38,594,1,39,1,39,3,39,599,8,39,1,40,1,40,3,40,603,8,40,1,41,
        1,41,1,41,1,41,3,41,609,8,41,1,41,1,41,1,42,1,42,1,43,1,43,1,43,
        1,43,1,43,1,44,1,44,3,44,622,8,44,1,44,1,44,1,45,1,45,1,45,1,45,
        1,45,1,45,1,45,1,45,1,45,1,45,1,45,1,45,1,45,1,45,1,45,1,45,1,45,
        1,45,1,45,1,45,1,45,1,45,1,45,1,45,1,45,1,45,1,45,1,45,1,45,1,45,
        1,45,1,45,1,45,1,45,1,45,1,45,1,45,1,45,1,45,1,45,1,45,1,45,1,45,
        1,45,1,45,1,45,1,45,1,45,1,45,1,45,1,45,1,45,1,45,1,45,3,45,680,
        8,45,1,46,1,46,1,46,1,46,1,46,1,46,1,46,1,46,1,47,1,47,1,47,5,47,
        693,8,47,10,47,12,47,696,9,47,1,48,1,48,1,48,1,48,3,48,702,8,48,
        1,49,1,49,3,49,706,8,49,1,50,1,50,1,50,1,50,1,50,1,51,1,51,1,51,
        1,51,1,52,1,52,1,52,1,52,3,52,721,8,52,1,52,1,52,1,53,1,53,3,53,
        727,8,53,1,53,1,53,1,53,1,54,1,54,3,54,734,8,54,1,55,1,55,1,55,1,
        55,1,55,1,55,1,55,1,55,1,56,1,56,1,56,4,56,747,8,56,11,56,12,56,
        748,1,57,1,57,1,57,1,57,1,57,3,57,756,8,57,1,58,1,58,1,58,1,58,3,
        58,762,8,58,1,58,1,58,1,59,1,59,1,59,1,59,3,59,770,8,59,1,59,1,59,
        1,60,1,60,1,61,1,61,1,61,1,61,1,61,1,62,1,62,1,62,1,62,1,62,1,62,
        1,62,1,62,1,62,3,62,790,8,62,1,63,1,63,1,63,1,63,1,63,1,63,1,63,
        1,63,1,63,1,63,1,63,1,63,1,63,1,63,1,63,1,63,1,63,1,63,3,63,810,
        8,63,1,64,1,64,1,64,1,64,1,65,1,65,1,65,1,65,1,65,1,65,1,65,1,65,
        1,65,1,65,1,65,1,65,3,65,828,8,65,1,66,1,66,1,66,1,66,1,66,1,66,
        1,66,1,66,1,66,1,66,1,66,1,66,3,66,842,8,66,1,67,1,67,1,67,1,67,
        1,68,1,68,3,68,850,8,68,1,69,1,69,1,69,1,69,1,70,1,70,1,70,1,70,
        1,71,1,71,1,72,1,72,1,72,1,72,1,72,1,72,3,72,868,8,72,1,73,1,73,
        1,73,1,73,1,73,1,74,1,74,1,74,1,74,1,74,1,75,1,75,1,75,1,75,1,75,
        1,76,1,76,1,76,1,76,1,76,1,77,1,77,1,77,1,77,1,77,1,78,1,78,1,78,
        1,78,1,78,1,79,1,79,1,79,3,79,903,8,79,1,79,1,79,1,80,1,80,1,80,
        3,80,910,8,80,1,80,1,80,1,81,1,81,1,81,3,81,917,8,81,1,81,1,81,1,
        82,1,82,1,82,3,82,924,8,82,1,82,1,82,1,83,1,83,1,83,3,83,931,8,83,
        1,83,1,83,1,84,1,84,1,84,3,84,938,8,84,1,84,1,84,1,85,1,85,1,85,
        5,85,945,8,85,10,85,12,85,948,9,85,1,86,1,86,1,86,1,86,3,86,954,
        8,86,1,87,1,87,1,87,1,87,3,87,960,8,87,1,87,1,87,1,88,1,88,1,88,
        1,88,1,89,1,89,1,89,1,89,1,90,1,90,1,90,1,90,1,90,1,91,1,91,3,91,
        979,8,91,1,91,1,91,1,92,1,92,1,92,1,92,1,92,1,93,1,93,3,93,990,8,
        93,1,94,1,94,1,94,3,94,995,8,94,1,95,1,95,1,95,1,95,1,95,1,95,1,
        95,1,95,1,95,1,95,3,95,1007,8,95,1,96,1,96,1,96,1,96,1,96,1,96,1,
        96,1,96,1,96,1,96,1,96,1,96,1,96,1,96,1,96,1,96,1,96,1,96,1,96,1,
        96,1,96,1,96,1,96,1,96,1,96,1,96,1,96,1,96,1,96,1,96,1,96,1,96,1,
        96,1,96,1,96,1,96,1,96,1,96,1,96,1,96,1,96,1,96,1,96,1,96,1,96,1,
        96,1,96,1,96,1,96,1,96,1,96,1,96,1,96,1,96,1,96,1,96,1,96,1,96,1,
        96,1,96,1,96,1,96,1,96,1,96,1,96,1,96,1,96,1,96,1,96,1,96,1,96,1,
        96,1,96,1,96,1,96,1,96,1,96,1,96,1,96,1,96,1,96,1,96,1,96,1,96,3,
        96,1093,8,96,1,97,1,97,1,97,5,97,1098,8,97,10,97,12,97,1101,9,97,
        1,98,1,98,1,98,1,98,1,98,3,98,1108,8,98,1,99,1,99,1,99,1,99,3,99,
        1114,8,99,1,99,1,99,1,100,1,100,1,100,1,100,1,101,1,101,1,101,1,
        101,1,102,1,102,1,102,1,102,3,102,1130,8,102,1,102,1,102,1,103,1,
        103,1,103,1,103,1,104,1,104,1,104,1,104,1,105,1,105,1,105,1,105,
        1,105,1,106,1,106,3,106,1149,8,106,1,106,1,106,1,107,1,107,1,107,
        1,107,1,107,1,108,1,108,3,108,1160,8,108,1,109,1,109,1,109,1,109,
        1,109,1,109,1,109,1,109,1,109,1,109,1,109,1,109,1,109,1,109,1,109,
        1,109,1,109,1,109,1,109,1,109,1,109,1,109,1,109,1,109,1,109,1,109,
        1,109,1,109,1,109,1,109,1,109,1,109,1,109,1,109,1,109,1,109,1,109,
        1,109,1,109,1,109,1,109,1,109,1,109,1,109,1,109,1,109,1,109,1,109,
        1,109,1,109,1,109,1,109,1,109,1,109,1,109,1,109,1,109,1,109,1,109,
        1,109,1,109,1,109,1,109,1,109,1,109,1,109,1,109,1,109,1,109,1,109,
        1,109,1,109,1,109,1,109,1,109,1,109,1,109,1,109,1,109,1,109,1,109,
        1,109,1,109,1,109,1,109,1,109,1,109,1,109,1,109,1,109,1,109,1,109,
        1,109,1,109,1,109,1,109,1,109,1,109,1,109,1,109,1,109,1,109,1,109,
        1,109,1,109,1,109,1,109,3,109,1269,8,109,1,110,1,110,1,110,5,110,
        1274,8,110,10,110,12,110,1277,9,110,1,111,1,111,1,111,1,111,1,111,
        3,111,1284,8,111,1,112,1,112,1,112,1,112,3,112,1290,8,112,1,112,
        1,112,1,113,1,113,1,113,1,113,1,114,1,114,1,114,1,114,1,115,1,115,
        1,115,1,115,1,115,1,116,1,116,1,116,1,116,1,117,1,117,1,117,1,117,
        1,117,1,118,1,118,3,118,1318,8,118,1,118,1,118,1,119,1,119,1,119,
        1,119,1,119,1,120,1,120,3,120,1329,8,120,1,121,1,121,1,121,1,121,
        1,121,1,121,1,121,1,121,1,121,1,121,1,121,1,121,1,121,1,121,1,121,
        1,121,1,121,1,121,1,121,1,121,1,121,1,121,1,121,1,121,1,121,1,121,
        1,121,1,121,1,121,1,121,1,121,1,121,1,121,1,121,1,121,1,121,1,121,
        1,121,1,121,1,121,1,121,1,121,1,121,1,121,1,121,1,121,1,121,1,121,
        1,121,1,121,1,121,1,121,1,121,1,121,1,121,1,121,1,121,1,121,1,121,
        1,121,1,121,1,121,1,121,1,121,1,121,1,121,1,121,1,121,1,121,1,121,
        1,121,1,121,1,121,1,121,1,121,1,121,1,121,1,121,1,121,1,121,1,121,
        1,121,1,121,1,121,1,121,1,121,1,121,1,121,1,121,1,121,1,121,1,121,
        1,121,1,121,1,121,1,121,1,121,1,121,1,121,1,121,1,121,1,121,1,121,
        1,121,1,121,1,121,1,121,1,121,1,121,1,121,1,121,3,121,1442,8,121,
        1,122,1,122,1,122,5,122,1447,8,122,10,122,12,122,1450,9,122,1,123,
        1,123,1,123,1,123,1,123,3,123,1457,8,123,1,124,1,124,1,124,1,124,
        3,124,1463,8,124,1,124,1,124,1,125,1,125,1,125,1,125,1,126,1,126,
        1,126,1,126,1,127,1,127,1,127,1,127,1,127,1,128,1,128,1,128,1,128,
        1,129,1,129,1,129,1,129,1,129,1,130,1,130,3,130,1491,8,130,1,130,
        1,130,1,131,1,131,1,131,1,131,1,131,1,132,1,132,3,132,1502,8,132,
        1,133,1,133,1,133,1,133,1,133,1,133,1,133,1,133,1,133,1,133,1,133,
        1,133,1,133,1,133,1,133,1,133,1,133,1,133,1,133,1,133,1,133,1,133,
        1,133,1,133,1,133,1,133,1,133,1,133,1,133,1,133,1,133,1,133,1,133,
        1,133,1,133,1,133,1,133,1,133,1,133,1,133,1,133,1,133,1,133,1,133,
        1,133,1,133,1,133,1,133,1,133,1,133,1,133,1,133,1,133,1,133,1,133,
        1,133,1,133,1,133,1,133,1,133,1,133,1,133,1,133,1,133,1,133,1,133,
        1,133,1,133,1,133,1,133,1,133,1,133,1,133,1,133,1,133,1,133,1,133,
        1,133,1,133,1,133,1,133,1,133,1,133,1,133,1,133,1,133,1,133,1,133,
        1,133,1,133,1,133,1,133,1,133,1,133,1,133,1,133,1,133,1,133,1,133,
        1,133,1,133,1,133,1,133,1,133,1,133,1,133,1,133,1,133,1,133,1,133,
        1,133,3,133,1615,8,133,1,134,1,134,1,134,5,134,1620,8,134,10,134,
        12,134,1623,9,134,1,135,1,135,1,135,1,135,1,135,3,135,1630,8,135,
        1,136,1,136,1,136,1,136,3,136,1636,8,136,1,136,1,136,1,137,1,137,
        1,137,1,137,1,138,1,138,1,138,1,138,1,139,1,139,1,139,1,139,1,139,
        1,140,1,140,1,140,1,140,1,141,1,141,1,141,1,141,1,141,1,142,1,142,
        3,142,1664,8,142,1,142,1,142,1,143,1,143,1,143,1,143,1,143,1,144,
        1,144,3,144,1675,8,144,1,145,1,145,1,145,1,145,1,145,1,145,1,145,
        1,145,1,145,1,145,1,145,1,145,1,145,1,145,1,145,1,145,1,145,1,145,
        1,145,1,145,1,145,1,145,1,145,1,145,1,145,1,145,1,145,1,145,1,145,
        1,145,1,145,1,145,1,145,1,145,1,145,1,145,1,145,1,145,1,145,1,145,
        1,145,1,145,1,145,1,145,1,145,1,145,1,145,1,145,1,145,1,145,1,145,
        1,145,1,145,1,145,1,145,1,145,1,145,1,145,1,145,1,145,1,145,1,145,
        1,145,1,145,1,145,1,145,1,145,1,145,1,145,1,145,1,145,1,145,1,145,
        1,145,1,145,1,145,1,145,1,145,1,145,1,145,1,145,1,145,1,145,1,145,
        1,145,1,145,1,145,1,145,1,145,1,145,1,145,1,145,1,145,1,145,1,145,
        1,145,1,145,3,145,1774,8,145,1,146,1,146,1,146,1,146,3,146,1780,
        8,146,1,146,1,146,1,147,1,147,1,147,1,147,1,148,1,148,1,148,1,148,
        1,149,1,149,1,149,3,149,1795,8,149,1,150,1,150,1,150,1,150,1,150,
        1,150,1,150,1,150,1,150,1,150,3,150,1807,8,150,1,151,1,151,1,151,
        5,151,1812,8,151,10,151,12,151,1815,9,151,1,152,1,152,1,152,1,152,
        3,152,1821,8,152,1,153,1,153,1,153,1,153,3,153,1827,8,153,1,153,
        1,153,1,154,1,154,1,154,1,154,1,155,1,155,1,155,1,155,1,156,1,156,
        1,156,1,156,1,156,1,157,1,157,3,157,1846,8,157,1,157,1,157,1,158,
        1,158,1,158,1,158,1,158,1,159,1,159,3,159,1857,8,159,1,160,1,160,
        1,160,3,160,1862,8,160,1,161,1,161,1,161,1,161,1,161,1,161,1,161,
        1,161,1,161,1,161,3,161,1874,8,161,1,162,1,162,1,162,1,162,1,162,
        1,162,1,162,1,162,1,162,1,162,1,162,1,162,1,162,1,162,1,162,1,162,
        1,162,1,162,1,162,1,162,1,162,1,162,1,162,1,162,1,162,1,162,1,162,
        1,162,1,162,1,162,1,162,1,162,1,162,1,162,1,162,1,162,1,162,1,162,
        1,162,1,162,1,162,1,162,1,162,1,162,1,162,1,162,1,162,1,162,1,162,
        1,162,1,162,1,162,1,162,1,162,1,162,1,162,1,162,1,162,1,162,1,162,
        1,162,1,162,1,162,1,162,1,162,1,162,1,162,1,162,1,162,1,162,1,162,
        1,162,1,162,1,162,1,162,1,162,1,162,1,162,1,162,1,162,1,162,1,162,
        1,162,1,162,3,162,1960,8,162,1,163,1,163,1,164,1,164,1,164,1,164,
        1,165,1,165,3,165,1970,8,165,1,166,1,166,1,166,1,166,1,167,1,167,
        1,167,1,167,1,168,1,168,3,168,1982,8,168,1,168,1,168,3,168,1986,
        8,168,3,168,1988,8,168,1,169,1,169,1,170,1,170,1,170,5,170,1995,
        8,170,10,170,12,170,1998,9,170,1,170,0,0,171,0,2,4,6,8,10,12,14,
        16,18,20,22,24,26,28,30,32,34,36,38,40,42,44,46,48,50,52,54,56,58,
        60,62,64,66,68,70,72,74,76,78,80,82,84,86,88,90,92,94,96,98,100,
        102,104,106,108,110,112,114,116,118,120,122,124,126,128,130,132,
        134,136,138,140,142,144,146,148,150,152,154,156,158,160,162,164,
        166,168,170,172,174,176,178,180,182,184,186,188,190,192,194,196,
        198,200,202,204,206,208,210,212,214,216,218,220,222,224,226,228,
        230,232,234,236,238,240,242,244,246,248,250,252,254,256,258,260,
        262,264,266,268,270,272,274,276,278,280,282,284,286,288,290,292,
        294,296,298,300,302,304,306,308,310,312,314,316,318,320,322,324,
        326,328,330,332,334,336,338,340,0,10,2,0,88,88,94,94,1,0,42,50,2,
        0,63,63,159,159,1,0,119,121,1,0,99,100,3,0,33,36,38,38,40,41,2,0,
        167,167,173,173,2,0,161,161,163,163,2,0,168,168,173,173,2,0,88,88,
        94,98,2091,0,346,1,0,0,0,2,350,1,0,0,0,4,354,1,0,0,0,6,356,1,0,0,
        0,8,364,1,0,0,0,10,369,1,0,0,0,12,375,1,0,0,0,14,382,1,0,0,0,16,
        388,1,0,0,0,18,393,1,0,0,0,20,399,1,0,0,0,22,404,1,0,0,0,24,413,
        1,0,0,0,26,418,1,0,0,0,28,436,1,0,0,0,30,438,1,0,0,0,32,445,1,0,
        0,0,34,456,1,0,0,0,36,458,1,0,0,0,38,466,1,0,0,0,40,470,1,0,0,0,
        42,474,1,0,0,0,44,479,1,0,0,0,46,508,1,0,0,0,48,510,1,0,0,0,50,512,
        1,0,0,0,52,521,1,0,0,0,54,523,1,0,0,0,56,528,1,0,0,0,58,539,1,0,
        0,0,60,546,1,0,0,0,62,551,1,0,0,0,64,556,1,0,0,0,66,560,1,0,0,0,
        68,564,1,0,0,0,70,568,1,0,0,0,72,575,1,0,0,0,74,577,1,0,0,0,76,589,
        1,0,0,0,78,598,1,0,0,0,80,602,1,0,0,0,82,604,1,0,0,0,84,612,1,0,
        0,0,86,614,1,0,0,0,88,621,1,0,0,0,90,679,1,0,0,0,92,681,1,0,0,0,
        94,689,1,0,0,0,96,701,1,0,0,0,98,705,1,0,0,0,100,707,1,0,0,0,102,
        712,1,0,0,0,104,716,1,0,0,0,106,726,1,0,0,0,108,733,1,0,0,0,110,
        735,1,0,0,0,112,743,1,0,0,0,114,755,1,0,0,0,116,757,1,0,0,0,118,
        765,1,0,0,0,120,773,1,0,0,0,122,775,1,0,0,0,124,789,1,0,0,0,126,
        809,1,0,0,0,128,811,1,0,0,0,130,827,1,0,0,0,132,841,1,0,0,0,134,
        843,1,0,0,0,136,849,1,0,0,0,138,851,1,0,0,0,140,855,1,0,0,0,142,
        859,1,0,0,0,144,867,1,0,0,0,146,869,1,0,0,0,148,874,1,0,0,0,150,
        879,1,0,0,0,152,884,1,0,0,0,154,889,1,0,0,0,156,894,1,0,0,0,158,
        899,1,0,0,0,160,906,1,0,0,0,162,913,1,0,0,0,164,920,1,0,0,0,166,
        927,1,0,0,0,168,934,1,0,0,0,170,941,1,0,0,0,172,953,1,0,0,0,174,
        955,1,0,0,0,176,963,1,0,0,0,178,967,1,0,0,0,180,971,1,0,0,0,182,
        978,1,0,0,0,184,982,1,0,0,0,186,989,1,0,0,0,188,991,1,0,0,0,190,
        1006,1,0,0,0,192,1092,1,0,0,0,194,1094,1,0,0,0,196,1107,1,0,0,0,
        198,1109,1,0,0,0,200,1117,1,0,0,0,202,1121,1,0,0,0,204,1125,1,0,
        0,0,206,1133,1,0,0,0,208,1137,1,0,0,0,210,1141,1,0,0,0,212,1148,
        1,0,0,0,214,1152,1,0,0,0,216,1159,1,0,0,0,218,1268,1,0,0,0,220,1270,
        1,0,0,0,222,1283,1,0,0,0,224,1285,1,0,0,0,226,1293,1,0,0,0,228,1297,
        1,0,0,0,230,1301,1,0,0,0,232,1306,1,0,0,0,234,1310,1,0,0,0,236,1317,
        1,0,0,0,238,1321,1,0,0,0,240,1328,1,0,0,0,242,1441,1,0,0,0,244,1443,
        1,0,0,0,246,1456,1,0,0,0,248,1458,1,0,0,0,250,1466,1,0,0,0,252,1470,
        1,0,0,0,254,1474,1,0,0,0,256,1479,1,0,0,0,258,1483,1,0,0,0,260,1490,
        1,0,0,0,262,1494,1,0,0,0,264,1501,1,0,0,0,266,1614,1,0,0,0,268,1616,
        1,0,0,0,270,1629,1,0,0,0,272,1631,1,0,0,0,274,1639,1,0,0,0,276,1643,
        1,0,0,0,278,1647,1,0,0,0,280,1652,1,0,0,0,282,1656,1,0,0,0,284,1663,
        1,0,0,0,286,1667,1,0,0,0,288,1674,1,0,0,0,290,1773,1,0,0,0,292,1775,
        1,0,0,0,294,1783,1,0,0,0,296,1787,1,0,0,0,298,1791,1,0,0,0,300,1806,
        1,0,0,0,302,1808,1,0,0,0,304,1820,1,0,0,0,306,1822,1,0,0,0,308,1830,
        1,0,0,0,310,1834,1,0,0,0,312,1838,1,0,0,0,314,1845,1,0,0,0,316,1849,
        1,0,0,0,318,1856,1,0,0,0,320,1858,1,0,0,0,322,1873,1,0,0,0,324,1959,
        1,0,0,0,326,1961,1,0,0,0,328,1963,1,0,0,0,330,1969,1,0,0,0,332,1971,
        1,0,0,0,334,1975,1,0,0,0,336,1987,1,0,0,0,338,1989,1,0,0,0,340,1991,
        1,0,0,0,342,347,3,6,3,0,343,347,3,8,4,0,344,347,3,10,5,0,345,347,
        3,12,6,0,346,342,1,0,0,0,346,343,1,0,0,0,346,344,1,0,0,0,346,345,
        1,0,0,0,347,1,1,0,0,0,348,351,3,14,7,0,349,351,3,16,8,0,350,348,
        1,0,0,0,350,349,1,0,0,0,351,3,1,0,0,0,352,355,3,18,9,0,353,355,3,
        20,10,0,354,352,1,0,0,0,354,353,1,0,0,0,355,5,1,0,0,0,356,357,5,
        1,0,0,357,358,5,84,0,0,358,359,5,83,0,0,359,360,5,87,0,0,360,361,
        5,83,0,0,361,362,5,85,0,0,362,363,5,86,0,0,363,7,1,0,0,0,364,365,
        5,1,0,0,365,366,5,84,0,0,366,367,5,85,0,0,367,368,5,86,0,0,368,9,
        1,0,0,0,369,370,5,1,0,0,370,371,5,84,0,0,371,372,5,83,0,0,372,373,
        5,85,0,0,373,374,5,86,0,0,374,11,1,0,0,0,375,376,5,1,0,0,376,377,
        5,84,0,0,377,378,5,83,0,0,378,379,5,87,0,0,379,380,5,85,0,0,380,
        381,5,86,0,0,381,13,1,0,0,0,382,383,5,2,0,0,383,384,5,84,0,0,384,
        385,5,79,0,0,385,386,5,85,0,0,386,387,5,86,0,0,387,15,1,0,0,0,388,
        389,5,2,0,0,389,390,5,84,0,0,390,391,5,85,0,0,391,392,5,86,0,0,392,
        17,1,0,0,0,393,394,5,3,0,0,394,395,5,84,0,0,395,396,5,79,0,0,396,
        397,5,85,0,0,397,398,5,86,0,0,398,19,1,0,0,0,399,400,5,3,0,0,400,
        401,5,84,0,0,401,402,5,85,0,0,402,403,5,86,0,0,403,21,1,0,0,0,404,
        405,5,64,0,0,405,409,5,88,0,0,406,410,3,30,15,0,407,410,3,24,12,
        0,408,410,3,28,14,0,409,406,1,0,0,0,409,407,1,0,0,0,409,408,1,0,
        0,0,410,411,1,0,0,0,411,412,5,86,0,0,412,23,1,0,0,0,413,414,5,102,
        0,0,414,415,5,84,0,0,415,416,3,26,13,0,416,417,5,85,0,0,417,25,1,
        0,0,0,418,419,3,48,24,0,419,420,3,326,163,0,420,421,5,79,0,0,421,
        27,1,0,0,0,422,423,5,102,0,0,423,424,5,84,0,0,424,437,5,85,0,0,425,
        426,5,102,0,0,426,427,5,84,0,0,427,428,3,48,24,0,428,429,5,85,0,
        0,429,437,1,0,0,0,430,431,5,102,0,0,431,432,5,84,0,0,432,433,3,48,
        24,0,433,434,3,326,163,0,434,435,5,85,0,0,435,437,1,0,0,0,436,422,
        1,0,0,0,436,425,1,0,0,0,436,430,1,0,0,0,437,29,1,0,0,0,438,439,5,
        131,0,0,439,441,5,84,0,0,440,442,3,32,16,0,441,440,1,0,0,0,441,442,
        1,0,0,0,442,443,1,0,0,0,443,444,5,85,0,0,444,31,1,0,0,0,445,450,
        3,34,17,0,446,447,5,87,0,0,447,449,3,34,17,0,448,446,1,0,0,0,449,
        452,1,0,0,0,450,448,1,0,0,0,450,451,1,0,0,0,451,33,1,0,0,0,452,450,
        1,0,0,0,453,457,3,36,18,0,454,457,3,42,21,0,455,457,3,46,23,0,456,
        453,1,0,0,0,456,454,1,0,0,0,456,455,1,0,0,0,457,35,1,0,0,0,458,459,
        5,17,0,0,459,462,5,84,0,0,460,463,3,38,19,0,461,463,3,40,20,0,462,
        460,1,0,0,0,462,461,1,0,0,0,463,464,1,0,0,0,464,465,5,85,0,0,465,
        37,1,0,0,0,466,467,5,169,0,0,467,468,5,105,0,0,468,469,3,340,170,
        0,469,39,1,0,0,0,470,471,5,169,0,0,471,472,7,0,0,0,472,473,5,67,
        0,0,473,41,1,0,0,0,474,475,5,20,0,0,475,476,5,84,0,0,476,477,3,44,
        22,0,477,478,5,85,0,0,478,43,1,0,0,0,479,480,5,162,0,0,480,481,3,
        326,163,0,481,482,5,79,0,0,482,45,1,0,0,0,483,484,5,17,0,0,484,485,
        5,84,0,0,485,509,5,85,0,0,486,487,5,17,0,0,487,488,5,84,0,0,488,
        489,5,169,0,0,489,509,5,85,0,0,490,491,5,17,0,0,491,492,5,84,0,0,
        492,493,5,169,0,0,493,494,5,105,0,0,494,509,5,85,0,0,495,496,5,20,
        0,0,496,497,5,84,0,0,497,509,5,85,0,0,498,499,5,20,0,0,499,500,5,
        84,0,0,500,501,5,162,0,0,501,509,5,85,0,0,502,503,5,20,0,0,503,504,
        5,84,0,0,504,505,5,162,0,0,505,506,3,326,163,0,506,507,5,85,0,0,
        507,509,1,0,0,0,508,483,1,0,0,0,508,486,1,0,0,0,508,490,1,0,0,0,
        508,495,1,0,0,0,508,498,1,0,0,0,508,502,1,0,0,0,509,47,1,0,0,0,510,
        511,7,1,0,0,511,49,1,0,0,0,512,513,5,4,0,0,513,514,5,88,0,0,514,
        515,3,52,26,0,515,516,5,86,0,0,516,51,1,0,0,0,517,522,3,54,27,0,
        518,522,3,64,32,0,519,522,3,56,28,0,520,522,3,66,33,0,521,517,1,
        0,0,0,521,518,1,0,0,0,521,519,1,0,0,0,521,520,1,0,0,0,522,53,1,0,
        0,0,523,524,5,6,0,0,524,525,5,84,0,0,525,526,5,83,0,0,526,527,5,
        85,0,0,527,55,1,0,0,0,528,529,5,5,0,0,529,530,5,84,0,0,530,533,7,
        2,0,0,531,532,5,87,0,0,532,534,3,58,29,0,533,531,1,0,0,0,533,534,
        1,0,0,0,534,535,1,0,0,0,535,536,5,85,0,0,536,57,1,0,0,0,537,540,
        3,62,31,0,538,540,3,68,34,0,539,537,1,0,0,0,539,538,1,0,0,0,540,
        541,1,0,0,0,541,544,5,87,0,0,542,545,3,60,30,0,543,545,3,70,35,0,
        544,542,1,0,0,0,544,543,1,0,0,0,545,59,1,0,0,0,546,547,5,7,0,0,547,
        548,5,84,0,0,548,549,5,83,0,0,549,550,5,85,0,0,550,61,1,0,0,0,551,
        552,5,8,0,0,552,553,5,84,0,0,553,554,5,83,0,0,554,555,5,85,0,0,555,
        63,1,0,0,0,556,557,5,6,0,0,557,558,5,84,0,0,558,559,5,85,0,0,559,
        65,1,0,0,0,560,561,5,5,0,0,561,562,5,84,0,0,562,563,5,85,0,0,563,
        67,1,0,0,0,564,565,5,8,0,0,565,566,5,84,0,0,566,567,5,85,0,0,567,
        69,1,0,0,0,568,569,5,7,0,0,569,570,5,84,0,0,570,571,5,85,0,0,571,
        71,1,0,0,0,572,576,3,74,37,0,573,576,3,92,46,0,574,576,3,110,55,
        0,575,572,1,0,0,0,575,573,1,0,0,0,575,574,1,0,0,0,576,73,1,0,0,0,
        577,578,5,61,0,0,578,579,5,88,0,0,579,580,5,74,0,0,580,581,5,84,
        0,0,581,584,3,76,38,0,582,583,5,87,0,0,583,585,3,80,40,0,584,582,
        1,0,0,0,584,585,1,0,0,0,585,586,1,0,0,0,586,587,5,85,0,0,587,588,
        5,86,0,0,588,75,1,0,0,0,589,592,3,78,39,0,590,591,5,87,0,0,591,593,
        3,78,39,0,592,590,1,0,0,0,593,594,1,0,0,0,594,592,1,0,0,0,594,595,
        1,0,0,0,595,77,1,0,0,0,596,599,3,82,41,0,597,599,3,132,66,0,598,
        596,1,0,0,0,598,597,1,0,0,0,599,79,1,0,0,0,600,603,3,84,42,0,601,
        603,3,90,45,0,602,600,1,0,0,0,602,601,1,0,0,0,603,81,1,0,0,0,604,
        605,5,77,0,0,605,608,5,84,0,0,606,609,3,126,63,0,607,609,3,128,64,
        0,608,606,1,0,0,0,608,607,1,0,0,0,609,610,1,0,0,0,610,611,5,85,0,
        0,611,83,1,0,0,0,612,613,3,86,43,0,613,85,1,0,0,0,614,615,5,26,0,
        0,615,616,5,84,0,0,616,617,3,88,44,0,617,618,5,85,0,0,618,87,1,0,
        0,0,619,622,3,134,67,0,620,622,3,136,68,0,621,619,1,0,0,0,621,620,
        1,0,0,0,622,623,1,0,0,0,623,624,5,9,0,0,624,89,1,0,0,0,625,626,5,
        26,0,0,626,627,5,84,0,0,627,680,5,85,0,0,628,629,5,26,0,0,629,630,
        5,84,0,0,630,631,5,119,0,0,631,680,5,85,0,0,632,633,5,26,0,0,633,
        634,5,84,0,0,634,635,5,119,0,0,635,636,3,142,71,0,636,637,5,85,0,
        0,637,680,1,0,0,0,638,639,5,26,0,0,639,640,5,84,0,0,640,641,5,119,
        0,0,641,642,3,142,71,0,642,643,5,114,0,0,643,644,5,85,0,0,644,680,
        1,0,0,0,645,646,5,26,0,0,646,647,5,84,0,0,647,648,5,122,0,0,648,
        680,5,85,0,0,649,650,5,26,0,0,650,651,5,84,0,0,651,652,5,122,0,0,
        652,653,3,142,71,0,653,654,5,85,0,0,654,680,1,0,0,0,655,656,5,26,
        0,0,656,657,5,84,0,0,657,658,5,122,0,0,658,659,3,142,71,0,659,660,
        5,114,0,0,660,661,5,85,0,0,661,680,1,0,0,0,662,663,5,26,0,0,663,
        664,5,84,0,0,664,665,5,123,0,0,665,680,5,85,0,0,666,667,5,26,0,0,
        667,668,5,84,0,0,668,669,5,123,0,0,669,670,3,142,71,0,670,671,5,
        85,0,0,671,680,1,0,0,0,672,673,5,26,0,0,673,674,5,84,0,0,674,675,
        5,123,0,0,675,676,3,142,71,0,676,677,5,114,0,0,677,678,5,85,0,0,
        678,680,1,0,0,0,679,625,1,0,0,0,679,628,1,0,0,0,679,632,1,0,0,0,
        679,638,1,0,0,0,679,645,1,0,0,0,679,649,1,0,0,0,679,655,1,0,0,0,
        679,662,1,0,0,0,679,666,1,0,0,0,679,672,1,0,0,0,680,91,1,0,0,0,681,
        682,5,62,0,0,682,683,5,88,0,0,683,684,5,75,0,0,684,685,5,84,0,0,
        685,686,3,94,47,0,686,687,5,85,0,0,687,688,5,86,0,0,688,93,1,0,0,
        0,689,694,3,96,48,0,690,691,5,87,0,0,691,693,3,96,48,0,692,690,1,
        0,0,0,693,696,1,0,0,0,694,692,1,0,0,0,694,695,1,0,0,0,695,95,1,0,
        0,0,696,694,1,0,0,0,697,702,3,98,49,0,698,702,3,104,52,0,699,702,
        3,130,65,0,700,702,3,132,66,0,701,697,1,0,0,0,701,698,1,0,0,0,701,
        699,1,0,0,0,701,700,1,0,0,0,702,97,1,0,0,0,703,706,5,11,0,0,704,
        706,3,100,50,0,705,703,1,0,0,0,705,704,1,0,0,0,706,99,1,0,0,0,707,
        708,5,13,0,0,708,709,5,84,0,0,709,710,3,102,51,0,710,711,5,85,0,
        0,711,101,1,0,0,0,712,713,7,3,0,0,713,714,5,79,0,0,714,715,5,114,
        0,0,715,103,1,0,0,0,716,717,5,77,0,0,717,720,5,84,0,0,718,721,3,
        106,53,0,719,721,3,108,54,0,720,718,1,0,0,0,720,719,1,0,0,0,721,
        722,1,0,0,0,722,723,5,85,0,0,723,105,1,0,0,0,724,727,3,126,63,0,
        725,727,3,128,64,0,726,724,1,0,0,0,726,725,1,0,0,0,727,728,1,0,0,
        0,728,729,5,87,0,0,729,730,5,12,0,0,730,107,1,0,0,0,731,734,3,126,
        63,0,732,734,3,128,64,0,733,731,1,0,0,0,733,732,1,0,0,0,734,109,
        1,0,0,0,735,736,5,63,0,0,736,737,5,88,0,0,737,738,5,76,0,0,738,739,
        5,84,0,0,739,740,3,112,56,0,740,741,5,85,0,0,741,742,5,86,0,0,742,
        111,1,0,0,0,743,746,3,114,57,0,744,745,5,87,0,0,745,747,3,114,57,
        0,746,744,1,0,0,0,747,748,1,0,0,0,748,746,1,0,0,0,748,749,1,0,0,
        0,749,113,1,0,0,0,750,756,1,0,0,0,751,756,3,116,58,0,752,756,3,132,
        66,0,753,756,3,118,59,0,754,756,3,124,62,0,755,750,1,0,0,0,755,751,
        1,0,0,0,755,752,1,0,0,0,755,753,1,0,0,0,755,754,1,0,0,0,756,115,
        1,0,0,0,757,758,5,77,0,0,758,761,5,84,0,0,759,762,3,126,63,0,760,
        762,3,128,64,0,761,759,1,0,0,0,761,760,1,0,0,0,762,763,1,0,0,0,763,
        764,5,85,0,0,764,117,1,0,0,0,765,766,5,16,0,0,766,769,5,84,0,0,767,
        770,3,120,60,0,768,770,3,122,61,0,769,767,1,0,0,0,769,768,1,0,0,
        0,770,771,1,0,0,0,771,772,5,85,0,0,772,119,1,0,0,0,773,774,7,4,0,
        0,774,121,1,0,0,0,775,776,5,113,0,0,776,777,5,84,0,0,777,778,5,79,
        0,0,778,779,5,85,0,0,779,123,1,0,0,0,780,781,5,16,0,0,781,782,5,
        84,0,0,782,790,5,85,0,0,783,784,5,16,0,0,784,785,5,84,0,0,785,786,
        5,113,0,0,786,787,5,84,0,0,787,788,5,85,0,0,788,790,5,85,0,0,789,
        780,1,0,0,0,789,783,1,0,0,0,790,125,1,0,0,0,791,792,5,33,0,0,792,
        793,5,124,0,0,793,810,5,153,0,0,794,795,5,34,0,0,795,796,5,124,0,
        0,796,810,5,154,0,0,797,798,5,35,0,0,798,799,5,124,0,0,799,810,5,
        155,0,0,800,801,5,36,0,0,801,802,5,124,0,0,802,810,5,156,0,0,803,
        804,5,38,0,0,804,805,5,124,0,0,805,810,5,157,0,0,806,807,5,40,0,
        0,807,808,5,124,0,0,808,810,5,158,0,0,809,791,1,0,0,0,809,794,1,
        0,0,0,809,797,1,0,0,0,809,800,1,0,0,0,809,803,1,0,0,0,809,806,1,
        0,0,0,810,127,1,0,0,0,811,812,5,41,0,0,812,813,5,124,0,0,813,814,
        5,9,0,0,814,129,1,0,0,0,815,816,5,13,0,0,816,817,5,84,0,0,817,828,
        5,85,0,0,818,819,5,13,0,0,819,820,5,84,0,0,820,821,7,3,0,0,821,828,
        5,85,0,0,822,823,5,13,0,0,823,824,5,84,0,0,824,825,7,3,0,0,825,826,
        5,79,0,0,826,828,5,85,0,0,827,815,1,0,0,0,827,818,1,0,0,0,827,822,
        1,0,0,0,828,131,1,0,0,0,829,830,5,77,0,0,830,831,5,84,0,0,831,842,
        5,85,0,0,832,833,5,77,0,0,833,834,5,84,0,0,834,835,7,5,0,0,835,842,
        5,85,0,0,836,837,5,77,0,0,837,838,5,84,0,0,838,839,7,5,0,0,839,840,
        5,124,0,0,840,842,5,85,0,0,841,829,1,0,0,0,841,832,1,0,0,0,841,836,
        1,0,0,0,842,133,1,0,0,0,843,844,5,119,0,0,844,845,3,142,71,0,845,
        846,5,114,0,0,846,135,1,0,0,0,847,850,3,138,69,0,848,850,3,140,70,
        0,849,847,1,0,0,0,849,848,1,0,0,0,850,137,1,0,0,0,851,852,5,122,
        0,0,852,853,3,142,71,0,853,854,5,114,0,0,854,139,1,0,0,0,855,856,
        5,123,0,0,856,857,3,142,71,0,857,858,5,114,0,0,858,141,1,0,0,0,859,
        860,5,79,0,0,860,143,1,0,0,0,861,868,3,146,73,0,862,868,3,148,74,
        0,863,868,3,150,75,0,864,868,3,152,76,0,865,868,3,154,77,0,866,868,
        3,156,78,0,867,861,1,0,0,0,867,862,1,0,0,0,867,863,1,0,0,0,867,864,
        1,0,0,0,867,865,1,0,0,0,867,866,1,0,0,0,868,145,1,0,0,0,869,870,
        5,53,0,0,870,871,5,88,0,0,871,872,3,158,79,0,872,873,5,86,0,0,873,
        147,1,0,0,0,874,875,5,54,0,0,875,876,5,88,0,0,876,877,3,160,80,0,
        877,878,5,86,0,0,878,149,1,0,0,0,879,880,5,55,0,0,880,881,5,88,0,
        0,881,882,3,162,81,0,882,883,5,86,0,0,883,151,1,0,0,0,884,885,5,
        56,0,0,885,886,5,88,0,0,886,887,3,164,82,0,887,888,5,86,0,0,888,
        153,1,0,0,0,889,890,5,58,0,0,890,891,5,88,0,0,891,892,3,166,83,0,
        892,893,5,86,0,0,893,155,1,0,0,0,894,895,5,60,0,0,895,896,5,88,0,
        0,896,897,3,168,84,0,897,898,5,86,0,0,898,157,1,0,0,0,899,900,5,
        127,0,0,900,902,5,84,0,0,901,903,3,170,85,0,902,901,1,0,0,0,902,
        903,1,0,0,0,903,904,1,0,0,0,904,905,5,85,0,0,905,159,1,0,0,0,906,
        907,5,128,0,0,907,909,5,84,0,0,908,910,3,194,97,0,909,908,1,0,0,
        0,909,910,1,0,0,0,910,911,1,0,0,0,911,912,5,85,0,0,912,161,1,0,0,
        0,913,914,5,129,0,0,914,916,5,84,0,0,915,917,3,220,110,0,916,915,
        1,0,0,0,916,917,1,0,0,0,917,918,1,0,0,0,918,919,5,85,0,0,919,163,
        1,0,0,0,920,921,5,130,0,0,921,923,5,84,0,0,922,924,3,244,122,0,923,
        922,1,0,0,0,923,924,1,0,0,0,924,925,1,0,0,0,925,926,5,85,0,0,926,
        165,1,0,0,0,927,928,5,132,0,0,928,930,5,84,0,0,929,931,3,268,134,
        0,930,929,1,0,0,0,930,931,1,0,0,0,931,932,1,0,0,0,932,933,5,85,0,
        0,933,167,1,0,0,0,934,935,5,134,0,0,935,937,5,84,0,0,936,938,3,302,
        151,0,937,936,1,0,0,0,937,938,1,0,0,0,938,939,1,0,0,0,939,940,5,
        85,0,0,940,169,1,0,0,0,941,946,3,172,86,0,942,943,5,87,0,0,943,945,
        3,172,86,0,944,942,1,0,0,0,945,948,1,0,0,0,946,944,1,0,0,0,946,947,
        1,0,0,0,947,171,1,0,0,0,948,946,1,0,0,0,949,954,3,174,87,0,950,954,
        3,180,90,0,951,954,3,184,92,0,952,954,3,192,96,0,953,949,1,0,0,0,
        953,950,1,0,0,0,953,951,1,0,0,0,953,952,1,0,0,0,954,173,1,0,0,0,
        955,956,5,17,0,0,956,959,5,84,0,0,957,960,3,176,88,0,958,960,3,178,
        89,0,959,957,1,0,0,0,959,958,1,0,0,0,960,961,1,0,0,0,961,962,5,85,
        0,0,962,175,1,0,0,0,963,964,5,165,0,0,964,965,5,105,0,0,965,966,
        3,340,170,0,966,177,1,0,0,0,967,968,5,165,0,0,968,969,7,0,0,0,969,
        970,5,67,0,0,970,179,1,0,0,0,971,972,5,26,0,0,972,973,5,84,0,0,973,
        974,3,182,91,0,974,975,5,85,0,0,975,181,1,0,0,0,976,979,3,328,164,
        0,977,979,3,330,165,0,978,976,1,0,0,0,978,977,1,0,0,0,979,980,1,
        0,0,0,980,981,5,153,0,0,981,183,1,0,0,0,982,983,5,29,0,0,983,984,
        5,84,0,0,984,985,3,186,93,0,985,986,5,85,0,0,986,185,1,0,0,0,987,
        990,3,298,149,0,988,990,3,320,160,0,989,987,1,0,0,0,989,988,1,0,
        0,0,990,187,1,0,0,0,991,994,5,127,0,0,992,995,3,176,88,0,993,995,
        3,178,89,0,994,992,1,0,0,0,994,993,1,0,0,0,995,189,1,0,0,0,996,1007,
        1,0,0,0,997,1007,5,127,0,0,998,999,5,127,0,0,999,1007,5,165,0,0,
        1000,1001,5,127,0,0,1001,1002,5,165,0,0,1002,1007,5,105,0,0,1003,
        1004,5,127,0,0,1004,1005,5,165,0,0,1005,1007,7,0,0,0,1006,996,1,
        0,0,0,1006,997,1,0,0,0,1006,998,1,0,0,0,1006,1000,1,0,0,0,1006,1003,
        1,0,0,0,1007,191,1,0,0,0,1008,1009,5,17,0,0,1009,1010,5,84,0,0,1010,
        1093,5,85,0,0,1011,1012,5,17,0,0,1012,1013,5,84,0,0,1013,1014,5,
        165,0,0,1014,1093,5,85,0,0,1015,1016,5,17,0,0,1016,1017,5,84,0,0,
        1017,1018,5,165,0,0,1018,1019,5,105,0,0,1019,1093,5,85,0,0,1020,
        1021,5,17,0,0,1021,1022,5,84,0,0,1022,1023,5,165,0,0,1023,1024,7,
        0,0,0,1024,1093,5,85,0,0,1025,1026,5,26,0,0,1026,1027,5,84,0,0,1027,
        1093,5,85,0,0,1028,1029,5,26,0,0,1029,1030,5,84,0,0,1030,1031,5,
        119,0,0,1031,1093,5,85,0,0,1032,1033,5,26,0,0,1033,1034,5,84,0,0,
        1034,1035,5,119,0,0,1035,1036,3,338,169,0,1036,1037,5,85,0,0,1037,
        1093,1,0,0,0,1038,1039,5,26,0,0,1039,1040,5,84,0,0,1040,1041,5,119,
        0,0,1041,1042,3,338,169,0,1042,1043,5,114,0,0,1043,1044,5,85,0,0,
        1044,1093,1,0,0,0,1045,1046,5,26,0,0,1046,1047,5,84,0,0,1047,1048,
        5,122,0,0,1048,1093,5,85,0,0,1049,1050,5,26,0,0,1050,1051,5,84,0,
        0,1051,1052,5,122,0,0,1052,1053,3,338,169,0,1053,1054,5,85,0,0,1054,
        1093,1,0,0,0,1055,1056,5,26,0,0,1056,1057,5,84,0,0,1057,1058,5,122,
        0,0,1058,1059,3,338,169,0,1059,1060,5,114,0,0,1060,1061,5,85,0,0,
        1061,1093,1,0,0,0,1062,1063,5,26,0,0,1063,1064,5,84,0,0,1064,1065,
        5,123,0,0,1065,1093,5,85,0,0,1066,1067,5,26,0,0,1067,1068,5,84,0,
        0,1068,1069,5,123,0,0,1069,1070,3,338,169,0,1070,1071,5,85,0,0,1071,
        1093,1,0,0,0,1072,1073,5,26,0,0,1073,1074,5,84,0,0,1074,1075,5,123,
        0,0,1075,1076,3,338,169,0,1076,1077,5,114,0,0,1077,1078,5,85,0,0,
        1078,1093,1,0,0,0,1079,1080,5,29,0,0,1080,1081,5,84,0,0,1081,1093,
        5,85,0,0,1082,1083,5,29,0,0,1083,1084,5,84,0,0,1084,1085,3,300,150,
        0,1085,1086,5,85,0,0,1086,1093,1,0,0,0,1087,1088,5,29,0,0,1088,1089,
        5,84,0,0,1089,1090,3,322,161,0,1090,1091,5,85,0,0,1091,1093,1,0,
        0,0,1092,1008,1,0,0,0,1092,1011,1,0,0,0,1092,1015,1,0,0,0,1092,1020,
        1,0,0,0,1092,1025,1,0,0,0,1092,1028,1,0,0,0,1092,1032,1,0,0,0,1092,
        1038,1,0,0,0,1092,1045,1,0,0,0,1092,1049,1,0,0,0,1092,1055,1,0,0,
        0,1092,1062,1,0,0,0,1092,1066,1,0,0,0,1092,1072,1,0,0,0,1092,1079,
        1,0,0,0,1092,1082,1,0,0,0,1092,1087,1,0,0,0,1093,193,1,0,0,0,1094,
        1099,3,196,98,0,1095,1096,5,87,0,0,1096,1098,3,196,98,0,1097,1095,
        1,0,0,0,1098,1101,1,0,0,0,1099,1097,1,0,0,0,1099,1100,1,0,0,0,1100,
        195,1,0,0,0,1101,1099,1,0,0,0,1102,1108,3,198,99,0,1103,1108,3,204,
        102,0,1104,1108,3,210,105,0,1105,1108,3,214,107,0,1106,1108,3,218,
        109,0,1107,1102,1,0,0,0,1107,1103,1,0,0,0,1107,1104,1,0,0,0,1107,
        1105,1,0,0,0,1107,1106,1,0,0,0,1108,197,1,0,0,0,1109,1110,5,17,0,
        0,1110,1113,5,84,0,0,1111,1114,3,200,100,0,1112,1114,3,202,101,0,
        1113,1111,1,0,0,0,1113,1112,1,0,0,0,1114,1115,1,0,0,0,1115,1116,
        5,85,0,0,1116,199,1,0,0,0,1117,1118,5,166,0,0,1118,1119,5,105,0,
        0,1119,1120,3,340,170,0,1120,201,1,0,0,0,1121,1122,5,166,0,0,1122,
        1123,7,0,0,0,1123,1124,5,67,0,0,1124,203,1,0,0,0,1125,1126,5,20,
        0,0,1126,1129,5,84,0,0,1127,1130,3,206,103,0,1128,1130,3,208,104,
        0,1129,1127,1,0,0,0,1129,1128,1,0,0,0,1130,1131,1,0,0,0,1131,1132,
        5,85,0,0,1132,205,1,0,0,0,1133,1134,5,164,0,0,1134,1135,3,326,163,
        0,1135,1136,3,336,168,0,1136,207,1,0,0,0,1137,1138,5,160,0,0,1138,
        1139,3,326,163,0,1139,1140,3,338,169,0,1140,209,1,0,0,0,1141,1142,
        5,26,0,0,1142,1143,5,84,0,0,1143,1144,3,212,106,0,1144,1145,5,85,
        0,0,1145,211,1,0,0,0,1146,1149,3,328,164,0,1147,1149,3,330,165,0,
        1148,1146,1,0,0,0,1148,1147,1,0,0,0,1149,1150,1,0,0,0,1150,1151,
        5,154,0,0,1151,213,1,0,0,0,1152,1153,5,29,0,0,1153,1154,5,84,0,0,
        1154,1155,3,216,108,0,1155,1156,5,85,0,0,1156,215,1,0,0,0,1157,1160,
        3,298,149,0,1158,1160,3,320,160,0,1159,1157,1,0,0,0,1159,1158,1,
        0,0,0,1160,217,1,0,0,0,1161,1162,5,17,0,0,1162,1163,5,84,0,0,1163,
        1269,5,85,0,0,1164,1165,5,17,0,0,1165,1166,5,84,0,0,1166,1167,5,
        166,0,0,1167,1269,5,85,0,0,1168,1169,5,17,0,0,1169,1170,5,84,0,0,
        1170,1171,5,166,0,0,1171,1172,5,105,0,0,1172,1269,5,85,0,0,1173,
        1174,5,17,0,0,1174,1175,5,84,0,0,1175,1176,5,166,0,0,1176,1177,7,
        0,0,0,1177,1269,5,85,0,0,1178,1179,5,20,0,0,1179,1180,5,84,0,0,1180,
        1269,5,85,0,0,1181,1182,5,20,0,0,1182,1183,5,84,0,0,1183,1184,5,
        164,0,0,1184,1269,5,85,0,0,1185,1186,5,20,0,0,1186,1187,5,84,0,0,
        1187,1188,5,164,0,0,1188,1189,3,326,163,0,1189,1190,5,85,0,0,1190,
        1269,1,0,0,0,1191,1192,5,20,0,0,1192,1193,5,84,0,0,1193,1194,5,160,
        0,0,1194,1269,5,85,0,0,1195,1196,5,20,0,0,1196,1197,5,84,0,0,1197,
        1198,5,160,0,0,1198,1199,3,326,163,0,1199,1200,5,85,0,0,1200,1269,
        1,0,0,0,1201,1202,5,26,0,0,1202,1203,5,84,0,0,1203,1269,5,85,0,0,
        1204,1205,5,26,0,0,1205,1206,5,84,0,0,1206,1207,5,119,0,0,1207,1269,
        5,85,0,0,1208,1209,5,26,0,0,1209,1210,5,84,0,0,1210,1211,5,119,0,
        0,1211,1212,3,338,169,0,1212,1213,5,85,0,0,1213,1269,1,0,0,0,1214,
        1215,5,26,0,0,1215,1216,5,84,0,0,1216,1217,5,119,0,0,1217,1218,3,
        338,169,0,1218,1219,5,114,0,0,1219,1220,5,85,0,0,1220,1269,1,0,0,
        0,1221,1222,5,26,0,0,1222,1223,5,84,0,0,1223,1224,5,122,0,0,1224,
        1269,5,85,0,0,1225,1226,5,26,0,0,1226,1227,5,84,0,0,1227,1228,5,
        122,0,0,1228,1229,3,338,169,0,1229,1230,5,85,0,0,1230,1269,1,0,0,
        0,1231,1232,5,26,0,0,1232,1233,5,84,0,0,1233,1234,5,122,0,0,1234,
        1235,3,338,169,0,1235,1236,5,114,0,0,1236,1237,5,85,0,0,1237,1269,
        1,0,0,0,1238,1239,5,26,0,0,1239,1240,5,84,0,0,1240,1241,5,123,0,
        0,1241,1269,5,85,0,0,1242,1243,5,26,0,0,1243,1244,5,84,0,0,1244,
        1245,5,123,0,0,1245,1246,3,338,169,0,1246,1247,5,85,0,0,1247,1269,
        1,0,0,0,1248,1249,5,26,0,0,1249,1250,5,84,0,0,1250,1251,5,123,0,
        0,1251,1252,3,338,169,0,1252,1253,5,114,0,0,1253,1254,5,85,0,0,1254,
        1269,1,0,0,0,1255,1256,5,29,0,0,1256,1257,5,84,0,0,1257,1269,5,85,
        0,0,1258,1259,5,29,0,0,1259,1260,5,84,0,0,1260,1261,3,300,150,0,
        1261,1262,5,85,0,0,1262,1269,1,0,0,0,1263,1264,5,29,0,0,1264,1265,
        5,84,0,0,1265,1266,3,322,161,0,1266,1267,5,85,0,0,1267,1269,1,0,
        0,0,1268,1161,1,0,0,0,1268,1164,1,0,0,0,1268,1168,1,0,0,0,1268,1173,
        1,0,0,0,1268,1178,1,0,0,0,1268,1181,1,0,0,0,1268,1185,1,0,0,0,1268,
        1191,1,0,0,0,1268,1195,1,0,0,0,1268,1201,1,0,0,0,1268,1204,1,0,0,
        0,1268,1208,1,0,0,0,1268,1214,1,0,0,0,1268,1221,1,0,0,0,1268,1225,
        1,0,0,0,1268,1231,1,0,0,0,1268,1238,1,0,0,0,1268,1242,1,0,0,0,1268,
        1248,1,0,0,0,1268,1255,1,0,0,0,1268,1258,1,0,0,0,1268,1263,1,0,0,
        0,1269,219,1,0,0,0,1270,1275,3,222,111,0,1271,1272,5,87,0,0,1272,
        1274,3,222,111,0,1273,1271,1,0,0,0,1274,1277,1,0,0,0,1275,1273,1,
        0,0,0,1275,1276,1,0,0,0,1276,221,1,0,0,0,1277,1275,1,0,0,0,1278,
        1284,3,224,112,0,1279,1284,3,230,115,0,1280,1284,3,234,117,0,1281,
        1284,3,238,119,0,1282,1284,3,242,121,0,1283,1278,1,0,0,0,1283,1279,
        1,0,0,0,1283,1280,1,0,0,0,1283,1281,1,0,0,0,1283,1282,1,0,0,0,1284,
        223,1,0,0,0,1285,1286,5,17,0,0,1286,1289,5,84,0,0,1287,1290,3,226,
        113,0,1288,1290,3,228,114,0,1289,1287,1,0,0,0,1289,1288,1,0,0,0,
        1290,1291,1,0,0,0,1291,1292,5,85,0,0,1292,225,1,0,0,0,1293,1294,
        7,6,0,0,1294,1295,5,105,0,0,1295,1296,3,340,170,0,1296,227,1,0,0,
        0,1297,1298,7,6,0,0,1298,1299,7,0,0,0,1299,1300,5,67,0,0,1300,229,
        1,0,0,0,1301,1302,5,20,0,0,1302,1303,5,84,0,0,1303,1304,3,232,116,
        0,1304,1305,5,85,0,0,1305,231,1,0,0,0,1306,1307,7,7,0,0,1307,1308,
        3,326,163,0,1308,1309,3,336,168,0,1309,233,1,0,0,0,1310,1311,5,26,
        0,0,1311,1312,5,84,0,0,1312,1313,3,236,118,0,1313,1314,5,85,0,0,
        1314,235,1,0,0,0,1315,1318,3,328,164,0,1316,1318,3,330,165,0,1317,
        1315,1,0,0,0,1317,1316,1,0,0,0,1318,1319,1,0,0,0,1319,1320,5,155,
        0,0,1320,237,1,0,0,0,1321,1322,5,29,0,0,1322,1323,5,84,0,0,1323,
        1324,3,240,120,0,1324,1325,5,85,0,0,1325,239,1,0,0,0,1326,1329,3,
        298,149,0,1327,1329,3,320,160,0,1328,1326,1,0,0,0,1328,1327,1,0,
        0,0,1329,241,1,0,0,0,1330,1331,5,17,0,0,1331,1332,5,84,0,0,1332,
        1442,5,85,0,0,1333,1334,5,17,0,0,1334,1335,5,84,0,0,1335,1336,5,
        167,0,0,1336,1442,5,85,0,0,1337,1338,5,17,0,0,1338,1339,5,84,0,0,
        1339,1340,5,167,0,0,1340,1341,5,105,0,0,1341,1442,5,85,0,0,1342,
        1343,5,17,0,0,1343,1344,5,84,0,0,1344,1345,5,167,0,0,1345,1346,7,
        0,0,0,1346,1442,5,85,0,0,1347,1348,5,17,0,0,1348,1349,5,84,0,0,1349,
        1350,5,173,0,0,1350,1442,5,85,0,0,1351,1352,5,17,0,0,1352,1353,5,
        84,0,0,1353,1354,5,173,0,0,1354,1355,5,105,0,0,1355,1442,5,85,0,
        0,1356,1357,5,17,0,0,1357,1358,5,84,0,0,1358,1359,5,173,0,0,1359,
        1360,7,0,0,0,1360,1442,5,85,0,0,1361,1362,5,20,0,0,1362,1363,5,84,
        0,0,1363,1442,5,85,0,0,1364,1365,5,20,0,0,1365,1366,5,84,0,0,1366,
        1367,7,7,0,0,1367,1442,5,85,0,0,1368,1369,5,20,0,0,1369,1370,5,84,
        0,0,1370,1371,7,7,0,0,1371,1372,3,326,163,0,1372,1373,5,85,0,0,1373,
        1442,1,0,0,0,1374,1375,5,26,0,0,1375,1376,5,84,0,0,1376,1442,5,85,
        0,0,1377,1378,5,26,0,0,1378,1379,5,84,0,0,1379,1380,5,119,0,0,1380,
        1442,5,85,0,0,1381,1382,5,26,0,0,1382,1383,5,84,0,0,1383,1384,5,
        119,0,0,1384,1385,3,338,169,0,1385,1386,5,85,0,0,1386,1442,1,0,0,
        0,1387,1388,5,26,0,0,1388,1389,5,84,0,0,1389,1390,5,119,0,0,1390,
        1391,3,338,169,0,1391,1392,5,114,0,0,1392,1393,5,85,0,0,1393,1442,
        1,0,0,0,1394,1395,5,26,0,0,1395,1396,5,84,0,0,1396,1397,5,122,0,
        0,1397,1442,5,85,0,0,1398,1399,5,26,0,0,1399,1400,5,84,0,0,1400,
        1401,5,122,0,0,1401,1402,3,338,169,0,1402,1403,5,85,0,0,1403,1442,
        1,0,0,0,1404,1405,5,26,0,0,1405,1406,5,84,0,0,1406,1407,5,122,0,
        0,1407,1408,3,338,169,0,1408,1409,5,114,0,0,1409,1410,5,85,0,0,1410,
        1442,1,0,0,0,1411,1412,5,26,0,0,1412,1413,5,84,0,0,1413,1414,5,123,
        0,0,1414,1442,5,85,0,0,1415,1416,5,26,0,0,1416,1417,5,84,0,0,1417,
        1418,5,123,0,0,1418,1419,3,338,169,0,1419,1420,5,85,0,0,1420,1442,
        1,0,0,0,1421,1422,5,26,0,0,1422,1423,5,84,0,0,1423,1424,5,123,0,
        0,1424,1425,3,338,169,0,1425,1426,5,114,0,0,1426,1427,5,85,0,0,1427,
        1442,1,0,0,0,1428,1429,5,29,0,0,1429,1430,5,84,0,0,1430,1442,5,85,
        0,0,1431,1432,5,29,0,0,1432,1433,5,84,0,0,1433,1434,3,300,150,0,
        1434,1435,5,85,0,0,1435,1442,1,0,0,0,1436,1437,5,29,0,0,1437,1438,
        5,84,0,0,1438,1439,3,322,161,0,1439,1440,5,85,0,0,1440,1442,1,0,
        0,0,1441,1330,1,0,0,0,1441,1333,1,0,0,0,1441,1337,1,0,0,0,1441,1342,
        1,0,0,0,1441,1347,1,0,0,0,1441,1351,1,0,0,0,1441,1356,1,0,0,0,1441,
        1361,1,0,0,0,1441,1364,1,0,0,0,1441,1368,1,0,0,0,1441,1374,1,0,0,
        0,1441,1377,1,0,0,0,1441,1381,1,0,0,0,1441,1387,1,0,0,0,1441,1394,
        1,0,0,0,1441,1398,1,0,0,0,1441,1404,1,0,0,0,1441,1411,1,0,0,0,1441,
        1415,1,0,0,0,1441,1421,1,0,0,0,1441,1428,1,0,0,0,1441,1431,1,0,0,
        0,1441,1436,1,0,0,0,1442,243,1,0,0,0,1443,1448,3,246,123,0,1444,
        1445,5,87,0,0,1445,1447,3,246,123,0,1446,1444,1,0,0,0,1447,1450,
        1,0,0,0,1448,1446,1,0,0,0,1448,1449,1,0,0,0,1449,245,1,0,0,0,1450,
        1448,1,0,0,0,1451,1457,3,248,124,0,1452,1457,3,254,127,0,1453,1457,
        3,258,129,0,1454,1457,3,262,131,0,1455,1457,3,266,133,0,1456,1451,
        1,0,0,0,1456,1452,1,0,0,0,1456,1453,1,0,0,0,1456,1454,1,0,0,0,1456,
        1455,1,0,0,0,1457,247,1,0,0,0,1458,1459,5,17,0,0,1459,1462,5,84,
        0,0,1460,1463,3,250,125,0,1461,1463,3,252,126,0,1462,1460,1,0,0,
        0,1462,1461,1,0,0,0,1463,1464,1,0,0,0,1464,1465,5,85,0,0,1465,249,
        1,0,0,0,1466,1467,7,8,0,0,1467,1468,5,105,0,0,1468,1469,3,340,170,
        0,1469,251,1,0,0,0,1470,1471,7,8,0,0,1471,1472,7,0,0,0,1472,1473,
        5,67,0,0,1473,253,1,0,0,0,1474,1475,5,20,0,0,1475,1476,5,84,0,0,
        1476,1477,3,256,128,0,1477,1478,5,85,0,0,1478,255,1,0,0,0,1479,1480,
        5,163,0,0,1480,1481,3,326,163,0,1481,1482,3,336,168,0,1482,257,1,
        0,0,0,1483,1484,5,26,0,0,1484,1485,5,84,0,0,1485,1486,3,260,130,
        0,1486,1487,5,85,0,0,1487,259,1,0,0,0,1488,1491,3,328,164,0,1489,
        1491,3,330,165,0,1490,1488,1,0,0,0,1490,1489,1,0,0,0,1491,1492,1,
        0,0,0,1492,1493,5,156,0,0,1493,261,1,0,0,0,1494,1495,5,29,0,0,1495,
        1496,5,84,0,0,1496,1497,3,264,132,0,1497,1498,5,85,0,0,1498,263,
        1,0,0,0,1499,1502,3,298,149,0,1500,1502,3,320,160,0,1501,1499,1,
        0,0,0,1501,1500,1,0,0,0,1502,265,1,0,0,0,1503,1504,5,17,0,0,1504,
        1505,5,84,0,0,1505,1615,5,85,0,0,1506,1507,5,17,0,0,1507,1508,5,
        84,0,0,1508,1509,5,168,0,0,1509,1615,5,85,0,0,1510,1511,5,17,0,0,
        1511,1512,5,84,0,0,1512,1513,5,168,0,0,1513,1514,5,105,0,0,1514,
        1615,5,85,0,0,1515,1516,5,17,0,0,1516,1517,5,84,0,0,1517,1518,5,
        168,0,0,1518,1519,7,0,0,0,1519,1615,5,85,0,0,1520,1521,5,17,0,0,
        1521,1522,5,84,0,0,1522,1523,5,173,0,0,1523,1615,5,85,0,0,1524,1525,
        5,17,0,0,1525,1526,5,84,0,0,1526,1527,5,173,0,0,1527,1528,5,105,
        0,0,1528,1615,5,85,0,0,1529,1530,5,17,0,0,1530,1531,5,84,0,0,1531,
        1532,5,173,0,0,1532,1533,7,0,0,0,1533,1615,5,85,0,0,1534,1535,5,
        20,0,0,1535,1536,5,84,0,0,1536,1615,5,85,0,0,1537,1538,5,20,0,0,
        1538,1539,5,84,0,0,1539,1540,5,163,0,0,1540,1615,5,85,0,0,1541,1542,
        5,20,0,0,1542,1543,5,84,0,0,1543,1544,5,163,0,0,1544,1545,3,326,
        163,0,1545,1546,5,85,0,0,1546,1615,1,0,0,0,1547,1548,5,26,0,0,1548,
        1549,5,84,0,0,1549,1615,5,85,0,0,1550,1551,5,26,0,0,1551,1552,5,
        84,0,0,1552,1553,5,119,0,0,1553,1615,5,85,0,0,1554,1555,5,26,0,0,
        1555,1556,5,84,0,0,1556,1557,5,119,0,0,1557,1558,3,338,169,0,1558,
        1559,5,85,0,0,1559,1615,1,0,0,0,1560,1561,5,26,0,0,1561,1562,5,84,
        0,0,1562,1563,5,119,0,0,1563,1564,3,338,169,0,1564,1565,5,114,0,
        0,1565,1566,5,85,0,0,1566,1615,1,0,0,0,1567,1568,5,26,0,0,1568,1569,
        5,84,0,0,1569,1570,5,122,0,0,1570,1615,5,85,0,0,1571,1572,5,26,0,
        0,1572,1573,5,84,0,0,1573,1574,5,122,0,0,1574,1575,3,338,169,0,1575,
        1576,5,85,0,0,1576,1615,1,0,0,0,1577,1578,5,26,0,0,1578,1579,5,84,
        0,0,1579,1580,5,122,0,0,1580,1581,3,338,169,0,1581,1582,5,114,0,
        0,1582,1583,5,85,0,0,1583,1615,1,0,0,0,1584,1585,5,26,0,0,1585,1586,
        5,84,0,0,1586,1587,5,123,0,0,1587,1615,5,85,0,0,1588,1589,5,26,0,
        0,1589,1590,5,84,0,0,1590,1591,5,123,0,0,1591,1592,3,338,169,0,1592,
        1593,5,85,0,0,1593,1615,1,0,0,0,1594,1595,5,26,0,0,1595,1596,5,84,
        0,0,1596,1597,5,123,0,0,1597,1598,3,338,169,0,1598,1599,5,114,0,
        0,1599,1600,5,85,0,0,1600,1615,1,0,0,0,1601,1602,5,29,0,0,1602,1603,
        5,84,0,0,1603,1615,5,85,0,0,1604,1605,5,29,0,0,1605,1606,5,84,0,
        0,1606,1607,3,300,150,0,1607,1608,5,85,0,0,1608,1615,1,0,0,0,1609,
        1610,5,29,0,0,1610,1611,5,84,0,0,1611,1612,3,322,161,0,1612,1613,
        5,85,0,0,1613,1615,1,0,0,0,1614,1503,1,0,0,0,1614,1506,1,0,0,0,1614,
        1510,1,0,0,0,1614,1515,1,0,0,0,1614,1520,1,0,0,0,1614,1524,1,0,0,
        0,1614,1529,1,0,0,0,1614,1534,1,0,0,0,1614,1537,1,0,0,0,1614,1541,
        1,0,0,0,1614,1547,1,0,0,0,1614,1550,1,0,0,0,1614,1554,1,0,0,0,1614,
        1560,1,0,0,0,1614,1567,1,0,0,0,1614,1571,1,0,0,0,1614,1577,1,0,0,
        0,1614,1584,1,0,0,0,1614,1588,1,0,0,0,1614,1594,1,0,0,0,1614,1601,
        1,0,0,0,1614,1604,1,0,0,0,1614,1609,1,0,0,0,1615,267,1,0,0,0,1616,
        1621,3,270,135,0,1617,1618,5,87,0,0,1618,1620,3,270,135,0,1619,1617,
        1,0,0,0,1620,1623,1,0,0,0,1621,1619,1,0,0,0,1621,1622,1,0,0,0,1622,
        269,1,0,0,0,1623,1621,1,0,0,0,1624,1630,3,272,136,0,1625,1630,3,
        278,139,0,1626,1630,3,282,141,0,1627,1630,3,286,143,0,1628,1630,
        3,290,145,0,1629,1624,1,0,0,0,1629,1625,1,0,0,0,1629,1626,1,0,0,
        0,1629,1627,1,0,0,0,1629,1628,1,0,0,0,1630,271,1,0,0,0,1631,1632,
        5,17,0,0,1632,1635,5,84,0,0,1633,1636,3,274,137,0,1634,1636,3,276,
        138,0,1635,1633,1,0,0,0,1635,1634,1,0,0,0,1636,1637,1,0,0,0,1637,
        1638,5,85,0,0,1638,273,1,0,0,0,1639,1640,5,170,0,0,1640,1641,5,105,
        0,0,1641,1642,3,340,170,0,1642,275,1,0,0,0,1643,1644,5,170,0,0,1644,
        1645,7,0,0,0,1645,1646,5,67,0,0,1646,277,1,0,0,0,1647,1648,5,20,
        0,0,1648,1649,5,84,0,0,1649,1650,3,280,140,0,1650,1651,5,85,0,0,
        1651,279,1,0,0,0,1652,1653,5,164,0,0,1653,1654,3,326,163,0,1654,
        1655,3,338,169,0,1655,281,1,0,0,0,1656,1657,5,26,0,0,1657,1658,5,
        84,0,0,1658,1659,3,284,142,0,1659,1660,5,85,0,0,1660,283,1,0,0,0,
        1661,1664,3,328,164,0,1662,1664,3,330,165,0,1663,1661,1,0,0,0,1663,
        1662,1,0,0,0,1664,1665,1,0,0,0,1665,1666,5,157,0,0,1666,285,1,0,
        0,0,1667,1668,5,29,0,0,1668,1669,5,84,0,0,1669,1670,3,288,144,0,
        1670,1671,5,85,0,0,1671,287,1,0,0,0,1672,1675,3,298,149,0,1673,1675,
        3,320,160,0,1674,1672,1,0,0,0,1674,1673,1,0,0,0,1675,289,1,0,0,0,
        1676,1677,5,17,0,0,1677,1678,5,84,0,0,1678,1774,5,85,0,0,1679,1680,
        5,17,0,0,1680,1681,5,84,0,0,1681,1682,5,170,0,0,1682,1774,5,85,0,
        0,1683,1684,5,17,0,0,1684,1685,5,84,0,0,1685,1686,5,170,0,0,1686,
        1687,5,105,0,0,1687,1774,5,85,0,0,1688,1689,5,17,0,0,1689,1690,5,
        84,0,0,1690,1691,5,170,0,0,1691,1692,7,0,0,0,1692,1774,5,85,0,0,
        1693,1694,5,20,0,0,1694,1695,5,84,0,0,1695,1774,5,85,0,0,1696,1697,
        5,20,0,0,1697,1698,5,84,0,0,1698,1699,5,164,0,0,1699,1774,5,85,0,
        0,1700,1701,5,20,0,0,1701,1702,5,84,0,0,1702,1703,5,164,0,0,1703,
        1704,3,326,163,0,1704,1705,5,85,0,0,1705,1774,1,0,0,0,1706,1707,
        5,26,0,0,1707,1708,5,84,0,0,1708,1774,5,85,0,0,1709,1710,5,26,0,
        0,1710,1711,5,84,0,0,1711,1712,5,119,0,0,1712,1774,5,85,0,0,1713,
        1714,5,26,0,0,1714,1715,5,84,0,0,1715,1716,5,119,0,0,1716,1717,3,
        338,169,0,1717,1718,5,85,0,0,1718,1774,1,0,0,0,1719,1720,5,26,0,
        0,1720,1721,5,84,0,0,1721,1722,5,119,0,0,1722,1723,3,338,169,0,1723,
        1724,5,114,0,0,1724,1725,5,85,0,0,1725,1774,1,0,0,0,1726,1727,5,
        26,0,0,1727,1728,5,84,0,0,1728,1729,5,122,0,0,1729,1774,5,85,0,0,
        1730,1731,5,26,0,0,1731,1732,5,84,0,0,1732,1733,5,122,0,0,1733,1734,
        3,338,169,0,1734,1735,5,85,0,0,1735,1774,1,0,0,0,1736,1737,5,26,
        0,0,1737,1738,5,84,0,0,1738,1739,5,122,0,0,1739,1740,3,338,169,0,
        1740,1741,5,114,0,0,1741,1742,5,85,0,0,1742,1774,1,0,0,0,1743,1744,
        5,26,0,0,1744,1745,5,84,0,0,1745,1746,5,123,0,0,1746,1774,5,85,0,
        0,1747,1748,5,26,0,0,1748,1749,5,84,0,0,1749,1750,5,123,0,0,1750,
        1751,3,338,169,0,1751,1752,5,85,0,0,1752,1774,1,0,0,0,1753,1754,
        5,26,0,0,1754,1755,5,84,0,0,1755,1756,5,123,0,0,1756,1757,3,338,
        169,0,1757,1758,5,114,0,0,1758,1759,5,85,0,0,1759,1774,1,0,0,0,1760,
        1761,5,29,0,0,1761,1762,5,84,0,0,1762,1774,5,85,0,0,1763,1764,5,
        29,0,0,1764,1765,5,84,0,0,1765,1766,3,300,150,0,1766,1767,5,85,0,
        0,1767,1774,1,0,0,0,1768,1769,5,29,0,0,1769,1770,5,84,0,0,1770,1771,
        3,322,161,0,1771,1772,5,85,0,0,1772,1774,1,0,0,0,1773,1676,1,0,0,
        0,1773,1679,1,0,0,0,1773,1683,1,0,0,0,1773,1688,1,0,0,0,1773,1693,
        1,0,0,0,1773,1696,1,0,0,0,1773,1700,1,0,0,0,1773,1706,1,0,0,0,1773,
        1709,1,0,0,0,1773,1713,1,0,0,0,1773,1719,1,0,0,0,1773,1726,1,0,0,
        0,1773,1730,1,0,0,0,1773,1736,1,0,0,0,1773,1743,1,0,0,0,1773,1747,
        1,0,0,0,1773,1753,1,0,0,0,1773,1760,1,0,0,0,1773,1763,1,0,0,0,1773,
        1768,1,0,0,0,1774,291,1,0,0,0,1775,1776,5,17,0,0,1776,1779,5,84,
        0,0,1777,1780,3,294,147,0,1778,1780,3,296,148,0,1779,1777,1,0,0,
        0,1779,1778,1,0,0,0,1780,1781,1,0,0,0,1781,1782,5,85,0,0,1782,293,
        1,0,0,0,1783,1784,5,171,0,0,1784,1785,5,105,0,0,1785,1786,3,340,
        170,0,1786,295,1,0,0,0,1787,1788,5,171,0,0,1788,1789,7,0,0,0,1789,
        1790,5,67,0,0,1790,297,1,0,0,0,1791,1794,5,133,0,0,1792,1795,3,294,
        147,0,1793,1795,3,296,148,0,1794,1792,1,0,0,0,1794,1793,1,0,0,0,
        1795,299,1,0,0,0,1796,1807,1,0,0,0,1797,1807,5,133,0,0,1798,1799,
        5,133,0,0,1799,1807,5,171,0,0,1800,1801,5,133,0,0,1801,1802,5,171,
        0,0,1802,1807,5,105,0,0,1803,1804,5,133,0,0,1804,1805,5,171,0,0,
        1805,1807,7,0,0,0,1806,1796,1,0,0,0,1806,1797,1,0,0,0,1806,1798,
        1,0,0,0,1806,1800,1,0,0,0,1806,1803,1,0,0,0,1807,301,1,0,0,0,1808,
        1813,3,304,152,0,1809,1810,5,87,0,0,1810,1812,3,304,152,0,1811,1809,
        1,0,0,0,1812,1815,1,0,0,0,1813,1811,1,0,0,0,1813,1814,1,0,0,0,1814,
        303,1,0,0,0,1815,1813,1,0,0,0,1816,1821,3,306,153,0,1817,1821,3,
        312,156,0,1818,1821,3,316,158,0,1819,1821,3,324,162,0,1820,1816,
        1,0,0,0,1820,1817,1,0,0,0,1820,1818,1,0,0,0,1820,1819,1,0,0,0,1821,
        305,1,0,0,0,1822,1823,5,17,0,0,1823,1826,5,84,0,0,1824,1827,3,308,
        154,0,1825,1827,3,310,155,0,1826,1824,1,0,0,0,1826,1825,1,0,0,0,
        1827,1828,1,0,0,0,1828,1829,5,85,0,0,1829,307,1,0,0,0,1830,1831,
        5,172,0,0,1831,1832,5,105,0,0,1832,1833,3,340,170,0,1833,309,1,0,
        0,0,1834,1835,5,172,0,0,1835,1836,7,0,0,0,1836,1837,5,67,0,0,1837,
        311,1,0,0,0,1838,1839,5,26,0,0,1839,1840,5,84,0,0,1840,1841,3,314,
        157,0,1841,1842,5,85,0,0,1842,313,1,0,0,0,1843,1846,3,328,164,0,
        1844,1846,3,330,165,0,1845,1843,1,0,0,0,1845,1844,1,0,0,0,1846,1847,
        1,0,0,0,1847,1848,5,158,0,0,1848,315,1,0,0,0,1849,1850,5,29,0,0,
        1850,1851,5,84,0,0,1851,1852,3,318,159,0,1852,1853,5,85,0,0,1853,
        317,1,0,0,0,1854,1857,3,298,149,0,1855,1857,3,188,94,0,1856,1854,
        1,0,0,0,1856,1855,1,0,0,0,1857,319,1,0,0,0,1858,1861,5,134,0,0,1859,
        1862,3,308,154,0,1860,1862,3,310,155,0,1861,1859,1,0,0,0,1861,1860,
        1,0,0,0,1862,321,1,0,0,0,1863,1874,1,0,0,0,1864,1874,5,134,0,0,1865,
        1866,5,134,0,0,1866,1874,5,172,0,0,1867,1868,5,134,0,0,1868,1869,
        5,172,0,0,1869,1874,5,105,0,0,1870,1871,5,134,0,0,1871,1872,5,172,
        0,0,1872,1874,7,0,0,0,1873,1863,1,0,0,0,1873,1864,1,0,0,0,1873,1865,
        1,0,0,0,1873,1867,1,0,0,0,1873,1870,1,0,0,0,1874,323,1,0,0,0,1875,
        1876,5,17,0,0,1876,1877,5,84,0,0,1877,1960,5,85,0,0,1878,1879,5,
        17,0,0,1879,1880,5,84,0,0,1880,1881,5,172,0,0,1881,1960,5,85,0,0,
        1882,1883,5,17,0,0,1883,1884,5,84,0,0,1884,1885,5,172,0,0,1885,1886,
        5,105,0,0,1886,1960,5,85,0,0,1887,1888,5,17,0,0,1888,1889,5,84,0,
        0,1889,1890,5,172,0,0,1890,1891,7,0,0,0,1891,1960,5,85,0,0,1892,
        1893,5,26,0,0,1893,1894,5,84,0,0,1894,1960,5,85,0,0,1895,1896,5,
        26,0,0,1896,1897,5,84,0,0,1897,1898,5,119,0,0,1898,1960,5,85,0,0,
        1899,1900,5,26,0,0,1900,1901,5,84,0,0,1901,1902,5,119,0,0,1902,1903,
        3,338,169,0,1903,1904,5,85,0,0,1904,1960,1,0,0,0,1905,1906,5,26,
        0,0,1906,1907,5,84,0,0,1907,1908,5,119,0,0,1908,1909,3,338,169,0,
        1909,1910,5,114,0,0,1910,1911,5,85,0,0,1911,1960,1,0,0,0,1912,1913,
        5,26,0,0,1913,1914,5,84,0,0,1914,1915,5,122,0,0,1915,1960,5,85,0,
        0,1916,1917,5,26,0,0,1917,1918,5,84,0,0,1918,1919,5,122,0,0,1919,
        1920,3,338,169,0,1920,1921,5,85,0,0,1921,1960,1,0,0,0,1922,1923,
        5,26,0,0,1923,1924,5,84,0,0,1924,1925,5,122,0,0,1925,1926,3,338,
        169,0,1926,1927,5,114,0,0,1927,1928,5,85,0,0,1928,1960,1,0,0,0,1929,
        1930,5,26,0,0,1930,1931,5,84,0,0,1931,1932,5,123,0,0,1932,1960,5,
        85,0,0,1933,1934,5,26,0,0,1934,1935,5,84,0,0,1935,1936,5,123,0,0,
        1936,1937,3,338,169,0,1937,1938,5,85,0,0,1938,1960,1,0,0,0,1939,
        1940,5,26,0,0,1940,1941,5,84,0,0,1941,1942,5,123,0,0,1942,1943,3,
        338,169,0,1943,1944,5,114,0,0,1944,1945,5,85,0,0,1945,1960,1,0,0,
        0,1946,1947,5,29,0,0,1947,1948,5,84,0,0,1948,1960,5,85,0,0,1949,
        1950,5,29,0,0,1950,1951,5,84,0,0,1951,1952,3,300,150,0,1952,1953,
        5,85,0,0,1953,1960,1,0,0,0,1954,1955,5,29,0,0,1955,1956,5,84,0,0,
        1956,1957,3,190,95,0,1957,1958,5,85,0,0,1958,1960,1,0,0,0,1959,1875,
        1,0,0,0,1959,1878,1,0,0,0,1959,1882,1,0,0,0,1959,1887,1,0,0,0,1959,
        1892,1,0,0,0,1959,1895,1,0,0,0,1959,1899,1,0,0,0,1959,1905,1,0,0,
        0,1959,1912,1,0,0,0,1959,1916,1,0,0,0,1959,1922,1,0,0,0,1959,1929,
        1,0,0,0,1959,1933,1,0,0,0,1959,1939,1,0,0,0,1959,1946,1,0,0,0,1959,
        1949,1,0,0,0,1959,1954,1,0,0,0,1960,325,1,0,0,0,1961,1962,7,9,0,
        0,1962,327,1,0,0,0,1963,1964,5,119,0,0,1964,1965,3,338,169,0,1965,
        1966,5,114,0,0,1966,329,1,0,0,0,1967,1970,3,332,166,0,1968,1970,
        3,334,167,0,1969,1967,1,0,0,0,1969,1968,1,0,0,0,1970,331,1,0,0,0,
        1971,1972,5,122,0,0,1972,1973,3,338,169,0,1973,1974,5,114,0,0,1974,
        333,1,0,0,0,1975,1976,5,123,0,0,1976,1977,3,338,169,0,1977,1978,
        5,114,0,0,1978,335,1,0,0,0,1979,1988,3,338,169,0,1980,1982,5,79,
        0,0,1981,1980,1,0,0,0,1981,1982,1,0,0,0,1982,1983,1,0,0,0,1983,1985,
        5,124,0,0,1984,1986,5,79,0,0,1985,1984,1,0,0,0,1985,1986,1,0,0,0,
        1986,1988,1,0,0,0,1987,1979,1,0,0,0,1987,1981,1,0,0,0,1988,337,1,
        0,0,0,1989,1990,5,79,0,0,1990,339,1,0,0,0,1991,1996,5,51,0,0,1992,
        1993,5,87,0,0,1993,1995,5,51,0,0,1994,1992,1,0,0,0,1995,1998,1,0,
        0,0,1996,1994,1,0,0,0,1996,1997,1,0,0,0,1997,341,1,0,0,0,1998,1996,
        1,0,0,0,93,346,350,354,409,436,441,450,456,462,508,521,533,539,544,
        575,584,594,598,602,608,621,679,694,701,705,720,726,733,748,755,
        761,769,789,809,827,841,849,867,902,909,916,923,930,937,946,953,
        959,978,989,994,1006,1092,1099,1107,1113,1129,1148,1159,1268,1275,
        1283,1289,1317,1328,1441,1448,1456,1462,1490,1501,1614,1621,1629,
        1635,1663,1674,1773,1779,1794,1806,1813,1820,1826,1845,1856,1861,
        1873,1959,1969,1981,1985,1987,1996
    ];

    private static __ATN: antlr.ATN;
    public static get _ATN(): antlr.ATN {
        if (!StudyPeriod.__ATN) {
            StudyPeriod.__ATN = new antlr.ATNDeserializer().deserialize(StudyPeriod._serializedATN);
        }

        return StudyPeriod.__ATN;
    }


    private static readonly vocabulary = new antlr.Vocabulary(StudyPeriod.literalNames, StudyPeriod.symbolicNames, []);

    public override get vocabulary(): antlr.Vocabulary {
        return StudyPeriod.vocabulary;
    }

    private static readonly decisionsToDFA = StudyPeriod._ATN.decisionToState.map( (ds: antlr.DecisionState, index: number) => new antlr.DFA(ds, index) );
}

export class Study_period_criteriaContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public overall_study_period(): Overall_study_periodContext | null {
        return this.getRuleContext(0, Overall_study_periodContext);
    }
    public overall_study_period_error(): Overall_study_period_errorContext | null {
        return this.getRuleContext(0, Overall_study_period_errorContext);
    }
    public overall_study_period_error2(): Overall_study_period_error2Context | null {
        return this.getRuleContext(0, Overall_study_period_error2Context);
    }
    public overall_study_period_error3(): Overall_study_period_error3Context | null {
        return this.getRuleContext(0, Overall_study_period_error3Context);
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_study_period_criteria;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterStudy_period_criteria) {
             listener.enterStudy_period_criteria(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitStudy_period_criteria) {
             listener.exitStudy_period_criteria(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitStudy_period_criteria) {
            return visitor.visitStudy_period_criteria(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Baseline_period_criteriaContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public baseline_period(): Baseline_periodContext | null {
        return this.getRuleContext(0, Baseline_periodContext);
    }
    public baseline_period_error(): Baseline_period_errorContext | null {
        return this.getRuleContext(0, Baseline_period_errorContext);
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_baseline_period_criteria;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterBaseline_period_criteria) {
             listener.enterBaseline_period_criteria(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitBaseline_period_criteria) {
             listener.exitBaseline_period_criteria(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitBaseline_period_criteria) {
            return visitor.visitBaseline_period_criteria(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Follow_up_period_criteriaContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public follow_up_period(): Follow_up_periodContext | null {
        return this.getRuleContext(0, Follow_up_periodContext);
    }
    public follow_up_period_error(): Follow_up_period_errorContext | null {
        return this.getRuleContext(0, Follow_up_period_errorContext);
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_follow_up_period_criteria;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterFollow_up_period_criteria) {
             listener.enterFollow_up_period_criteria(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitFollow_up_period_criteria) {
             listener.exitFollow_up_period_criteria(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitFollow_up_period_criteria) {
            return visitor.visitFollow_up_period_criteria(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Overall_study_periodContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public STUDY_PERIOD(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.STUDY_PERIOD, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.OPEN_PAREN, 0)!;
    }
    public DATE(): antlr.TerminalNode[];
    public DATE(i: number): antlr.TerminalNode | null;
    public DATE(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(StudyPeriod.DATE);
    	} else {
    		return this.getToken(StudyPeriod.DATE, i);
    	}
    }
    public COMMA(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.COMMA, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.CLOSE_PAREN, 0)!;
    }
    public SEMICOLON(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.SEMICOLON, 0)!;
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_overall_study_period;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterOverall_study_period) {
             listener.enterOverall_study_period(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitOverall_study_period) {
             listener.exitOverall_study_period(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitOverall_study_period) {
            return visitor.visitOverall_study_period(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Overall_study_period_errorContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public STUDY_PERIOD(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.STUDY_PERIOD, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.CLOSE_PAREN, 0)!;
    }
    public SEMICOLON(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.SEMICOLON, 0)!;
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_overall_study_period_error;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterOverall_study_period_error) {
             listener.enterOverall_study_period_error(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitOverall_study_period_error) {
             listener.exitOverall_study_period_error(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitOverall_study_period_error) {
            return visitor.visitOverall_study_period_error(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Overall_study_period_error2Context extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public STUDY_PERIOD(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.STUDY_PERIOD, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.OPEN_PAREN, 0)!;
    }
    public DATE(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.DATE, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.CLOSE_PAREN, 0)!;
    }
    public SEMICOLON(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.SEMICOLON, 0)!;
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_overall_study_period_error2;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterOverall_study_period_error2) {
             listener.enterOverall_study_period_error2(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitOverall_study_period_error2) {
             listener.exitOverall_study_period_error2(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitOverall_study_period_error2) {
            return visitor.visitOverall_study_period_error2(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Overall_study_period_error3Context extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public STUDY_PERIOD(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.STUDY_PERIOD, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.OPEN_PAREN, 0)!;
    }
    public DATE(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.DATE, 0)!;
    }
    public COMMA(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.COMMA, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.CLOSE_PAREN, 0)!;
    }
    public SEMICOLON(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.SEMICOLON, 0)!;
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_overall_study_period_error3;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterOverall_study_period_error3) {
             listener.enterOverall_study_period_error3(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitOverall_study_period_error3) {
             listener.exitOverall_study_period_error3(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitOverall_study_period_error3) {
            return visitor.visitOverall_study_period_error3(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Baseline_periodContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public BASELINE(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.BASELINE, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.OPEN_PAREN, 0)!;
    }
    public INT(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.INT, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.CLOSE_PAREN, 0)!;
    }
    public SEMICOLON(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.SEMICOLON, 0)!;
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_baseline_period;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterBaseline_period) {
             listener.enterBaseline_period(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitBaseline_period) {
             listener.exitBaseline_period(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitBaseline_period) {
            return visitor.visitBaseline_period(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Baseline_period_errorContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public BASELINE(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.BASELINE, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.CLOSE_PAREN, 0)!;
    }
    public SEMICOLON(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.SEMICOLON, 0)!;
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_baseline_period_error;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterBaseline_period_error) {
             listener.enterBaseline_period_error(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitBaseline_period_error) {
             listener.exitBaseline_period_error(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitBaseline_period_error) {
            return visitor.visitBaseline_period_error(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Follow_up_periodContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public FOLLOW_UP(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.FOLLOW_UP, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.OPEN_PAREN, 0)!;
    }
    public INT(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.INT, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.CLOSE_PAREN, 0)!;
    }
    public SEMICOLON(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.SEMICOLON, 0)!;
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_follow_up_period;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterFollow_up_period) {
             listener.enterFollow_up_period(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitFollow_up_period) {
             listener.exitFollow_up_period(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitFollow_up_period) {
            return visitor.visitFollow_up_period(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Follow_up_period_errorContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public FOLLOW_UP(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.FOLLOW_UP, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.CLOSE_PAREN, 0)!;
    }
    public SEMICOLON(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.SEMICOLON, 0)!;
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_follow_up_period_error;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterFollow_up_period_error) {
             listener.enterFollow_up_period_error(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitFollow_up_period_error) {
             listener.exitFollow_up_period_error(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitFollow_up_period_error) {
            return visitor.visitFollow_up_period_error(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Subjects_variableContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public SUBJECTS_VARIABLE_NAME(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.SUBJECTS_VARIABLE_NAME, 0)!;
    }
    public EQ(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.EQ, 0)!;
    }
    public SEMICOLON(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.SEMICOLON, 0)!;
    }
    public demographic_event_criteria(): Demographic_event_criteriaContext | null {
        return this.getRuleContext(0, Demographic_event_criteriaContext);
    }
    public event_count_criteria(): Event_count_criteriaContext | null {
        return this.getRuleContext(0, Event_count_criteriaContext);
    }
    public event_count_criteria_error(): Event_count_criteria_errorContext | null {
        return this.getRuleContext(0, Event_count_criteria_errorContext);
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_subjects_variable;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterSubjects_variable) {
             listener.enterSubjects_variable(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitSubjects_variable) {
             listener.exitSubjects_variable(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitSubjects_variable) {
            return visitor.visitSubjects_variable(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Event_count_criteriaContext extends antlr.ParserRuleContext {
    public _prefix?: Token | null;
    public _criteria?: Count_criteriaContext;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.CLOSE_PAREN, 0)!;
    }
    public COUNT(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.COUNT, 0)!;
    }
    public count_criteria(): Count_criteriaContext {
        return this.getRuleContext(0, Count_criteriaContext)!;
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_event_count_criteria;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterEvent_count_criteria) {
             listener.enterEvent_count_criteria(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitEvent_count_criteria) {
             listener.exitEvent_count_criteria(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitEvent_count_criteria) {
            return visitor.visitEvent_count_criteria(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Count_criteriaContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public subject_variable_event_name(): Subject_variable_event_nameContext {
        return this.getRuleContext(0, Subject_variable_event_nameContext)!;
    }
    public comparison_op(): Comparison_opContext {
        return this.getRuleContext(0, Comparison_opContext)!;
    }
    public INT(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.INT, 0)!;
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_count_criteria;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterCount_criteria) {
             listener.enterCount_criteria(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitCount_criteria) {
             listener.exitCount_criteria(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitCount_criteria) {
            return visitor.visitCount_criteria(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Event_count_criteria_errorContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public COUNT(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.COUNT, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.CLOSE_PAREN, 0)!;
    }
    public subject_variable_event_name(): Subject_variable_event_nameContext | null {
        return this.getRuleContext(0, Subject_variable_event_nameContext);
    }
    public comparison_op(): Comparison_opContext | null {
        return this.getRuleContext(0, Comparison_opContext);
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_event_count_criteria_error;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterEvent_count_criteria_error) {
             listener.enterEvent_count_criteria_error(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitEvent_count_criteria_error) {
             listener.exitEvent_count_criteria_error(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitEvent_count_criteria_error) {
            return visitor.visitEvent_count_criteria_error(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Demographic_event_criteriaContext extends antlr.ParserRuleContext {
    public _prefix?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.CLOSE_PAREN, 0)!;
    }
    public PERSON(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.PERSON, 0)!;
    }
    public demographic_event_filters(): Demographic_event_filtersContext | null {
        return this.getRuleContext(0, Demographic_event_filtersContext);
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_demographic_event_criteria;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterDemographic_event_criteria) {
             listener.enterDemographic_event_criteria(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitDemographic_event_criteria) {
             listener.exitDemographic_event_criteria(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitDemographic_event_criteria) {
            return visitor.visitDemographic_event_criteria(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Demographic_event_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public demographic_event_filter(): Demographic_event_filterContext[];
    public demographic_event_filter(i: number): Demographic_event_filterContext | null;
    public demographic_event_filter(i?: number): Demographic_event_filterContext[] | Demographic_event_filterContext | null {
        if (i === undefined) {
            return this.getRuleContexts(Demographic_event_filterContext);
        }

        return this.getRuleContext(i, Demographic_event_filterContext);
    }
    public COMMA(): antlr.TerminalNode[];
    public COMMA(i: number): antlr.TerminalNode | null;
    public COMMA(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(StudyPeriod.COMMA);
    	} else {
    		return this.getToken(StudyPeriod.COMMA, i);
    	}
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_demographic_event_filters;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterDemographic_event_filters) {
             listener.enterDemographic_event_filters(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitDemographic_event_filters) {
             listener.exitDemographic_event_filters(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitDemographic_event_filters) {
            return visitor.visitDemographic_event_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Demographic_event_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public demographic_concept_filter(): Demographic_concept_filterContext | null {
        return this.getRuleContext(0, Demographic_concept_filterContext);
    }
    public demographic_numeric_filter(): Demographic_numeric_filterContext | null {
        return this.getRuleContext(0, Demographic_numeric_filterContext);
    }
    public demographic_error_filter(): Demographic_error_filterContext | null {
        return this.getRuleContext(0, Demographic_error_filterContext);
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_demographic_event_filter;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterDemographic_event_filter) {
             listener.enterDemographic_event_filter(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitDemographic_event_filter) {
             listener.exitDemographic_event_filter(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitDemographic_event_filter) {
            return visitor.visitDemographic_event_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Demographic_concept_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CF(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.CF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.CLOSE_PAREN, 0)!;
    }
    public demographic_concept_group_filter(): Demographic_concept_group_filterContext | null {
        return this.getRuleContext(0, Demographic_concept_group_filterContext);
    }
    public demographic_concept_id_filter(): Demographic_concept_id_filterContext | null {
        return this.getRuleContext(0, Demographic_concept_id_filterContext);
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_demographic_concept_filter;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterDemographic_concept_filter) {
             listener.enterDemographic_concept_filter(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitDemographic_concept_filter) {
             listener.exitDemographic_concept_filter(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitDemographic_concept_filter) {
            return visitor.visitDemographic_concept_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Demographic_concept_group_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public PERSON_CONCEPT_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.PERSON_CONCEPT_ATTRIBUTE, 0)!;
    }
    public IN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.IN, 0)!;
    }
    public concept_group_selection(): Concept_group_selectionContext {
        return this.getRuleContext(0, Concept_group_selectionContext)!;
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_demographic_concept_group_filter;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterDemographic_concept_group_filter) {
             listener.enterDemographic_concept_group_filter(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitDemographic_concept_group_filter) {
             listener.exitDemographic_concept_group_filter(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitDemographic_concept_group_filter) {
            return visitor.visitDemographic_concept_group_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Demographic_concept_id_filterContext extends antlr.ParserRuleContext {
    public _op?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public PERSON_CONCEPT_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.PERSON_CONCEPT_ATTRIBUTE, 0)!;
    }
    public CONCEPT(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.CONCEPT, 0)!;
    }
    public EQ(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.EQ, 0);
    }
    public NEQ(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.NEQ, 0);
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_demographic_concept_id_filter;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterDemographic_concept_id_filter) {
             listener.enterDemographic_concept_id_filter(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitDemographic_concept_id_filter) {
             listener.exitDemographic_concept_id_filter(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitDemographic_concept_id_filter) {
            return visitor.visitDemographic_concept_id_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Demographic_numeric_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public NF(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.NF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.CLOSE_PAREN, 0)!;
    }
    public demographic_int_filter(): Demographic_int_filterContext | null {
        return this.getRuleContext(0, Demographic_int_filterContext);
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_demographic_numeric_filter;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterDemographic_numeric_filter) {
             listener.enterDemographic_numeric_filter(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitDemographic_numeric_filter) {
             listener.exitDemographic_numeric_filter(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitDemographic_numeric_filter) {
            return visitor.visitDemographic_numeric_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Demographic_int_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public PERSON_INT_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.PERSON_INT_ATTRIBUTE, 0)!;
    }
    public comparison_op(): Comparison_opContext {
        return this.getRuleContext(0, Comparison_opContext)!;
    }
    public INT(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.INT, 0)!;
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_demographic_int_filter;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterDemographic_int_filter) {
             listener.enterDemographic_int_filter(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitDemographic_int_filter) {
             listener.exitDemographic_int_filter(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitDemographic_int_filter) {
            return visitor.visitDemographic_int_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Demographic_error_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CF(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.CF, 0);
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.CLOSE_PAREN, 0)!;
    }
    public PERSON_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.PERSON_CONCEPT_ATTRIBUTE, 0);
    }
    public IN(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.IN, 0);
    }
    public NF(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.NF, 0);
    }
    public PERSON_INT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.PERSON_INT_ATTRIBUTE, 0);
    }
    public comparison_op(): Comparison_opContext | null {
        return this.getRuleContext(0, Comparison_opContext);
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_demographic_error_filter;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterDemographic_error_filter) {
             listener.enterDemographic_error_filter(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitDemographic_error_filter) {
             listener.exitDemographic_error_filter(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitDemographic_error_filter) {
            return visitor.visitDemographic_error_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Subject_variable_event_nameContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public SUBJECT_VARIABLE_CARE_SITE_ALIAS(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.SUBJECT_VARIABLE_CARE_SITE_ALIAS, 0);
    }
    public SUBJECT_VARIABLE_CONDITION_OCCURRENCE_ALIAS(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.SUBJECT_VARIABLE_CONDITION_OCCURRENCE_ALIAS, 0);
    }
    public SUBJECT_VARIABLE_DRUG_EXPOSURE_ALIAS(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.SUBJECT_VARIABLE_DRUG_EXPOSURE_ALIAS, 0);
    }
    public SUBJECT_VARIABLE_MEASUREMENT_ALIAS(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.SUBJECT_VARIABLE_MEASUREMENT_ALIAS, 0);
    }
    public SUBJECT_VARIABLE_OBSERVATION_ALIAS(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.SUBJECT_VARIABLE_OBSERVATION_ALIAS, 0);
    }
    public SUBJECT_VARIABLE_PROCEDURE_OCCURRENCE_ALIAS(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.SUBJECT_VARIABLE_PROCEDURE_OCCURRENCE_ALIAS, 0);
    }
    public SUBJECT_VARIABLE_PROVIDER_ALIAS(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.SUBJECT_VARIABLE_PROVIDER_ALIAS, 0);
    }
    public SUBJECT_VARIABLE_VISIT_OCCURRENCE_ALIAS(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.SUBJECT_VARIABLE_VISIT_OCCURRENCE_ALIAS, 0);
    }
    public SUBJECT_VARIABLE_DERIVED_EVENT_NAME(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.SUBJECT_VARIABLE_DERIVED_EVENT_NAME, 0);
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_subject_variable_event_name;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterSubject_variable_event_name) {
             listener.enterSubject_variable_event_name(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitSubject_variable_event_name) {
             listener.exitSubject_variable_event_name(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitSubject_variable_event_name) {
            return visitor.visitSubject_variable_event_name(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Index_dateContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public INDEX_DATE(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.INDEX_DATE, 0)!;
    }
    public EQ(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.EQ, 0)!;
    }
    public index_date_definition(): Index_date_definitionContext {
        return this.getRuleContext(0, Index_date_definitionContext)!;
    }
    public SEMICOLON(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.SEMICOLON, 0)!;
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_index_date;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterIndex_date) {
             listener.enterIndex_date(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitIndex_date) {
             listener.exitIndex_date(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitIndex_date) {
            return visitor.visitIndex_date(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Index_date_definitionContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public calendar_date(): Calendar_dateContext | null {
        return this.getRuleContext(0, Calendar_dateContext);
    }
    public calendarError(): CalendarErrorContext | null {
        return this.getRuleContext(0, CalendarErrorContext);
    }
    public index_event_date(): Index_event_dateContext | null {
        return this.getRuleContext(0, Index_event_dateContext);
    }
    public index_event_date_error(): Index_event_date_errorContext | null {
        return this.getRuleContext(0, Index_event_date_errorContext);
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_index_date_definition;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterIndex_date_definition) {
             listener.enterIndex_date_definition(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitIndex_date_definition) {
             listener.exitIndex_date_definition(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitIndex_date_definition) {
            return visitor.visitIndex_date_definition(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Calendar_dateContext extends antlr.ParserRuleContext {
    public _index_date_type?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.OPEN_PAREN, 0)!;
    }
    public DATE(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.DATE, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.CLOSE_PAREN, 0)!;
    }
    public CALENDAR_DATE(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.CALENDAR_DATE, 0)!;
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_calendar_date;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterCalendar_date) {
             listener.enterCalendar_date(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitCalendar_date) {
             listener.exitCalendar_date(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitCalendar_date) {
            return visitor.visitCalendar_date(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Index_event_dateContext extends antlr.ParserRuleContext {
    public _index_date_type?: Token | null;
    public _date?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.CLOSE_PAREN, 0)!;
    }
    public EVENT(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.EVENT, 0)!;
    }
    public INSTANCE_EVENT_NAME(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.INSTANCE_EVENT_NAME, 0);
    }
    public PERSON_DATE_TIME_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.PERSON_DATE_TIME_ATTRIBUTE, 0);
    }
    public COMMA(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.COMMA, 0);
    }
    public index_date_bounds(): Index_date_boundsContext | null {
        return this.getRuleContext(0, Index_date_boundsContext);
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_index_event_date;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterIndex_event_date) {
             listener.enterIndex_event_date(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitIndex_event_date) {
             listener.exitIndex_event_date(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitIndex_event_date) {
            return visitor.visitIndex_event_date(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Index_date_boundsContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public COMMA(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.COMMA, 0)!;
    }
    public lower_date_bounds(): Lower_date_boundsContext | null {
        return this.getRuleContext(0, Lower_date_boundsContext);
    }
    public lower_date_bounds_error(): Lower_date_bounds_errorContext | null {
        return this.getRuleContext(0, Lower_date_bounds_errorContext);
    }
    public upper_date_bounds(): Upper_date_boundsContext | null {
        return this.getRuleContext(0, Upper_date_boundsContext);
    }
    public upper_date_bounds_error(): Upper_date_bounds_errorContext | null {
        return this.getRuleContext(0, Upper_date_bounds_errorContext);
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_index_date_bounds;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterIndex_date_bounds) {
             listener.enterIndex_date_bounds(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitIndex_date_bounds) {
             listener.exitIndex_date_bounds(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitIndex_date_bounds) {
            return visitor.visitIndex_date_bounds(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Upper_date_boundsContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public UPPER_DATE_BOUND(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.UPPER_DATE_BOUND, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.OPEN_PAREN, 0)!;
    }
    public DATE(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.DATE, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_upper_date_bounds;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterUpper_date_bounds) {
             listener.enterUpper_date_bounds(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitUpper_date_bounds) {
             listener.exitUpper_date_bounds(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitUpper_date_bounds) {
            return visitor.visitUpper_date_bounds(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Lower_date_boundsContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public LOWER_DATE_BOUND(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.LOWER_DATE_BOUND, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.OPEN_PAREN, 0)!;
    }
    public DATE(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.DATE, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_lower_date_bounds;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterLower_date_bounds) {
             listener.enterLower_date_bounds(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitLower_date_bounds) {
             listener.exitLower_date_bounds(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitLower_date_bounds) {
            return visitor.visitLower_date_bounds(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class CalendarErrorContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CALENDAR_DATE(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.CALENDAR_DATE, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_calendarError;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterCalendarError) {
             listener.enterCalendarError(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitCalendarError) {
             listener.exitCalendarError(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitCalendarError) {
            return visitor.visitCalendarError(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Index_event_date_errorContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public EVENT(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.EVENT, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_index_event_date_error;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterIndex_event_date_error) {
             listener.enterIndex_event_date_error(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitIndex_event_date_error) {
             listener.exitIndex_event_date_error(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitIndex_event_date_error) {
            return visitor.visitIndex_event_date_error(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Lower_date_bounds_errorContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public LOWER_DATE_BOUND(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.LOWER_DATE_BOUND, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_lower_date_bounds_error;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterLower_date_bounds_error) {
             listener.enterLower_date_bounds_error(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitLower_date_bounds_error) {
             listener.exitLower_date_bounds_error(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitLower_date_bounds_error) {
            return visitor.visitLower_date_bounds_error(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Upper_date_bounds_errorContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public UPPER_DATE_BOUND(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.UPPER_DATE_BOUND, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_upper_date_bounds_error;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterUpper_date_bounds_error) {
             listener.enterUpper_date_bounds_error(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitUpper_date_bounds_error) {
             listener.exitUpper_date_bounds_error(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitUpper_date_bounds_error) {
            return visitor.visitUpper_date_bounds_error(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Derived_eventContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public merged_event(): Merged_eventContext | null {
        return this.getRuleContext(0, Merged_eventContext);
    }
    public sequence_event(): Sequence_eventContext | null {
        return this.getRuleContext(0, Sequence_eventContext);
    }
    public instance_event(): Instance_eventContext | null {
        return this.getRuleContext(0, Instance_eventContext);
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_derived_event;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterDerived_event) {
             listener.enterDerived_event(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitDerived_event) {
             listener.exitDerived_event(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitDerived_event) {
            return visitor.visitDerived_event(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Merged_eventContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public MERGED_EVENT_NAME(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.MERGED_EVENT_NAME, 0)!;
    }
    public EQ(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.EQ, 0)!;
    }
    public MERGED_EVENT(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.MERGED_EVENT, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.OPEN_PAREN, 0)!;
    }
    public merged_event_criteria(): Merged_event_criteriaContext {
        return this.getRuleContext(0, Merged_event_criteriaContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.CLOSE_PAREN, 0)!;
    }
    public SEMICOLON(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.SEMICOLON, 0)!;
    }
    public COMMA(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.COMMA, 0);
    }
    public merged_event_filter_criterion(): Merged_event_filter_criterionContext | null {
        return this.getRuleContext(0, Merged_event_filter_criterionContext);
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_merged_event;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterMerged_event) {
             listener.enterMerged_event(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitMerged_event) {
             listener.exitMerged_event(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitMerged_event) {
            return visitor.visitMerged_event(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Merged_event_criteriaContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public merged_event_criterion(): Merged_event_criterionContext[];
    public merged_event_criterion(i: number): Merged_event_criterionContext | null;
    public merged_event_criterion(i?: number): Merged_event_criterionContext[] | Merged_event_criterionContext | null {
        if (i === undefined) {
            return this.getRuleContexts(Merged_event_criterionContext);
        }

        return this.getRuleContext(i, Merged_event_criterionContext);
    }
    public COMMA(): antlr.TerminalNode[];
    public COMMA(i: number): antlr.TerminalNode | null;
    public COMMA(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(StudyPeriod.COMMA);
    	} else {
    		return this.getToken(StudyPeriod.COMMA, i);
    	}
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_merged_event_criteria;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterMerged_event_criteria) {
             listener.enterMerged_event_criteria(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitMerged_event_criteria) {
             listener.exitMerged_event_criteria(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitMerged_event_criteria) {
            return visitor.visitMerged_event_criteria(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Merged_event_criterionContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public merged_event_event(): Merged_event_eventContext | null {
        return this.getRuleContext(0, Merged_event_eventContext);
    }
    public derived_event_error(): Derived_event_errorContext | null {
        return this.getRuleContext(0, Derived_event_errorContext);
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_merged_event_criterion;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterMerged_event_criterion) {
             listener.enterMerged_event_criterion(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitMerged_event_criterion) {
             listener.exitMerged_event_criterion(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitMerged_event_criterion) {
            return visitor.visitMerged_event_criterion(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Merged_event_filter_criterionContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public merged_event_filter(): Merged_event_filterContext | null {
        return this.getRuleContext(0, Merged_event_filterContext);
    }
    public merged_event_filter_error(): Merged_event_filter_errorContext | null {
        return this.getRuleContext(0, Merged_event_filter_errorContext);
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_merged_event_filter_criterion;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterMerged_event_filter_criterion) {
             listener.enterMerged_event_filter_criterion(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitMerged_event_filter_criterion) {
             listener.exitMerged_event_filter_criterion(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitMerged_event_filter_criterion) {
            return visitor.visitMerged_event_filter_criterion(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Merged_event_eventContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public DERIVED_EVENT(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.DERIVED_EVENT, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.CLOSE_PAREN, 0)!;
    }
    public qualified_simple_event(): Qualified_simple_eventContext | null {
        return this.getRuleContext(0, Qualified_simple_eventContext);
    }
    public qualified_derived_event(): Qualified_derived_eventContext | null {
        return this.getRuleContext(0, Qualified_derived_eventContext);
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_merged_event_event;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterMerged_event_event) {
             listener.enterMerged_event_event(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitMerged_event_event) {
             listener.exitMerged_event_event(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitMerged_event_event) {
            return visitor.visitMerged_event_event(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Merged_event_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public merged_event_uniqueness_filter(): Merged_event_uniqueness_filterContext {
        return this.getRuleContext(0, Merged_event_uniqueness_filterContext)!;
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_merged_event_filter;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterMerged_event_filter) {
             listener.enterMerged_event_filter(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitMerged_event_filter) {
             listener.exitMerged_event_filter(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitMerged_event_filter) {
            return visitor.visitMerged_event_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Merged_event_uniqueness_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public UF(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.UF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.OPEN_PAREN, 0)!;
    }
    public merged_event_uniqueness_filter_criteria(): Merged_event_uniqueness_filter_criteriaContext {
        return this.getRuleContext(0, Merged_event_uniqueness_filter_criteriaContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_merged_event_uniqueness_filter;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterMerged_event_uniqueness_filter) {
             listener.enterMerged_event_uniqueness_filter(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitMerged_event_uniqueness_filter) {
             listener.exitMerged_event_uniqueness_filter(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitMerged_event_uniqueness_filter) {
            return visitor.visitMerged_event_uniqueness_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Merged_event_uniqueness_filter_criteriaContext extends antlr.ParserRuleContext {
    public _date_attr?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public DERIVED_EVENT_DATE(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.DERIVED_EVENT_DATE, 0)!;
    }
    public derived_uniqueness_filter(): Derived_uniqueness_filterContext | null {
        return this.getRuleContext(0, Derived_uniqueness_filterContext);
    }
    public derived_uniqueness_filter_window(): Derived_uniqueness_filter_windowContext | null {
        return this.getRuleContext(0, Derived_uniqueness_filter_windowContext);
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_merged_event_uniqueness_filter_criteria;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterMerged_event_uniqueness_filter_criteria) {
             listener.enterMerged_event_uniqueness_filter_criteria(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitMerged_event_uniqueness_filter_criteria) {
             listener.exitMerged_event_uniqueness_filter_criteria(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitMerged_event_uniqueness_filter_criteria) {
            return visitor.visitMerged_event_uniqueness_filter_criteria(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Merged_event_filter_errorContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public UF(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.UF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.CLOSE_PAREN, 0)!;
    }
    public MINIMUM_BETWEEN(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.MINIMUM_BETWEEN, 0);
    }
    public derived_event_int(): Derived_event_intContext | null {
        return this.getRuleContext(0, Derived_event_intContext);
    }
    public TIME_UNIT(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.TIME_UNIT, 0);
    }
    public FIXED_WINDOW(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.FIXED_WINDOW, 0);
    }
    public ROLLING_WINDOW(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.ROLLING_WINDOW, 0);
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_merged_event_filter_error;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterMerged_event_filter_error) {
             listener.enterMerged_event_filter_error(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitMerged_event_filter_error) {
             listener.exitMerged_event_filter_error(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitMerged_event_filter_error) {
            return visitor.visitMerged_event_filter_error(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Sequence_eventContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public SEQUENCE_EVENT_NAME(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.SEQUENCE_EVENT_NAME, 0)!;
    }
    public EQ(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.EQ, 0)!;
    }
    public SEQUENCE_EVENT(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.SEQUENCE_EVENT, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.OPEN_PAREN, 0)!;
    }
    public sequence_event_criteria(): Sequence_event_criteriaContext {
        return this.getRuleContext(0, Sequence_event_criteriaContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.CLOSE_PAREN, 0)!;
    }
    public SEMICOLON(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.SEMICOLON, 0)!;
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_sequence_event;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterSequence_event) {
             listener.enterSequence_event(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitSequence_event) {
             listener.exitSequence_event(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitSequence_event) {
            return visitor.visitSequence_event(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Sequence_event_criteriaContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public sequence_event_criterion(): Sequence_event_criterionContext[];
    public sequence_event_criterion(i: number): Sequence_event_criterionContext | null;
    public sequence_event_criterion(i?: number): Sequence_event_criterionContext[] | Sequence_event_criterionContext | null {
        if (i === undefined) {
            return this.getRuleContexts(Sequence_event_criterionContext);
        }

        return this.getRuleContext(i, Sequence_event_criterionContext);
    }
    public COMMA(): antlr.TerminalNode[];
    public COMMA(i: number): antlr.TerminalNode | null;
    public COMMA(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(StudyPeriod.COMMA);
    	} else {
    		return this.getToken(StudyPeriod.COMMA, i);
    	}
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_sequence_event_criteria;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterSequence_event_criteria) {
             listener.enterSequence_event_criteria(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitSequence_event_criteria) {
             listener.exitSequence_event_criteria(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitSequence_event_criteria) {
            return visitor.visitSequence_event_criteria(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Sequence_event_criterionContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public sequence_event_constraint(): Sequence_event_constraintContext | null {
        return this.getRuleContext(0, Sequence_event_constraintContext);
    }
    public sequence_event_event(): Sequence_event_eventContext | null {
        return this.getRuleContext(0, Sequence_event_eventContext);
    }
    public sequence_event_constraint_error(): Sequence_event_constraint_errorContext | null {
        return this.getRuleContext(0, Sequence_event_constraint_errorContext);
    }
    public derived_event_error(): Derived_event_errorContext | null {
        return this.getRuleContext(0, Derived_event_errorContext);
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_sequence_event_criterion;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterSequence_event_criterion) {
             listener.enterSequence_event_criterion(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitSequence_event_criterion) {
             listener.exitSequence_event_criterion(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitSequence_event_criterion) {
            return visitor.visitSequence_event_criterion(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Sequence_event_constraintContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public ANY_ORDER(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.ANY_ORDER, 0);
    }
    public temporal_constraint(): Temporal_constraintContext | null {
        return this.getRuleContext(0, Temporal_constraintContext);
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_sequence_event_constraint;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterSequence_event_constraint) {
             listener.enterSequence_event_constraint(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitSequence_event_constraint) {
             listener.exitSequence_event_constraint(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitSequence_event_constraint) {
            return visitor.visitSequence_event_constraint(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Temporal_constraintContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public TC(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.TC, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.OPEN_PAREN, 0)!;
    }
    public sequence_temporal_filter(): Sequence_temporal_filterContext {
        return this.getRuleContext(0, Sequence_temporal_filterContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_temporal_constraint;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterTemporal_constraint) {
             listener.enterTemporal_constraint(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitTemporal_constraint) {
             listener.exitTemporal_constraint(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitTemporal_constraint) {
            return visitor.visitTemporal_constraint(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Sequence_temporal_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public INT(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.INT, 0)!;
    }
    public TIME_UNIT(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.TIME_UNIT, 0)!;
    }
    public MINIMUM_BETWEEN(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.MINIMUM_BETWEEN, 0);
    }
    public MAXIMUM_BETWEEN(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.MAXIMUM_BETWEEN, 0);
    }
    public TOTAL_BETWEEN(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.TOTAL_BETWEEN, 0);
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_sequence_temporal_filter;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterSequence_temporal_filter) {
             listener.enterSequence_temporal_filter(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitSequence_temporal_filter) {
             listener.exitSequence_temporal_filter(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitSequence_temporal_filter) {
            return visitor.visitSequence_temporal_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Sequence_event_eventContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public DERIVED_EVENT(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.DERIVED_EVENT, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.CLOSE_PAREN, 0)!;
    }
    public selected_sequence_event(): Selected_sequence_eventContext | null {
        return this.getRuleContext(0, Selected_sequence_eventContext);
    }
    public unselected_sequence_event(): Unselected_sequence_eventContext | null {
        return this.getRuleContext(0, Unselected_sequence_eventContext);
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_sequence_event_event;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterSequence_event_event) {
             listener.enterSequence_event_event(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitSequence_event_event) {
             listener.exitSequence_event_event(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitSequence_event_event) {
            return visitor.visitSequence_event_event(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Selected_sequence_eventContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public COMMA(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.COMMA, 0)!;
    }
    public IS_EVENT_DATE(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.IS_EVENT_DATE, 0)!;
    }
    public qualified_simple_event(): Qualified_simple_eventContext | null {
        return this.getRuleContext(0, Qualified_simple_eventContext);
    }
    public qualified_derived_event(): Qualified_derived_eventContext | null {
        return this.getRuleContext(0, Qualified_derived_eventContext);
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_selected_sequence_event;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterSelected_sequence_event) {
             listener.enterSelected_sequence_event(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitSelected_sequence_event) {
             listener.exitSelected_sequence_event(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitSelected_sequence_event) {
            return visitor.visitSelected_sequence_event(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Unselected_sequence_eventContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public qualified_simple_event(): Qualified_simple_eventContext | null {
        return this.getRuleContext(0, Qualified_simple_eventContext);
    }
    public qualified_derived_event(): Qualified_derived_eventContext | null {
        return this.getRuleContext(0, Qualified_derived_eventContext);
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_unselected_sequence_event;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterUnselected_sequence_event) {
             listener.enterUnselected_sequence_event(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitUnselected_sequence_event) {
             listener.exitUnselected_sequence_event(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitUnselected_sequence_event) {
            return visitor.visitUnselected_sequence_event(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Instance_eventContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public INSTANCE_EVENT_NAME(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.INSTANCE_EVENT_NAME, 0)!;
    }
    public EQ(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.EQ, 0)!;
    }
    public INSTANCE_EVENT(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.INSTANCE_EVENT, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.OPEN_PAREN, 0)!;
    }
    public instance_event_criteria(): Instance_event_criteriaContext {
        return this.getRuleContext(0, Instance_event_criteriaContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.CLOSE_PAREN, 0)!;
    }
    public SEMICOLON(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.SEMICOLON, 0)!;
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_instance_event;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterInstance_event) {
             listener.enterInstance_event(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitInstance_event) {
             listener.exitInstance_event(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitInstance_event) {
            return visitor.visitInstance_event(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Instance_event_criteriaContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public instance_event_criterion(): Instance_event_criterionContext[];
    public instance_event_criterion(i: number): Instance_event_criterionContext | null;
    public instance_event_criterion(i?: number): Instance_event_criterionContext[] | Instance_event_criterionContext | null {
        if (i === undefined) {
            return this.getRuleContexts(Instance_event_criterionContext);
        }

        return this.getRuleContext(i, Instance_event_criterionContext);
    }
    public COMMA(): antlr.TerminalNode[];
    public COMMA(i: number): antlr.TerminalNode | null;
    public COMMA(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(StudyPeriod.COMMA);
    	} else {
    		return this.getToken(StudyPeriod.COMMA, i);
    	}
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_instance_event_criteria;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterInstance_event_criteria) {
             listener.enterInstance_event_criteria(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitInstance_event_criteria) {
             listener.exitInstance_event_criteria(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitInstance_event_criteria) {
            return visitor.visitInstance_event_criteria(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Instance_event_criterionContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public instance_event_event(): Instance_event_eventContext | null {
        return this.getRuleContext(0, Instance_event_eventContext);
    }
    public derived_event_error(): Derived_event_errorContext | null {
        return this.getRuleContext(0, Derived_event_errorContext);
    }
    public instance_event_position(): Instance_event_positionContext | null {
        return this.getRuleContext(0, Instance_event_positionContext);
    }
    public instance_event_position_error(): Instance_event_position_errorContext | null {
        return this.getRuleContext(0, Instance_event_position_errorContext);
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_instance_event_criterion;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterInstance_event_criterion) {
             listener.enterInstance_event_criterion(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitInstance_event_criterion) {
             listener.exitInstance_event_criterion(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitInstance_event_criterion) {
            return visitor.visitInstance_event_criterion(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Instance_event_eventContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public DERIVED_EVENT(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.DERIVED_EVENT, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.CLOSE_PAREN, 0)!;
    }
    public qualified_simple_event(): Qualified_simple_eventContext | null {
        return this.getRuleContext(0, Qualified_simple_eventContext);
    }
    public qualified_derived_event(): Qualified_derived_eventContext | null {
        return this.getRuleContext(0, Qualified_derived_eventContext);
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_instance_event_event;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterInstance_event_event) {
             listener.enterInstance_event_event(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitInstance_event_event) {
             listener.exitInstance_event_event(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitInstance_event_event) {
            return visitor.visitInstance_event_event(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Instance_event_positionContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public POSITION(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.POSITION, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.CLOSE_PAREN, 0)!;
    }
    public aggregation_qualified(): Aggregation_qualifiedContext | null {
        return this.getRuleContext(0, Aggregation_qualifiedContext);
    }
    public specific_instance(): Specific_instanceContext | null {
        return this.getRuleContext(0, Specific_instanceContext);
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_instance_event_position;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterInstance_event_position) {
             listener.enterInstance_event_position(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitInstance_event_position) {
             listener.exitInstance_event_position(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitInstance_event_position) {
            return visitor.visitInstance_event_position(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Aggregation_qualifiedContext extends antlr.ParserRuleContext {
    public _op?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public MAX(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.MAX, 0);
    }
    public MIN(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.MIN, 0);
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_aggregation_qualified;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterAggregation_qualified) {
             listener.enterAggregation_qualified(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitAggregation_qualified) {
             listener.exitAggregation_qualified(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitAggregation_qualified) {
            return visitor.visitAggregation_qualified(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Specific_instanceContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public INDEX(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.INDEX, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.OPEN_PAREN, 0)!;
    }
    public INT(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.INT, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_specific_instance;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterSpecific_instance) {
             listener.enterSpecific_instance(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitSpecific_instance) {
             listener.exitSpecific_instance(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitSpecific_instance) {
            return visitor.visitSpecific_instance(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Instance_event_position_errorContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public POSITION(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.POSITION, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode[];
    public OPEN_PAREN(i: number): antlr.TerminalNode | null;
    public OPEN_PAREN(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(StudyPeriod.OPEN_PAREN);
    	} else {
    		return this.getToken(StudyPeriod.OPEN_PAREN, i);
    	}
    }
    public CLOSE_PAREN(): antlr.TerminalNode[];
    public CLOSE_PAREN(i: number): antlr.TerminalNode | null;
    public CLOSE_PAREN(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(StudyPeriod.CLOSE_PAREN);
    	} else {
    		return this.getToken(StudyPeriod.CLOSE_PAREN, i);
    	}
    }
    public INDEX(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.INDEX, 0);
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_instance_event_position_error;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterInstance_event_position_error) {
             listener.enterInstance_event_position_error(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitInstance_event_position_error) {
             listener.exitInstance_event_position_error(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitInstance_event_position_error) {
            return visitor.visitInstance_event_position_error(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Qualified_simple_eventContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public QUALIFIED_CONDITION_OCCURRENCE_ALIAS(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.QUALIFIED_CONDITION_OCCURRENCE_ALIAS, 0);
    }
    public PERIOD(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.PERIOD, 0)!;
    }
    public CONDITION_OCCURRENCE_DATE_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.CONDITION_OCCURRENCE_DATE_ATTRIBUTE, 0);
    }
    public QUALIFIED_DRUG_EXPOSURE_ALIAS(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.QUALIFIED_DRUG_EXPOSURE_ALIAS, 0);
    }
    public DRUG_EXPOSURE_DATE_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.DRUG_EXPOSURE_DATE_ATTRIBUTE, 0);
    }
    public QUALIFIED_MEASUREMENT_ALIAS(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.QUALIFIED_MEASUREMENT_ALIAS, 0);
    }
    public MEASUREMENT_DATE_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.MEASUREMENT_DATE_ATTRIBUTE, 0);
    }
    public QUALIFIED_OBSERVATION_ALIAS(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.QUALIFIED_OBSERVATION_ALIAS, 0);
    }
    public OBSERVATION_DATE_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.OBSERVATION_DATE_ATTRIBUTE, 0);
    }
    public QUALIFIED_PROCEDURE_OCCURRENCE_ALIAS(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.QUALIFIED_PROCEDURE_OCCURRENCE_ALIAS, 0);
    }
    public PROCEDURE_OCCURRENCE_DATE_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.PROCEDURE_OCCURRENCE_DATE_ATTRIBUTE, 0);
    }
    public QUALIFIED_VISIT_OCCURRENCE_ALIAS(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.QUALIFIED_VISIT_OCCURRENCE_ALIAS, 0);
    }
    public VISIT_OCCURRENCE_DATE_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.VISIT_OCCURRENCE_DATE_ATTRIBUTE, 0);
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_qualified_simple_event;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterQualified_simple_event) {
             listener.enterQualified_simple_event(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitQualified_simple_event) {
             listener.exitQualified_simple_event(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitQualified_simple_event) {
            return visitor.visitQualified_simple_event(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Qualified_derived_eventContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public QUALIFIED_DERIVED_EVENT_NAME(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.QUALIFIED_DERIVED_EVENT_NAME, 0)!;
    }
    public PERIOD(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.PERIOD, 0)!;
    }
    public DERIVED_EVENT_DATE(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.DERIVED_EVENT_DATE, 0)!;
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_qualified_derived_event;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterQualified_derived_event) {
             listener.enterQualified_derived_event(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitQualified_derived_event) {
             listener.exitQualified_derived_event(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitQualified_derived_event) {
            return visitor.visitQualified_derived_event(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Sequence_event_constraint_errorContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public TC(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.TC, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.CLOSE_PAREN, 0)!;
    }
    public MINIMUM_BETWEEN(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.MINIMUM_BETWEEN, 0);
    }
    public MAXIMUM_BETWEEN(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.MAXIMUM_BETWEEN, 0);
    }
    public TOTAL_BETWEEN(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.TOTAL_BETWEEN, 0);
    }
    public INT(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.INT, 0);
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_sequence_event_constraint_error;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterSequence_event_constraint_error) {
             listener.enterSequence_event_constraint_error(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitSequence_event_constraint_error) {
             listener.exitSequence_event_constraint_error(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitSequence_event_constraint_error) {
            return visitor.visitSequence_event_constraint_error(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Derived_event_errorContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public DERIVED_EVENT(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.DERIVED_EVENT, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.CLOSE_PAREN, 0)!;
    }
    public QUALIFIED_CONDITION_OCCURRENCE_ALIAS(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.QUALIFIED_CONDITION_OCCURRENCE_ALIAS, 0);
    }
    public QUALIFIED_DRUG_EXPOSURE_ALIAS(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.QUALIFIED_DRUG_EXPOSURE_ALIAS, 0);
    }
    public QUALIFIED_MEASUREMENT_ALIAS(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.QUALIFIED_MEASUREMENT_ALIAS, 0);
    }
    public QUALIFIED_OBSERVATION_ALIAS(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.QUALIFIED_OBSERVATION_ALIAS, 0);
    }
    public QUALIFIED_PROCEDURE_OCCURRENCE_ALIAS(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.QUALIFIED_PROCEDURE_OCCURRENCE_ALIAS, 0);
    }
    public QUALIFIED_VISIT_OCCURRENCE_ALIAS(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.QUALIFIED_VISIT_OCCURRENCE_ALIAS, 0);
    }
    public QUALIFIED_DERIVED_EVENT_NAME(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.QUALIFIED_DERIVED_EVENT_NAME, 0);
    }
    public PERIOD(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.PERIOD, 0);
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_derived_event_error;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterDerived_event_error) {
             listener.enterDerived_event_error(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitDerived_event_error) {
             listener.exitDerived_event_error(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitDerived_event_error) {
            return visitor.visitDerived_event_error(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Derived_uniqueness_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public MINIMUM_BETWEEN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.MINIMUM_BETWEEN, 0)!;
    }
    public derived_event_int(): Derived_event_intContext {
        return this.getRuleContext(0, Derived_event_intContext)!;
    }
    public TIME_UNIT(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.TIME_UNIT, 0)!;
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_derived_uniqueness_filter;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterDerived_uniqueness_filter) {
             listener.enterDerived_uniqueness_filter(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitDerived_uniqueness_filter) {
             listener.exitDerived_uniqueness_filter(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitDerived_uniqueness_filter) {
            return visitor.visitDerived_uniqueness_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Derived_uniqueness_filter_windowContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public derived_fixed_window_uniqueness_filter(): Derived_fixed_window_uniqueness_filterContext | null {
        return this.getRuleContext(0, Derived_fixed_window_uniqueness_filterContext);
    }
    public derived_rolling_window_uniqueness_filter(): Derived_rolling_window_uniqueness_filterContext | null {
        return this.getRuleContext(0, Derived_rolling_window_uniqueness_filterContext);
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_derived_uniqueness_filter_window;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterDerived_uniqueness_filter_window) {
             listener.enterDerived_uniqueness_filter_window(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitDerived_uniqueness_filter_window) {
             listener.exitDerived_uniqueness_filter_window(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitDerived_uniqueness_filter_window) {
            return visitor.visitDerived_uniqueness_filter_window(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Derived_fixed_window_uniqueness_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public FIXED_WINDOW(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.FIXED_WINDOW, 0)!;
    }
    public derived_event_int(): Derived_event_intContext {
        return this.getRuleContext(0, Derived_event_intContext)!;
    }
    public TIME_UNIT(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.TIME_UNIT, 0)!;
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_derived_fixed_window_uniqueness_filter;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterDerived_fixed_window_uniqueness_filter) {
             listener.enterDerived_fixed_window_uniqueness_filter(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitDerived_fixed_window_uniqueness_filter) {
             listener.exitDerived_fixed_window_uniqueness_filter(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitDerived_fixed_window_uniqueness_filter) {
            return visitor.visitDerived_fixed_window_uniqueness_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Derived_rolling_window_uniqueness_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public ROLLING_WINDOW(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.ROLLING_WINDOW, 0)!;
    }
    public derived_event_int(): Derived_event_intContext {
        return this.getRuleContext(0, Derived_event_intContext)!;
    }
    public TIME_UNIT(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.TIME_UNIT, 0)!;
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_derived_rolling_window_uniqueness_filter;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterDerived_rolling_window_uniqueness_filter) {
             listener.enterDerived_rolling_window_uniqueness_filter(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitDerived_rolling_window_uniqueness_filter) {
             listener.exitDerived_rolling_window_uniqueness_filter(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitDerived_rolling_window_uniqueness_filter) {
            return visitor.visitDerived_rolling_window_uniqueness_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Derived_event_intContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public INT(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.INT, 0)!;
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_derived_event_int;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterDerived_event_int) {
             listener.enterDerived_event_int(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitDerived_event_int) {
             listener.exitDerived_event_int(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitDerived_event_int) {
            return visitor.visitDerived_event_int(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Simple_eventContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public condition_occurrence_event(): Condition_occurrence_eventContext | null {
        return this.getRuleContext(0, Condition_occurrence_eventContext);
    }
    public drug_exposure_event(): Drug_exposure_eventContext | null {
        return this.getRuleContext(0, Drug_exposure_eventContext);
    }
    public measurement_event(): Measurement_eventContext | null {
        return this.getRuleContext(0, Measurement_eventContext);
    }
    public observation_event(): Observation_eventContext | null {
        return this.getRuleContext(0, Observation_eventContext);
    }
    public procedure_occurrence_event(): Procedure_occurrence_eventContext | null {
        return this.getRuleContext(0, Procedure_occurrence_eventContext);
    }
    public visit_occurrence_event(): Visit_occurrence_eventContext | null {
        return this.getRuleContext(0, Visit_occurrence_eventContext);
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_simple_event;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterSimple_event) {
             listener.enterSimple_event(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitSimple_event) {
             listener.exitSimple_event(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitSimple_event) {
            return visitor.visitSimple_event(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Condition_occurrence_eventContext extends antlr.ParserRuleContext {
    public _event_name?: Token | null;
    public _event_definition?: Condition_occurrence_event_definitionContext;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public EQ(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.EQ, 0)!;
    }
    public SEMICOLON(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.SEMICOLON, 0)!;
    }
    public CONDITION_OCCURRENCE_ALIAS(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.CONDITION_OCCURRENCE_ALIAS, 0)!;
    }
    public condition_occurrence_event_definition(): Condition_occurrence_event_definitionContext {
        return this.getRuleContext(0, Condition_occurrence_event_definitionContext)!;
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_condition_occurrence_event;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterCondition_occurrence_event) {
             listener.enterCondition_occurrence_event(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitCondition_occurrence_event) {
             listener.exitCondition_occurrence_event(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitCondition_occurrence_event) {
            return visitor.visitCondition_occurrence_event(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Drug_exposure_eventContext extends antlr.ParserRuleContext {
    public _event_name?: Token | null;
    public _event_definition?: Drug_exposure_event_definitionContext;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public EQ(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.EQ, 0)!;
    }
    public SEMICOLON(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.SEMICOLON, 0)!;
    }
    public DRUG_EXPOSURE_ALIAS(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.DRUG_EXPOSURE_ALIAS, 0)!;
    }
    public drug_exposure_event_definition(): Drug_exposure_event_definitionContext {
        return this.getRuleContext(0, Drug_exposure_event_definitionContext)!;
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_drug_exposure_event;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterDrug_exposure_event) {
             listener.enterDrug_exposure_event(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitDrug_exposure_event) {
             listener.exitDrug_exposure_event(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitDrug_exposure_event) {
            return visitor.visitDrug_exposure_event(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Measurement_eventContext extends antlr.ParserRuleContext {
    public _event_name?: Token | null;
    public _event_definition?: Measurement_event_definitionContext;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public EQ(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.EQ, 0)!;
    }
    public SEMICOLON(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.SEMICOLON, 0)!;
    }
    public MEASUREMENT_ALIAS(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.MEASUREMENT_ALIAS, 0)!;
    }
    public measurement_event_definition(): Measurement_event_definitionContext {
        return this.getRuleContext(0, Measurement_event_definitionContext)!;
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_measurement_event;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterMeasurement_event) {
             listener.enterMeasurement_event(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitMeasurement_event) {
             listener.exitMeasurement_event(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitMeasurement_event) {
            return visitor.visitMeasurement_event(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Observation_eventContext extends antlr.ParserRuleContext {
    public _event_name?: Token | null;
    public _event_definition?: Observation_event_definitionContext;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public EQ(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.EQ, 0)!;
    }
    public SEMICOLON(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.SEMICOLON, 0)!;
    }
    public OBSERVATION_ALIAS(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.OBSERVATION_ALIAS, 0)!;
    }
    public observation_event_definition(): Observation_event_definitionContext {
        return this.getRuleContext(0, Observation_event_definitionContext)!;
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_observation_event;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterObservation_event) {
             listener.enterObservation_event(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitObservation_event) {
             listener.exitObservation_event(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitObservation_event) {
            return visitor.visitObservation_event(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Procedure_occurrence_eventContext extends antlr.ParserRuleContext {
    public _event_name?: Token | null;
    public _event_definition?: Procedure_occurrence_event_definitionContext;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public EQ(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.EQ, 0)!;
    }
    public SEMICOLON(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.SEMICOLON, 0)!;
    }
    public PROCEDURE_OCCURRENCE_ALIAS(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.PROCEDURE_OCCURRENCE_ALIAS, 0)!;
    }
    public procedure_occurrence_event_definition(): Procedure_occurrence_event_definitionContext {
        return this.getRuleContext(0, Procedure_occurrence_event_definitionContext)!;
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_procedure_occurrence_event;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterProcedure_occurrence_event) {
             listener.enterProcedure_occurrence_event(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitProcedure_occurrence_event) {
             listener.exitProcedure_occurrence_event(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitProcedure_occurrence_event) {
            return visitor.visitProcedure_occurrence_event(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Visit_occurrence_eventContext extends antlr.ParserRuleContext {
    public _event_name?: Token | null;
    public _event_definition?: Visit_occurrence_event_definitionContext;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public EQ(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.EQ, 0)!;
    }
    public SEMICOLON(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.SEMICOLON, 0)!;
    }
    public VISIT_OCCURRENCE_ALIAS(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.VISIT_OCCURRENCE_ALIAS, 0)!;
    }
    public visit_occurrence_event_definition(): Visit_occurrence_event_definitionContext {
        return this.getRuleContext(0, Visit_occurrence_event_definitionContext)!;
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_visit_occurrence_event;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterVisit_occurrence_event) {
             listener.enterVisit_occurrence_event(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitVisit_occurrence_event) {
             listener.exitVisit_occurrence_event(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitVisit_occurrence_event) {
            return visitor.visitVisit_occurrence_event(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Condition_occurrence_event_definitionContext extends antlr.ParserRuleContext {
    public _prefix?: Token | null;
    public _criteria?: Condition_occurrence_event_criteriaContext;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.CLOSE_PAREN, 0)!;
    }
    public CONDITION_OCCURRENCE(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.CONDITION_OCCURRENCE, 0)!;
    }
    public condition_occurrence_event_criteria(): Condition_occurrence_event_criteriaContext | null {
        return this.getRuleContext(0, Condition_occurrence_event_criteriaContext);
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_condition_occurrence_event_definition;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterCondition_occurrence_event_definition) {
             listener.enterCondition_occurrence_event_definition(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitCondition_occurrence_event_definition) {
             listener.exitCondition_occurrence_event_definition(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitCondition_occurrence_event_definition) {
            return visitor.visitCondition_occurrence_event_definition(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Drug_exposure_event_definitionContext extends antlr.ParserRuleContext {
    public _prefix?: Token | null;
    public _criteria?: Drug_exposure_event_criteriaContext;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.CLOSE_PAREN, 0)!;
    }
    public DRUG_EXPOSURE(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.DRUG_EXPOSURE, 0)!;
    }
    public drug_exposure_event_criteria(): Drug_exposure_event_criteriaContext | null {
        return this.getRuleContext(0, Drug_exposure_event_criteriaContext);
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_drug_exposure_event_definition;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterDrug_exposure_event_definition) {
             listener.enterDrug_exposure_event_definition(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitDrug_exposure_event_definition) {
             listener.exitDrug_exposure_event_definition(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitDrug_exposure_event_definition) {
            return visitor.visitDrug_exposure_event_definition(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Measurement_event_definitionContext extends antlr.ParserRuleContext {
    public _prefix?: Token | null;
    public _criteria?: Measurement_event_criteriaContext;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.CLOSE_PAREN, 0)!;
    }
    public MEASUREMENT(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.MEASUREMENT, 0)!;
    }
    public measurement_event_criteria(): Measurement_event_criteriaContext | null {
        return this.getRuleContext(0, Measurement_event_criteriaContext);
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_measurement_event_definition;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterMeasurement_event_definition) {
             listener.enterMeasurement_event_definition(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitMeasurement_event_definition) {
             listener.exitMeasurement_event_definition(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitMeasurement_event_definition) {
            return visitor.visitMeasurement_event_definition(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Observation_event_definitionContext extends antlr.ParserRuleContext {
    public _prefix?: Token | null;
    public _criteria?: Observation_event_criteriaContext;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.CLOSE_PAREN, 0)!;
    }
    public OBSERVATION(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.OBSERVATION, 0)!;
    }
    public observation_event_criteria(): Observation_event_criteriaContext | null {
        return this.getRuleContext(0, Observation_event_criteriaContext);
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_observation_event_definition;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterObservation_event_definition) {
             listener.enterObservation_event_definition(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitObservation_event_definition) {
             listener.exitObservation_event_definition(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitObservation_event_definition) {
            return visitor.visitObservation_event_definition(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Procedure_occurrence_event_definitionContext extends antlr.ParserRuleContext {
    public _prefix?: Token | null;
    public _criteria?: Procedure_occurrence_event_criteriaContext;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.CLOSE_PAREN, 0)!;
    }
    public PROCEDURE_OCCURRENCE(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.PROCEDURE_OCCURRENCE, 0)!;
    }
    public procedure_occurrence_event_criteria(): Procedure_occurrence_event_criteriaContext | null {
        return this.getRuleContext(0, Procedure_occurrence_event_criteriaContext);
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_procedure_occurrence_event_definition;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterProcedure_occurrence_event_definition) {
             listener.enterProcedure_occurrence_event_definition(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitProcedure_occurrence_event_definition) {
             listener.exitProcedure_occurrence_event_definition(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitProcedure_occurrence_event_definition) {
            return visitor.visitProcedure_occurrence_event_definition(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Visit_occurrence_event_definitionContext extends antlr.ParserRuleContext {
    public _prefix?: Token | null;
    public _criteria?: Visit_occurrence_event_criteriaContext;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.CLOSE_PAREN, 0)!;
    }
    public VISIT_OCCURRENCE(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.VISIT_OCCURRENCE, 0)!;
    }
    public visit_occurrence_event_criteria(): Visit_occurrence_event_criteriaContext | null {
        return this.getRuleContext(0, Visit_occurrence_event_criteriaContext);
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_visit_occurrence_event_definition;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterVisit_occurrence_event_definition) {
             listener.enterVisit_occurrence_event_definition(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitVisit_occurrence_event_definition) {
             listener.exitVisit_occurrence_event_definition(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitVisit_occurrence_event_definition) {
            return visitor.visitVisit_occurrence_event_definition(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Condition_occurrence_event_criteriaContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public condition_occurrence_event_filter(): Condition_occurrence_event_filterContext[];
    public condition_occurrence_event_filter(i: number): Condition_occurrence_event_filterContext | null;
    public condition_occurrence_event_filter(i?: number): Condition_occurrence_event_filterContext[] | Condition_occurrence_event_filterContext | null {
        if (i === undefined) {
            return this.getRuleContexts(Condition_occurrence_event_filterContext);
        }

        return this.getRuleContext(i, Condition_occurrence_event_filterContext);
    }
    public COMMA(): antlr.TerminalNode[];
    public COMMA(i: number): antlr.TerminalNode | null;
    public COMMA(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(StudyPeriod.COMMA);
    	} else {
    		return this.getToken(StudyPeriod.COMMA, i);
    	}
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_condition_occurrence_event_criteria;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterCondition_occurrence_event_criteria) {
             listener.enterCondition_occurrence_event_criteria(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitCondition_occurrence_event_criteria) {
             listener.exitCondition_occurrence_event_criteria(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitCondition_occurrence_event_criteria) {
            return visitor.visitCondition_occurrence_event_criteria(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Condition_occurrence_event_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public condition_occurrence_concept_filters(): Condition_occurrence_concept_filtersContext | null {
        return this.getRuleContext(0, Condition_occurrence_concept_filtersContext);
    }
    public condition_occurrence_uniqueness_filters(): Condition_occurrence_uniqueness_filtersContext | null {
        return this.getRuleContext(0, Condition_occurrence_uniqueness_filtersContext);
    }
    public condition_occurrence_related_entity_filters(): Condition_occurrence_related_entity_filtersContext | null {
        return this.getRuleContext(0, Condition_occurrence_related_entity_filtersContext);
    }
    public condition_occurrence_error_filter(): Condition_occurrence_error_filterContext | null {
        return this.getRuleContext(0, Condition_occurrence_error_filterContext);
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_condition_occurrence_event_filter;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterCondition_occurrence_event_filter) {
             listener.enterCondition_occurrence_event_filter(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitCondition_occurrence_event_filter) {
             listener.exitCondition_occurrence_event_filter(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitCondition_occurrence_event_filter) {
            return visitor.visitCondition_occurrence_event_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Condition_occurrence_concept_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CF(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.CF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.CLOSE_PAREN, 0)!;
    }
    public condition_occurrence_concept_group_filter(): Condition_occurrence_concept_group_filterContext | null {
        return this.getRuleContext(0, Condition_occurrence_concept_group_filterContext);
    }
    public condition_occurrence_concept_filter(): Condition_occurrence_concept_filterContext | null {
        return this.getRuleContext(0, Condition_occurrence_concept_filterContext);
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_condition_occurrence_concept_filters;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterCondition_occurrence_concept_filters) {
             listener.enterCondition_occurrence_concept_filters(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitCondition_occurrence_concept_filters) {
             listener.exitCondition_occurrence_concept_filters(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitCondition_occurrence_concept_filters) {
            return visitor.visitCondition_occurrence_concept_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Condition_occurrence_concept_group_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE, 0)!;
    }
    public IN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.IN, 0)!;
    }
    public concept_group_selection(): Concept_group_selectionContext {
        return this.getRuleContext(0, Concept_group_selectionContext)!;
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_condition_occurrence_concept_group_filter;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterCondition_occurrence_concept_group_filter) {
             listener.enterCondition_occurrence_concept_group_filter(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitCondition_occurrence_concept_group_filter) {
             listener.exitCondition_occurrence_concept_group_filter(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitCondition_occurrence_concept_group_filter) {
            return visitor.visitCondition_occurrence_concept_group_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Condition_occurrence_concept_filterContext extends antlr.ParserRuleContext {
    public _op?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE, 0)!;
    }
    public CONCEPT(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.CONCEPT, 0)!;
    }
    public EQ(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.EQ, 0);
    }
    public NEQ(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.NEQ, 0);
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_condition_occurrence_concept_filter;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterCondition_occurrence_concept_filter) {
             listener.enterCondition_occurrence_concept_filter(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitCondition_occurrence_concept_filter) {
             listener.exitCondition_occurrence_concept_filter(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitCondition_occurrence_concept_filter) {
            return visitor.visitCondition_occurrence_concept_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Condition_occurrence_uniqueness_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public UF(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.UF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.OPEN_PAREN, 0)!;
    }
    public condition_occurrence_uniqueness_filter(): Condition_occurrence_uniqueness_filterContext {
        return this.getRuleContext(0, Condition_occurrence_uniqueness_filterContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_condition_occurrence_uniqueness_filters;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterCondition_occurrence_uniqueness_filters) {
             listener.enterCondition_occurrence_uniqueness_filters(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitCondition_occurrence_uniqueness_filters) {
             listener.exitCondition_occurrence_uniqueness_filters(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitCondition_occurrence_uniqueness_filters) {
            return visitor.visitCondition_occurrence_uniqueness_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Condition_occurrence_uniqueness_filterContext extends antlr.ParserRuleContext {
    public _date_attr?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CONDITION_OCCURRENCE_DATE_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.CONDITION_OCCURRENCE_DATE_ATTRIBUTE, 0)!;
    }
    public simple_uniqueness_filter(): Simple_uniqueness_filterContext | null {
        return this.getRuleContext(0, Simple_uniqueness_filterContext);
    }
    public simple_uniqueness_filter_window(): Simple_uniqueness_filter_windowContext | null {
        return this.getRuleContext(0, Simple_uniqueness_filter_windowContext);
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_condition_occurrence_uniqueness_filter;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterCondition_occurrence_uniqueness_filter) {
             listener.enterCondition_occurrence_uniqueness_filter(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitCondition_occurrence_uniqueness_filter) {
             listener.exitCondition_occurrence_uniqueness_filter(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitCondition_occurrence_uniqueness_filter) {
            return visitor.visitCondition_occurrence_uniqueness_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Condition_occurrence_related_entity_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public RF(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.RF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.OPEN_PAREN, 0)!;
    }
    public condition_occurrence_related_entity_filter(): Condition_occurrence_related_entity_filterContext {
        return this.getRuleContext(0, Condition_occurrence_related_entity_filterContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_condition_occurrence_related_entity_filters;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterCondition_occurrence_related_entity_filters) {
             listener.enterCondition_occurrence_related_entity_filters(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitCondition_occurrence_related_entity_filters) {
             listener.exitCondition_occurrence_related_entity_filters(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitCondition_occurrence_related_entity_filters) {
            return visitor.visitCondition_occurrence_related_entity_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Condition_occurrence_related_entity_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public provider_sub_filter(): Provider_sub_filterContext | null {
        return this.getRuleContext(0, Provider_sub_filterContext);
    }
    public visit_occurrence_sub_filter(): Visit_occurrence_sub_filterContext | null {
        return this.getRuleContext(0, Visit_occurrence_sub_filterContext);
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_condition_occurrence_related_entity_filter;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterCondition_occurrence_related_entity_filter) {
             listener.enterCondition_occurrence_related_entity_filter(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitCondition_occurrence_related_entity_filter) {
             listener.exitCondition_occurrence_related_entity_filter(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitCondition_occurrence_related_entity_filter) {
            return visitor.visitCondition_occurrence_related_entity_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Condition_occurrence_sub_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CONDITION_OCCURRENCE(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.CONDITION_OCCURRENCE, 0)!;
    }
    public condition_occurrence_concept_group_filter(): Condition_occurrence_concept_group_filterContext | null {
        return this.getRuleContext(0, Condition_occurrence_concept_group_filterContext);
    }
    public condition_occurrence_concept_filter(): Condition_occurrence_concept_filterContext | null {
        return this.getRuleContext(0, Condition_occurrence_concept_filterContext);
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_condition_occurrence_sub_filter;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterCondition_occurrence_sub_filter) {
             listener.enterCondition_occurrence_sub_filter(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitCondition_occurrence_sub_filter) {
             listener.exitCondition_occurrence_sub_filter(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitCondition_occurrence_sub_filter) {
            return visitor.visitCondition_occurrence_sub_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Condition_occurrence_error_sub_filterContext extends antlr.ParserRuleContext {
    public _op?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CONDITION_OCCURRENCE(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.CONDITION_OCCURRENCE, 0);
    }
    public CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE, 0);
    }
    public IN(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.IN, 0);
    }
    public EQ(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.EQ, 0);
    }
    public NEQ(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.NEQ, 0);
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_condition_occurrence_error_sub_filter;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterCondition_occurrence_error_sub_filter) {
             listener.enterCondition_occurrence_error_sub_filter(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitCondition_occurrence_error_sub_filter) {
             listener.exitCondition_occurrence_error_sub_filter(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitCondition_occurrence_error_sub_filter) {
            return visitor.visitCondition_occurrence_error_sub_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Condition_occurrence_error_filterContext extends antlr.ParserRuleContext {
    public _op?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CF(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.CF, 0);
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.CLOSE_PAREN, 0)!;
    }
    public CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.CONDITION_OCCURRENCE_CONCEPT_ATTRIBUTE, 0);
    }
    public IN(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.IN, 0);
    }
    public EQ(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.EQ, 0);
    }
    public NEQ(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.NEQ, 0);
    }
    public UF(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.UF, 0);
    }
    public MINIMUM_BETWEEN(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.MINIMUM_BETWEEN, 0);
    }
    public simple_event_int(): Simple_event_intContext | null {
        return this.getRuleContext(0, Simple_event_intContext);
    }
    public TIME_UNIT(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.TIME_UNIT, 0);
    }
    public FIXED_WINDOW(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.FIXED_WINDOW, 0);
    }
    public ROLLING_WINDOW(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.ROLLING_WINDOW, 0);
    }
    public RF(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.RF, 0);
    }
    public provider_error_sub_filter(): Provider_error_sub_filterContext | null {
        return this.getRuleContext(0, Provider_error_sub_filterContext);
    }
    public visit_occurrence_error_sub_filter(): Visit_occurrence_error_sub_filterContext | null {
        return this.getRuleContext(0, Visit_occurrence_error_sub_filterContext);
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_condition_occurrence_error_filter;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterCondition_occurrence_error_filter) {
             listener.enterCondition_occurrence_error_filter(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitCondition_occurrence_error_filter) {
             listener.exitCondition_occurrence_error_filter(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitCondition_occurrence_error_filter) {
            return visitor.visitCondition_occurrence_error_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Drug_exposure_event_criteriaContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public drug_exposure_event_filter(): Drug_exposure_event_filterContext[];
    public drug_exposure_event_filter(i: number): Drug_exposure_event_filterContext | null;
    public drug_exposure_event_filter(i?: number): Drug_exposure_event_filterContext[] | Drug_exposure_event_filterContext | null {
        if (i === undefined) {
            return this.getRuleContexts(Drug_exposure_event_filterContext);
        }

        return this.getRuleContext(i, Drug_exposure_event_filterContext);
    }
    public COMMA(): antlr.TerminalNode[];
    public COMMA(i: number): antlr.TerminalNode | null;
    public COMMA(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(StudyPeriod.COMMA);
    	} else {
    		return this.getToken(StudyPeriod.COMMA, i);
    	}
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_drug_exposure_event_criteria;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterDrug_exposure_event_criteria) {
             listener.enterDrug_exposure_event_criteria(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitDrug_exposure_event_criteria) {
             listener.exitDrug_exposure_event_criteria(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitDrug_exposure_event_criteria) {
            return visitor.visitDrug_exposure_event_criteria(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Drug_exposure_event_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public drug_exposure_concept_filters(): Drug_exposure_concept_filtersContext | null {
        return this.getRuleContext(0, Drug_exposure_concept_filtersContext);
    }
    public drug_exposure_numeric_filters(): Drug_exposure_numeric_filtersContext | null {
        return this.getRuleContext(0, Drug_exposure_numeric_filtersContext);
    }
    public drug_exposure_uniqueness_filters(): Drug_exposure_uniqueness_filtersContext | null {
        return this.getRuleContext(0, Drug_exposure_uniqueness_filtersContext);
    }
    public drug_exposure_related_entity_filters(): Drug_exposure_related_entity_filtersContext | null {
        return this.getRuleContext(0, Drug_exposure_related_entity_filtersContext);
    }
    public drug_exposure_error_filter(): Drug_exposure_error_filterContext | null {
        return this.getRuleContext(0, Drug_exposure_error_filterContext);
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_drug_exposure_event_filter;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterDrug_exposure_event_filter) {
             listener.enterDrug_exposure_event_filter(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitDrug_exposure_event_filter) {
             listener.exitDrug_exposure_event_filter(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitDrug_exposure_event_filter) {
            return visitor.visitDrug_exposure_event_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Drug_exposure_concept_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CF(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.CF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.CLOSE_PAREN, 0)!;
    }
    public drug_exposure_concept_group_filter(): Drug_exposure_concept_group_filterContext | null {
        return this.getRuleContext(0, Drug_exposure_concept_group_filterContext);
    }
    public drug_exposure_concept_filter(): Drug_exposure_concept_filterContext | null {
        return this.getRuleContext(0, Drug_exposure_concept_filterContext);
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_drug_exposure_concept_filters;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterDrug_exposure_concept_filters) {
             listener.enterDrug_exposure_concept_filters(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitDrug_exposure_concept_filters) {
             listener.exitDrug_exposure_concept_filters(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitDrug_exposure_concept_filters) {
            return visitor.visitDrug_exposure_concept_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Drug_exposure_concept_group_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public DRUG_EXPOSURE_CONCEPT_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.DRUG_EXPOSURE_CONCEPT_ATTRIBUTE, 0)!;
    }
    public IN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.IN, 0)!;
    }
    public concept_group_selection(): Concept_group_selectionContext {
        return this.getRuleContext(0, Concept_group_selectionContext)!;
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_drug_exposure_concept_group_filter;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterDrug_exposure_concept_group_filter) {
             listener.enterDrug_exposure_concept_group_filter(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitDrug_exposure_concept_group_filter) {
             listener.exitDrug_exposure_concept_group_filter(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitDrug_exposure_concept_group_filter) {
            return visitor.visitDrug_exposure_concept_group_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Drug_exposure_concept_filterContext extends antlr.ParserRuleContext {
    public _op?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public DRUG_EXPOSURE_CONCEPT_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.DRUG_EXPOSURE_CONCEPT_ATTRIBUTE, 0)!;
    }
    public CONCEPT(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.CONCEPT, 0)!;
    }
    public EQ(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.EQ, 0);
    }
    public NEQ(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.NEQ, 0);
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_drug_exposure_concept_filter;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterDrug_exposure_concept_filter) {
             listener.enterDrug_exposure_concept_filter(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitDrug_exposure_concept_filter) {
             listener.exitDrug_exposure_concept_filter(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitDrug_exposure_concept_filter) {
            return visitor.visitDrug_exposure_concept_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Drug_exposure_numeric_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public NF(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.NF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.CLOSE_PAREN, 0)!;
    }
    public drug_exposure_float_filter(): Drug_exposure_float_filterContext | null {
        return this.getRuleContext(0, Drug_exposure_float_filterContext);
    }
    public drug_exposure_int_filter(): Drug_exposure_int_filterContext | null {
        return this.getRuleContext(0, Drug_exposure_int_filterContext);
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_drug_exposure_numeric_filters;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterDrug_exposure_numeric_filters) {
             listener.enterDrug_exposure_numeric_filters(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitDrug_exposure_numeric_filters) {
             listener.exitDrug_exposure_numeric_filters(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitDrug_exposure_numeric_filters) {
            return visitor.visitDrug_exposure_numeric_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Drug_exposure_float_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public QUANTITY(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.QUANTITY, 0)!;
    }
    public comparison_op(): Comparison_opContext {
        return this.getRuleContext(0, Comparison_opContext)!;
    }
    public simple_event_float(): Simple_event_floatContext {
        return this.getRuleContext(0, Simple_event_floatContext)!;
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_drug_exposure_float_filter;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterDrug_exposure_float_filter) {
             listener.enterDrug_exposure_float_filter(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitDrug_exposure_float_filter) {
             listener.exitDrug_exposure_float_filter(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitDrug_exposure_float_filter) {
            return visitor.visitDrug_exposure_float_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Drug_exposure_int_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public DRUG_EXPOSURE_INT_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.DRUG_EXPOSURE_INT_ATTRIBUTE, 0)!;
    }
    public comparison_op(): Comparison_opContext {
        return this.getRuleContext(0, Comparison_opContext)!;
    }
    public simple_event_int(): Simple_event_intContext {
        return this.getRuleContext(0, Simple_event_intContext)!;
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_drug_exposure_int_filter;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterDrug_exposure_int_filter) {
             listener.enterDrug_exposure_int_filter(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitDrug_exposure_int_filter) {
             listener.exitDrug_exposure_int_filter(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitDrug_exposure_int_filter) {
            return visitor.visitDrug_exposure_int_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Drug_exposure_uniqueness_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public UF(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.UF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.OPEN_PAREN, 0)!;
    }
    public drug_exposure_uniqueness_filter(): Drug_exposure_uniqueness_filterContext {
        return this.getRuleContext(0, Drug_exposure_uniqueness_filterContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_drug_exposure_uniqueness_filters;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterDrug_exposure_uniqueness_filters) {
             listener.enterDrug_exposure_uniqueness_filters(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitDrug_exposure_uniqueness_filters) {
             listener.exitDrug_exposure_uniqueness_filters(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitDrug_exposure_uniqueness_filters) {
            return visitor.visitDrug_exposure_uniqueness_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Drug_exposure_uniqueness_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public DRUG_EXPOSURE_DATE_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.DRUG_EXPOSURE_DATE_ATTRIBUTE, 0)!;
    }
    public simple_uniqueness_filter(): Simple_uniqueness_filterContext | null {
        return this.getRuleContext(0, Simple_uniqueness_filterContext);
    }
    public simple_uniqueness_filter_window(): Simple_uniqueness_filter_windowContext | null {
        return this.getRuleContext(0, Simple_uniqueness_filter_windowContext);
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_drug_exposure_uniqueness_filter;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterDrug_exposure_uniqueness_filter) {
             listener.enterDrug_exposure_uniqueness_filter(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitDrug_exposure_uniqueness_filter) {
             listener.exitDrug_exposure_uniqueness_filter(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitDrug_exposure_uniqueness_filter) {
            return visitor.visitDrug_exposure_uniqueness_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Drug_exposure_related_entity_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public RF(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.RF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.OPEN_PAREN, 0)!;
    }
    public drug_exposure_related_entity_filter(): Drug_exposure_related_entity_filterContext {
        return this.getRuleContext(0, Drug_exposure_related_entity_filterContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_drug_exposure_related_entity_filters;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterDrug_exposure_related_entity_filters) {
             listener.enterDrug_exposure_related_entity_filters(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitDrug_exposure_related_entity_filters) {
             listener.exitDrug_exposure_related_entity_filters(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitDrug_exposure_related_entity_filters) {
            return visitor.visitDrug_exposure_related_entity_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Drug_exposure_related_entity_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public provider_sub_filter(): Provider_sub_filterContext | null {
        return this.getRuleContext(0, Provider_sub_filterContext);
    }
    public visit_occurrence_sub_filter(): Visit_occurrence_sub_filterContext | null {
        return this.getRuleContext(0, Visit_occurrence_sub_filterContext);
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_drug_exposure_related_entity_filter;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterDrug_exposure_related_entity_filter) {
             listener.enterDrug_exposure_related_entity_filter(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitDrug_exposure_related_entity_filter) {
             listener.exitDrug_exposure_related_entity_filter(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitDrug_exposure_related_entity_filter) {
            return visitor.visitDrug_exposure_related_entity_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Drug_exposure_error_filterContext extends antlr.ParserRuleContext {
    public _op?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CF(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.CF, 0);
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.CLOSE_PAREN, 0)!;
    }
    public DRUG_EXPOSURE_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.DRUG_EXPOSURE_CONCEPT_ATTRIBUTE, 0);
    }
    public IN(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.IN, 0);
    }
    public EQ(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.EQ, 0);
    }
    public NEQ(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.NEQ, 0);
    }
    public NF(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.NF, 0);
    }
    public QUANTITY(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.QUANTITY, 0);
    }
    public comparison_op(): Comparison_opContext | null {
        return this.getRuleContext(0, Comparison_opContext);
    }
    public DRUG_EXPOSURE_INT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.DRUG_EXPOSURE_INT_ATTRIBUTE, 0);
    }
    public UF(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.UF, 0);
    }
    public MINIMUM_BETWEEN(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.MINIMUM_BETWEEN, 0);
    }
    public simple_event_int(): Simple_event_intContext | null {
        return this.getRuleContext(0, Simple_event_intContext);
    }
    public TIME_UNIT(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.TIME_UNIT, 0);
    }
    public FIXED_WINDOW(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.FIXED_WINDOW, 0);
    }
    public ROLLING_WINDOW(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.ROLLING_WINDOW, 0);
    }
    public RF(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.RF, 0);
    }
    public provider_error_sub_filter(): Provider_error_sub_filterContext | null {
        return this.getRuleContext(0, Provider_error_sub_filterContext);
    }
    public visit_occurrence_error_sub_filter(): Visit_occurrence_error_sub_filterContext | null {
        return this.getRuleContext(0, Visit_occurrence_error_sub_filterContext);
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_drug_exposure_error_filter;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterDrug_exposure_error_filter) {
             listener.enterDrug_exposure_error_filter(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitDrug_exposure_error_filter) {
             listener.exitDrug_exposure_error_filter(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitDrug_exposure_error_filter) {
            return visitor.visitDrug_exposure_error_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Measurement_event_criteriaContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public measurement_event_filter(): Measurement_event_filterContext[];
    public measurement_event_filter(i: number): Measurement_event_filterContext | null;
    public measurement_event_filter(i?: number): Measurement_event_filterContext[] | Measurement_event_filterContext | null {
        if (i === undefined) {
            return this.getRuleContexts(Measurement_event_filterContext);
        }

        return this.getRuleContext(i, Measurement_event_filterContext);
    }
    public COMMA(): antlr.TerminalNode[];
    public COMMA(i: number): antlr.TerminalNode | null;
    public COMMA(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(StudyPeriod.COMMA);
    	} else {
    		return this.getToken(StudyPeriod.COMMA, i);
    	}
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_measurement_event_criteria;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterMeasurement_event_criteria) {
             listener.enterMeasurement_event_criteria(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitMeasurement_event_criteria) {
             listener.exitMeasurement_event_criteria(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitMeasurement_event_criteria) {
            return visitor.visitMeasurement_event_criteria(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Measurement_event_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public measurement_concept_filters(): Measurement_concept_filtersContext | null {
        return this.getRuleContext(0, Measurement_concept_filtersContext);
    }
    public measurement_numeric_filters(): Measurement_numeric_filtersContext | null {
        return this.getRuleContext(0, Measurement_numeric_filtersContext);
    }
    public measurement_uniqueness_filters(): Measurement_uniqueness_filtersContext | null {
        return this.getRuleContext(0, Measurement_uniqueness_filtersContext);
    }
    public measurement_related_entity_filters(): Measurement_related_entity_filtersContext | null {
        return this.getRuleContext(0, Measurement_related_entity_filtersContext);
    }
    public measurement_error_filter(): Measurement_error_filterContext | null {
        return this.getRuleContext(0, Measurement_error_filterContext);
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_measurement_event_filter;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterMeasurement_event_filter) {
             listener.enterMeasurement_event_filter(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitMeasurement_event_filter) {
             listener.exitMeasurement_event_filter(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitMeasurement_event_filter) {
            return visitor.visitMeasurement_event_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Measurement_concept_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CF(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.CF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.CLOSE_PAREN, 0)!;
    }
    public measurement_concept_group_filter(): Measurement_concept_group_filterContext | null {
        return this.getRuleContext(0, Measurement_concept_group_filterContext);
    }
    public measurement_concept_filter(): Measurement_concept_filterContext | null {
        return this.getRuleContext(0, Measurement_concept_filterContext);
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_measurement_concept_filters;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterMeasurement_concept_filters) {
             listener.enterMeasurement_concept_filters(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitMeasurement_concept_filters) {
             listener.exitMeasurement_concept_filters(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitMeasurement_concept_filters) {
            return visitor.visitMeasurement_concept_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Measurement_concept_group_filterContext extends antlr.ParserRuleContext {
    public _attr?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public IN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.IN, 0)!;
    }
    public concept_group_selection(): Concept_group_selectionContext {
        return this.getRuleContext(0, Concept_group_selectionContext)!;
    }
    public MEASUREMENT_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.MEASUREMENT_CONCEPT_ATTRIBUTE, 0);
    }
    public COMMON_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.COMMON_CONCEPT_ATTRIBUTE, 0);
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_measurement_concept_group_filter;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterMeasurement_concept_group_filter) {
             listener.enterMeasurement_concept_group_filter(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitMeasurement_concept_group_filter) {
             listener.exitMeasurement_concept_group_filter(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitMeasurement_concept_group_filter) {
            return visitor.visitMeasurement_concept_group_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Measurement_concept_filterContext extends antlr.ParserRuleContext {
    public _attr?: Token | null;
    public _op?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CONCEPT(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.CONCEPT, 0)!;
    }
    public MEASUREMENT_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.MEASUREMENT_CONCEPT_ATTRIBUTE, 0);
    }
    public COMMON_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.COMMON_CONCEPT_ATTRIBUTE, 0);
    }
    public EQ(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.EQ, 0);
    }
    public NEQ(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.NEQ, 0);
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_measurement_concept_filter;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterMeasurement_concept_filter) {
             listener.enterMeasurement_concept_filter(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitMeasurement_concept_filter) {
             listener.exitMeasurement_concept_filter(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitMeasurement_concept_filter) {
            return visitor.visitMeasurement_concept_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Measurement_numeric_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public NF(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.NF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.OPEN_PAREN, 0)!;
    }
    public measurement_float_filter(): Measurement_float_filterContext {
        return this.getRuleContext(0, Measurement_float_filterContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_measurement_numeric_filters;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterMeasurement_numeric_filters) {
             listener.enterMeasurement_numeric_filters(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitMeasurement_numeric_filters) {
             listener.exitMeasurement_numeric_filters(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitMeasurement_numeric_filters) {
            return visitor.visitMeasurement_numeric_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Measurement_float_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public comparison_op(): Comparison_opContext {
        return this.getRuleContext(0, Comparison_opContext)!;
    }
    public simple_event_float(): Simple_event_floatContext {
        return this.getRuleContext(0, Simple_event_floatContext)!;
    }
    public MEASUREMENT_FLOAT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.MEASUREMENT_FLOAT_ATTRIBUTE, 0);
    }
    public COMMON_NUMERIC_FLOAT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.COMMON_NUMERIC_FLOAT_ATTRIBUTE, 0);
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_measurement_float_filter;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterMeasurement_float_filter) {
             listener.enterMeasurement_float_filter(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitMeasurement_float_filter) {
             listener.exitMeasurement_float_filter(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitMeasurement_float_filter) {
            return visitor.visitMeasurement_float_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Measurement_uniqueness_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public UF(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.UF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.OPEN_PAREN, 0)!;
    }
    public measurement_uniqueness_filter(): Measurement_uniqueness_filterContext {
        return this.getRuleContext(0, Measurement_uniqueness_filterContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_measurement_uniqueness_filters;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterMeasurement_uniqueness_filters) {
             listener.enterMeasurement_uniqueness_filters(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitMeasurement_uniqueness_filters) {
             listener.exitMeasurement_uniqueness_filters(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitMeasurement_uniqueness_filters) {
            return visitor.visitMeasurement_uniqueness_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Measurement_uniqueness_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public MEASUREMENT_DATE_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.MEASUREMENT_DATE_ATTRIBUTE, 0)!;
    }
    public simple_uniqueness_filter(): Simple_uniqueness_filterContext | null {
        return this.getRuleContext(0, Simple_uniqueness_filterContext);
    }
    public simple_uniqueness_filter_window(): Simple_uniqueness_filter_windowContext | null {
        return this.getRuleContext(0, Simple_uniqueness_filter_windowContext);
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_measurement_uniqueness_filter;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterMeasurement_uniqueness_filter) {
             listener.enterMeasurement_uniqueness_filter(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitMeasurement_uniqueness_filter) {
             listener.exitMeasurement_uniqueness_filter(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitMeasurement_uniqueness_filter) {
            return visitor.visitMeasurement_uniqueness_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Measurement_related_entity_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public RF(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.RF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.OPEN_PAREN, 0)!;
    }
    public measurement_related_entity_filter(): Measurement_related_entity_filterContext {
        return this.getRuleContext(0, Measurement_related_entity_filterContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_measurement_related_entity_filters;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterMeasurement_related_entity_filters) {
             listener.enterMeasurement_related_entity_filters(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitMeasurement_related_entity_filters) {
             listener.exitMeasurement_related_entity_filters(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitMeasurement_related_entity_filters) {
            return visitor.visitMeasurement_related_entity_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Measurement_related_entity_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public provider_sub_filter(): Provider_sub_filterContext | null {
        return this.getRuleContext(0, Provider_sub_filterContext);
    }
    public visit_occurrence_sub_filter(): Visit_occurrence_sub_filterContext | null {
        return this.getRuleContext(0, Visit_occurrence_sub_filterContext);
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_measurement_related_entity_filter;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterMeasurement_related_entity_filter) {
             listener.enterMeasurement_related_entity_filter(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitMeasurement_related_entity_filter) {
             listener.exitMeasurement_related_entity_filter(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitMeasurement_related_entity_filter) {
            return visitor.visitMeasurement_related_entity_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Measurement_error_filterContext extends antlr.ParserRuleContext {
    public _op?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CF(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.CF, 0);
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.CLOSE_PAREN, 0)!;
    }
    public MEASUREMENT_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.MEASUREMENT_CONCEPT_ATTRIBUTE, 0);
    }
    public IN(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.IN, 0);
    }
    public EQ(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.EQ, 0);
    }
    public NEQ(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.NEQ, 0);
    }
    public COMMON_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.COMMON_CONCEPT_ATTRIBUTE, 0);
    }
    public NF(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.NF, 0);
    }
    public MEASUREMENT_FLOAT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.MEASUREMENT_FLOAT_ATTRIBUTE, 0);
    }
    public COMMON_NUMERIC_FLOAT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.COMMON_NUMERIC_FLOAT_ATTRIBUTE, 0);
    }
    public comparison_op(): Comparison_opContext | null {
        return this.getRuleContext(0, Comparison_opContext);
    }
    public UF(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.UF, 0);
    }
    public MINIMUM_BETWEEN(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.MINIMUM_BETWEEN, 0);
    }
    public simple_event_int(): Simple_event_intContext | null {
        return this.getRuleContext(0, Simple_event_intContext);
    }
    public TIME_UNIT(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.TIME_UNIT, 0);
    }
    public FIXED_WINDOW(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.FIXED_WINDOW, 0);
    }
    public ROLLING_WINDOW(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.ROLLING_WINDOW, 0);
    }
    public RF(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.RF, 0);
    }
    public provider_error_sub_filter(): Provider_error_sub_filterContext | null {
        return this.getRuleContext(0, Provider_error_sub_filterContext);
    }
    public visit_occurrence_error_sub_filter(): Visit_occurrence_error_sub_filterContext | null {
        return this.getRuleContext(0, Visit_occurrence_error_sub_filterContext);
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_measurement_error_filter;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterMeasurement_error_filter) {
             listener.enterMeasurement_error_filter(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitMeasurement_error_filter) {
             listener.exitMeasurement_error_filter(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitMeasurement_error_filter) {
            return visitor.visitMeasurement_error_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Observation_event_criteriaContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public observation_event_filter(): Observation_event_filterContext[];
    public observation_event_filter(i: number): Observation_event_filterContext | null;
    public observation_event_filter(i?: number): Observation_event_filterContext[] | Observation_event_filterContext | null {
        if (i === undefined) {
            return this.getRuleContexts(Observation_event_filterContext);
        }

        return this.getRuleContext(i, Observation_event_filterContext);
    }
    public COMMA(): antlr.TerminalNode[];
    public COMMA(i: number): antlr.TerminalNode | null;
    public COMMA(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(StudyPeriod.COMMA);
    	} else {
    		return this.getToken(StudyPeriod.COMMA, i);
    	}
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_observation_event_criteria;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterObservation_event_criteria) {
             listener.enterObservation_event_criteria(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitObservation_event_criteria) {
             listener.exitObservation_event_criteria(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitObservation_event_criteria) {
            return visitor.visitObservation_event_criteria(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Observation_event_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public observation_concept_filters(): Observation_concept_filtersContext | null {
        return this.getRuleContext(0, Observation_concept_filtersContext);
    }
    public observation_numeric_filters(): Observation_numeric_filtersContext | null {
        return this.getRuleContext(0, Observation_numeric_filtersContext);
    }
    public observation_uniqueness_filters(): Observation_uniqueness_filtersContext | null {
        return this.getRuleContext(0, Observation_uniqueness_filtersContext);
    }
    public observation_related_entity_filters(): Observation_related_entity_filtersContext | null {
        return this.getRuleContext(0, Observation_related_entity_filtersContext);
    }
    public observation_error_filter(): Observation_error_filterContext | null {
        return this.getRuleContext(0, Observation_error_filterContext);
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_observation_event_filter;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterObservation_event_filter) {
             listener.enterObservation_event_filter(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitObservation_event_filter) {
             listener.exitObservation_event_filter(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitObservation_event_filter) {
            return visitor.visitObservation_event_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Observation_concept_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CF(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.CF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.CLOSE_PAREN, 0)!;
    }
    public observation_concept_group_filter(): Observation_concept_group_filterContext | null {
        return this.getRuleContext(0, Observation_concept_group_filterContext);
    }
    public observation_concept_filter(): Observation_concept_filterContext | null {
        return this.getRuleContext(0, Observation_concept_filterContext);
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_observation_concept_filters;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterObservation_concept_filters) {
             listener.enterObservation_concept_filters(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitObservation_concept_filters) {
             listener.exitObservation_concept_filters(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitObservation_concept_filters) {
            return visitor.visitObservation_concept_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Observation_concept_group_filterContext extends antlr.ParserRuleContext {
    public _attr?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public IN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.IN, 0)!;
    }
    public concept_group_selection(): Concept_group_selectionContext {
        return this.getRuleContext(0, Concept_group_selectionContext)!;
    }
    public OBSERVATION_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.OBSERVATION_CONCEPT_ATTRIBUTE, 0);
    }
    public COMMON_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.COMMON_CONCEPT_ATTRIBUTE, 0);
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_observation_concept_group_filter;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterObservation_concept_group_filter) {
             listener.enterObservation_concept_group_filter(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitObservation_concept_group_filter) {
             listener.exitObservation_concept_group_filter(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitObservation_concept_group_filter) {
            return visitor.visitObservation_concept_group_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Observation_concept_filterContext extends antlr.ParserRuleContext {
    public _attr?: Token | null;
    public _op?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CONCEPT(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.CONCEPT, 0)!;
    }
    public OBSERVATION_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.OBSERVATION_CONCEPT_ATTRIBUTE, 0);
    }
    public COMMON_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.COMMON_CONCEPT_ATTRIBUTE, 0);
    }
    public EQ(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.EQ, 0);
    }
    public NEQ(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.NEQ, 0);
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_observation_concept_filter;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterObservation_concept_filter) {
             listener.enterObservation_concept_filter(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitObservation_concept_filter) {
             listener.exitObservation_concept_filter(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitObservation_concept_filter) {
            return visitor.visitObservation_concept_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Observation_numeric_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public NF(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.NF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.CLOSE_PAREN, 0)!;
    }
    public observation_float_filter(): Observation_float_filterContext | null {
        return this.getRuleContext(0, Observation_float_filterContext);
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_observation_numeric_filters;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterObservation_numeric_filters) {
             listener.enterObservation_numeric_filters(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitObservation_numeric_filters) {
             listener.exitObservation_numeric_filters(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitObservation_numeric_filters) {
            return visitor.visitObservation_numeric_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Observation_float_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public COMMON_NUMERIC_FLOAT_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.COMMON_NUMERIC_FLOAT_ATTRIBUTE, 0)!;
    }
    public comparison_op(): Comparison_opContext {
        return this.getRuleContext(0, Comparison_opContext)!;
    }
    public simple_event_float(): Simple_event_floatContext {
        return this.getRuleContext(0, Simple_event_floatContext)!;
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_observation_float_filter;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterObservation_float_filter) {
             listener.enterObservation_float_filter(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitObservation_float_filter) {
             listener.exitObservation_float_filter(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitObservation_float_filter) {
            return visitor.visitObservation_float_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Observation_uniqueness_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public UF(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.UF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.OPEN_PAREN, 0)!;
    }
    public observation_uniqueness_filter(): Observation_uniqueness_filterContext {
        return this.getRuleContext(0, Observation_uniqueness_filterContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_observation_uniqueness_filters;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterObservation_uniqueness_filters) {
             listener.enterObservation_uniqueness_filters(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitObservation_uniqueness_filters) {
             listener.exitObservation_uniqueness_filters(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitObservation_uniqueness_filters) {
            return visitor.visitObservation_uniqueness_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Observation_uniqueness_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public OBSERVATION_DATE_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.OBSERVATION_DATE_ATTRIBUTE, 0)!;
    }
    public simple_uniqueness_filter(): Simple_uniqueness_filterContext | null {
        return this.getRuleContext(0, Simple_uniqueness_filterContext);
    }
    public simple_uniqueness_filter_window(): Simple_uniqueness_filter_windowContext | null {
        return this.getRuleContext(0, Simple_uniqueness_filter_windowContext);
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_observation_uniqueness_filter;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterObservation_uniqueness_filter) {
             listener.enterObservation_uniqueness_filter(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitObservation_uniqueness_filter) {
             listener.exitObservation_uniqueness_filter(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitObservation_uniqueness_filter) {
            return visitor.visitObservation_uniqueness_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Observation_related_entity_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public RF(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.RF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.OPEN_PAREN, 0)!;
    }
    public observation_related_entity_filter(): Observation_related_entity_filterContext {
        return this.getRuleContext(0, Observation_related_entity_filterContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_observation_related_entity_filters;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterObservation_related_entity_filters) {
             listener.enterObservation_related_entity_filters(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitObservation_related_entity_filters) {
             listener.exitObservation_related_entity_filters(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitObservation_related_entity_filters) {
            return visitor.visitObservation_related_entity_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Observation_related_entity_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public provider_sub_filter(): Provider_sub_filterContext | null {
        return this.getRuleContext(0, Provider_sub_filterContext);
    }
    public visit_occurrence_sub_filter(): Visit_occurrence_sub_filterContext | null {
        return this.getRuleContext(0, Visit_occurrence_sub_filterContext);
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_observation_related_entity_filter;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterObservation_related_entity_filter) {
             listener.enterObservation_related_entity_filter(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitObservation_related_entity_filter) {
             listener.exitObservation_related_entity_filter(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitObservation_related_entity_filter) {
            return visitor.visitObservation_related_entity_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Observation_error_filterContext extends antlr.ParserRuleContext {
    public _op?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CF(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.CF, 0);
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.CLOSE_PAREN, 0)!;
    }
    public OBSERVATION_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.OBSERVATION_CONCEPT_ATTRIBUTE, 0);
    }
    public IN(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.IN, 0);
    }
    public EQ(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.EQ, 0);
    }
    public NEQ(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.NEQ, 0);
    }
    public COMMON_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.COMMON_CONCEPT_ATTRIBUTE, 0);
    }
    public NF(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.NF, 0);
    }
    public COMMON_NUMERIC_FLOAT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.COMMON_NUMERIC_FLOAT_ATTRIBUTE, 0);
    }
    public comparison_op(): Comparison_opContext | null {
        return this.getRuleContext(0, Comparison_opContext);
    }
    public UF(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.UF, 0);
    }
    public MINIMUM_BETWEEN(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.MINIMUM_BETWEEN, 0);
    }
    public simple_event_int(): Simple_event_intContext | null {
        return this.getRuleContext(0, Simple_event_intContext);
    }
    public TIME_UNIT(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.TIME_UNIT, 0);
    }
    public FIXED_WINDOW(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.FIXED_WINDOW, 0);
    }
    public ROLLING_WINDOW(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.ROLLING_WINDOW, 0);
    }
    public RF(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.RF, 0);
    }
    public provider_error_sub_filter(): Provider_error_sub_filterContext | null {
        return this.getRuleContext(0, Provider_error_sub_filterContext);
    }
    public visit_occurrence_error_sub_filter(): Visit_occurrence_error_sub_filterContext | null {
        return this.getRuleContext(0, Visit_occurrence_error_sub_filterContext);
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_observation_error_filter;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterObservation_error_filter) {
             listener.enterObservation_error_filter(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitObservation_error_filter) {
             listener.exitObservation_error_filter(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitObservation_error_filter) {
            return visitor.visitObservation_error_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Procedure_occurrence_event_criteriaContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public procedure_occurrence_event_filter(): Procedure_occurrence_event_filterContext[];
    public procedure_occurrence_event_filter(i: number): Procedure_occurrence_event_filterContext | null;
    public procedure_occurrence_event_filter(i?: number): Procedure_occurrence_event_filterContext[] | Procedure_occurrence_event_filterContext | null {
        if (i === undefined) {
            return this.getRuleContexts(Procedure_occurrence_event_filterContext);
        }

        return this.getRuleContext(i, Procedure_occurrence_event_filterContext);
    }
    public COMMA(): antlr.TerminalNode[];
    public COMMA(i: number): antlr.TerminalNode | null;
    public COMMA(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(StudyPeriod.COMMA);
    	} else {
    		return this.getToken(StudyPeriod.COMMA, i);
    	}
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_procedure_occurrence_event_criteria;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterProcedure_occurrence_event_criteria) {
             listener.enterProcedure_occurrence_event_criteria(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitProcedure_occurrence_event_criteria) {
             listener.exitProcedure_occurrence_event_criteria(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitProcedure_occurrence_event_criteria) {
            return visitor.visitProcedure_occurrence_event_criteria(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Procedure_occurrence_event_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public procedure_occurrence_concept_filters(): Procedure_occurrence_concept_filtersContext | null {
        return this.getRuleContext(0, Procedure_occurrence_concept_filtersContext);
    }
    public procedure_occurrence_numeric_filters(): Procedure_occurrence_numeric_filtersContext | null {
        return this.getRuleContext(0, Procedure_occurrence_numeric_filtersContext);
    }
    public procedure_occurrence_uniqueness_filters(): Procedure_occurrence_uniqueness_filtersContext | null {
        return this.getRuleContext(0, Procedure_occurrence_uniqueness_filtersContext);
    }
    public procedure_occurrence_related_entity_filters(): Procedure_occurrence_related_entity_filtersContext | null {
        return this.getRuleContext(0, Procedure_occurrence_related_entity_filtersContext);
    }
    public procedure_occurrence_error_filter(): Procedure_occurrence_error_filterContext | null {
        return this.getRuleContext(0, Procedure_occurrence_error_filterContext);
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_procedure_occurrence_event_filter;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterProcedure_occurrence_event_filter) {
             listener.enterProcedure_occurrence_event_filter(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitProcedure_occurrence_event_filter) {
             listener.exitProcedure_occurrence_event_filter(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitProcedure_occurrence_event_filter) {
            return visitor.visitProcedure_occurrence_event_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Procedure_occurrence_concept_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CF(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.CF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.CLOSE_PAREN, 0)!;
    }
    public procedure_occurrence_concept_group_filter(): Procedure_occurrence_concept_group_filterContext | null {
        return this.getRuleContext(0, Procedure_occurrence_concept_group_filterContext);
    }
    public procedure_occurrence_concept_filter(): Procedure_occurrence_concept_filterContext | null {
        return this.getRuleContext(0, Procedure_occurrence_concept_filterContext);
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_procedure_occurrence_concept_filters;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterProcedure_occurrence_concept_filters) {
             listener.enterProcedure_occurrence_concept_filters(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitProcedure_occurrence_concept_filters) {
             listener.exitProcedure_occurrence_concept_filters(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitProcedure_occurrence_concept_filters) {
            return visitor.visitProcedure_occurrence_concept_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Procedure_occurrence_concept_group_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public PROCEDURE_OCCURRENCE_CONCEPT_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.PROCEDURE_OCCURRENCE_CONCEPT_ATTRIBUTE, 0)!;
    }
    public IN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.IN, 0)!;
    }
    public concept_group_selection(): Concept_group_selectionContext {
        return this.getRuleContext(0, Concept_group_selectionContext)!;
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_procedure_occurrence_concept_group_filter;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterProcedure_occurrence_concept_group_filter) {
             listener.enterProcedure_occurrence_concept_group_filter(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitProcedure_occurrence_concept_group_filter) {
             listener.exitProcedure_occurrence_concept_group_filter(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitProcedure_occurrence_concept_group_filter) {
            return visitor.visitProcedure_occurrence_concept_group_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Procedure_occurrence_concept_filterContext extends antlr.ParserRuleContext {
    public _op?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public PROCEDURE_OCCURRENCE_CONCEPT_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.PROCEDURE_OCCURRENCE_CONCEPT_ATTRIBUTE, 0)!;
    }
    public CONCEPT(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.CONCEPT, 0)!;
    }
    public EQ(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.EQ, 0);
    }
    public NEQ(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.NEQ, 0);
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_procedure_occurrence_concept_filter;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterProcedure_occurrence_concept_filter) {
             listener.enterProcedure_occurrence_concept_filter(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitProcedure_occurrence_concept_filter) {
             listener.exitProcedure_occurrence_concept_filter(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitProcedure_occurrence_concept_filter) {
            return visitor.visitProcedure_occurrence_concept_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Procedure_occurrence_numeric_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public NF(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.NF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.OPEN_PAREN, 0)!;
    }
    public procedure_occurrence_int_filter(): Procedure_occurrence_int_filterContext {
        return this.getRuleContext(0, Procedure_occurrence_int_filterContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_procedure_occurrence_numeric_filters;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterProcedure_occurrence_numeric_filters) {
             listener.enterProcedure_occurrence_numeric_filters(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitProcedure_occurrence_numeric_filters) {
             listener.exitProcedure_occurrence_numeric_filters(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitProcedure_occurrence_numeric_filters) {
            return visitor.visitProcedure_occurrence_numeric_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Procedure_occurrence_int_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public QUANTITY(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.QUANTITY, 0)!;
    }
    public comparison_op(): Comparison_opContext {
        return this.getRuleContext(0, Comparison_opContext)!;
    }
    public simple_event_int(): Simple_event_intContext {
        return this.getRuleContext(0, Simple_event_intContext)!;
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_procedure_occurrence_int_filter;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterProcedure_occurrence_int_filter) {
             listener.enterProcedure_occurrence_int_filter(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitProcedure_occurrence_int_filter) {
             listener.exitProcedure_occurrence_int_filter(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitProcedure_occurrence_int_filter) {
            return visitor.visitProcedure_occurrence_int_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Procedure_occurrence_uniqueness_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public UF(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.UF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.OPEN_PAREN, 0)!;
    }
    public procedure_occurrence_uniqueness_filter(): Procedure_occurrence_uniqueness_filterContext {
        return this.getRuleContext(0, Procedure_occurrence_uniqueness_filterContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_procedure_occurrence_uniqueness_filters;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterProcedure_occurrence_uniqueness_filters) {
             listener.enterProcedure_occurrence_uniqueness_filters(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitProcedure_occurrence_uniqueness_filters) {
             listener.exitProcedure_occurrence_uniqueness_filters(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitProcedure_occurrence_uniqueness_filters) {
            return visitor.visitProcedure_occurrence_uniqueness_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Procedure_occurrence_uniqueness_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public PROCEDURE_OCCURRENCE_DATE_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.PROCEDURE_OCCURRENCE_DATE_ATTRIBUTE, 0)!;
    }
    public simple_uniqueness_filter(): Simple_uniqueness_filterContext | null {
        return this.getRuleContext(0, Simple_uniqueness_filterContext);
    }
    public simple_uniqueness_filter_window(): Simple_uniqueness_filter_windowContext | null {
        return this.getRuleContext(0, Simple_uniqueness_filter_windowContext);
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_procedure_occurrence_uniqueness_filter;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterProcedure_occurrence_uniqueness_filter) {
             listener.enterProcedure_occurrence_uniqueness_filter(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitProcedure_occurrence_uniqueness_filter) {
             listener.exitProcedure_occurrence_uniqueness_filter(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitProcedure_occurrence_uniqueness_filter) {
            return visitor.visitProcedure_occurrence_uniqueness_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Procedure_occurrence_related_entity_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public RF(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.RF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.OPEN_PAREN, 0)!;
    }
    public procedure_occurrence_related_entity_filter(): Procedure_occurrence_related_entity_filterContext {
        return this.getRuleContext(0, Procedure_occurrence_related_entity_filterContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_procedure_occurrence_related_entity_filters;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterProcedure_occurrence_related_entity_filters) {
             listener.enterProcedure_occurrence_related_entity_filters(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitProcedure_occurrence_related_entity_filters) {
             listener.exitProcedure_occurrence_related_entity_filters(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitProcedure_occurrence_related_entity_filters) {
            return visitor.visitProcedure_occurrence_related_entity_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Procedure_occurrence_related_entity_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public provider_sub_filter(): Provider_sub_filterContext | null {
        return this.getRuleContext(0, Provider_sub_filterContext);
    }
    public visit_occurrence_sub_filter(): Visit_occurrence_sub_filterContext | null {
        return this.getRuleContext(0, Visit_occurrence_sub_filterContext);
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_procedure_occurrence_related_entity_filter;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterProcedure_occurrence_related_entity_filter) {
             listener.enterProcedure_occurrence_related_entity_filter(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitProcedure_occurrence_related_entity_filter) {
             listener.exitProcedure_occurrence_related_entity_filter(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitProcedure_occurrence_related_entity_filter) {
            return visitor.visitProcedure_occurrence_related_entity_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Procedure_occurrence_error_filterContext extends antlr.ParserRuleContext {
    public _op?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CF(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.CF, 0);
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.CLOSE_PAREN, 0)!;
    }
    public PROCEDURE_OCCURRENCE_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.PROCEDURE_OCCURRENCE_CONCEPT_ATTRIBUTE, 0);
    }
    public IN(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.IN, 0);
    }
    public EQ(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.EQ, 0);
    }
    public NEQ(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.NEQ, 0);
    }
    public NF(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.NF, 0);
    }
    public QUANTITY(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.QUANTITY, 0);
    }
    public comparison_op(): Comparison_opContext | null {
        return this.getRuleContext(0, Comparison_opContext);
    }
    public UF(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.UF, 0);
    }
    public MINIMUM_BETWEEN(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.MINIMUM_BETWEEN, 0);
    }
    public simple_event_int(): Simple_event_intContext | null {
        return this.getRuleContext(0, Simple_event_intContext);
    }
    public TIME_UNIT(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.TIME_UNIT, 0);
    }
    public FIXED_WINDOW(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.FIXED_WINDOW, 0);
    }
    public ROLLING_WINDOW(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.ROLLING_WINDOW, 0);
    }
    public RF(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.RF, 0);
    }
    public provider_error_sub_filter(): Provider_error_sub_filterContext | null {
        return this.getRuleContext(0, Provider_error_sub_filterContext);
    }
    public visit_occurrence_error_sub_filter(): Visit_occurrence_error_sub_filterContext | null {
        return this.getRuleContext(0, Visit_occurrence_error_sub_filterContext);
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_procedure_occurrence_error_filter;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterProcedure_occurrence_error_filter) {
             listener.enterProcedure_occurrence_error_filter(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitProcedure_occurrence_error_filter) {
             listener.exitProcedure_occurrence_error_filter(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitProcedure_occurrence_error_filter) {
            return visitor.visitProcedure_occurrence_error_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Provider_concept_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CF(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.CF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.CLOSE_PAREN, 0)!;
    }
    public provider_concept_group_filter(): Provider_concept_group_filterContext | null {
        return this.getRuleContext(0, Provider_concept_group_filterContext);
    }
    public provider_concept_filter(): Provider_concept_filterContext | null {
        return this.getRuleContext(0, Provider_concept_filterContext);
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_provider_concept_filters;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterProvider_concept_filters) {
             listener.enterProvider_concept_filters(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitProvider_concept_filters) {
             listener.exitProvider_concept_filters(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitProvider_concept_filters) {
            return visitor.visitProvider_concept_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Provider_concept_group_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public PROVIDER_CONCEPT_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.PROVIDER_CONCEPT_ATTRIBUTE, 0)!;
    }
    public IN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.IN, 0)!;
    }
    public concept_group_selection(): Concept_group_selectionContext {
        return this.getRuleContext(0, Concept_group_selectionContext)!;
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_provider_concept_group_filter;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterProvider_concept_group_filter) {
             listener.enterProvider_concept_group_filter(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitProvider_concept_group_filter) {
             listener.exitProvider_concept_group_filter(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitProvider_concept_group_filter) {
            return visitor.visitProvider_concept_group_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Provider_concept_filterContext extends antlr.ParserRuleContext {
    public _op?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public PROVIDER_CONCEPT_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.PROVIDER_CONCEPT_ATTRIBUTE, 0)!;
    }
    public CONCEPT(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.CONCEPT, 0)!;
    }
    public EQ(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.EQ, 0);
    }
    public NEQ(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.NEQ, 0);
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_provider_concept_filter;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterProvider_concept_filter) {
             listener.enterProvider_concept_filter(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitProvider_concept_filter) {
             listener.exitProvider_concept_filter(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitProvider_concept_filter) {
            return visitor.visitProvider_concept_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Provider_sub_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public PROVIDER(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.PROVIDER, 0)!;
    }
    public provider_concept_group_filter(): Provider_concept_group_filterContext | null {
        return this.getRuleContext(0, Provider_concept_group_filterContext);
    }
    public provider_concept_filter(): Provider_concept_filterContext | null {
        return this.getRuleContext(0, Provider_concept_filterContext);
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_provider_sub_filter;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterProvider_sub_filter) {
             listener.enterProvider_sub_filter(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitProvider_sub_filter) {
             listener.exitProvider_sub_filter(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitProvider_sub_filter) {
            return visitor.visitProvider_sub_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Provider_error_sub_filterContext extends antlr.ParserRuleContext {
    public _op?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public PROVIDER(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.PROVIDER, 0);
    }
    public PROVIDER_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.PROVIDER_CONCEPT_ATTRIBUTE, 0);
    }
    public IN(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.IN, 0);
    }
    public EQ(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.EQ, 0);
    }
    public NEQ(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.NEQ, 0);
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_provider_error_sub_filter;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterProvider_error_sub_filter) {
             listener.enterProvider_error_sub_filter(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitProvider_error_sub_filter) {
             listener.exitProvider_error_sub_filter(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitProvider_error_sub_filter) {
            return visitor.visitProvider_error_sub_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Visit_occurrence_event_criteriaContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public visit_occurrence_event_filter(): Visit_occurrence_event_filterContext[];
    public visit_occurrence_event_filter(i: number): Visit_occurrence_event_filterContext | null;
    public visit_occurrence_event_filter(i?: number): Visit_occurrence_event_filterContext[] | Visit_occurrence_event_filterContext | null {
        if (i === undefined) {
            return this.getRuleContexts(Visit_occurrence_event_filterContext);
        }

        return this.getRuleContext(i, Visit_occurrence_event_filterContext);
    }
    public COMMA(): antlr.TerminalNode[];
    public COMMA(i: number): antlr.TerminalNode | null;
    public COMMA(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(StudyPeriod.COMMA);
    	} else {
    		return this.getToken(StudyPeriod.COMMA, i);
    	}
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_visit_occurrence_event_criteria;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterVisit_occurrence_event_criteria) {
             listener.enterVisit_occurrence_event_criteria(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitVisit_occurrence_event_criteria) {
             listener.exitVisit_occurrence_event_criteria(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitVisit_occurrence_event_criteria) {
            return visitor.visitVisit_occurrence_event_criteria(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Visit_occurrence_event_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public visit_occurrence_concept_filters(): Visit_occurrence_concept_filtersContext | null {
        return this.getRuleContext(0, Visit_occurrence_concept_filtersContext);
    }
    public visit_occurrence_uniqueness_filters(): Visit_occurrence_uniqueness_filtersContext | null {
        return this.getRuleContext(0, Visit_occurrence_uniqueness_filtersContext);
    }
    public visit_occurrence_related_entity_filters(): Visit_occurrence_related_entity_filtersContext | null {
        return this.getRuleContext(0, Visit_occurrence_related_entity_filtersContext);
    }
    public visit_occurrence_error_filter(): Visit_occurrence_error_filterContext | null {
        return this.getRuleContext(0, Visit_occurrence_error_filterContext);
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_visit_occurrence_event_filter;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterVisit_occurrence_event_filter) {
             listener.enterVisit_occurrence_event_filter(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitVisit_occurrence_event_filter) {
             listener.exitVisit_occurrence_event_filter(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitVisit_occurrence_event_filter) {
            return visitor.visitVisit_occurrence_event_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Visit_occurrence_concept_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CF(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.CF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.CLOSE_PAREN, 0)!;
    }
    public visit_occurrence_concept_group_filter(): Visit_occurrence_concept_group_filterContext | null {
        return this.getRuleContext(0, Visit_occurrence_concept_group_filterContext);
    }
    public visit_occurrence_concept_filter(): Visit_occurrence_concept_filterContext | null {
        return this.getRuleContext(0, Visit_occurrence_concept_filterContext);
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_visit_occurrence_concept_filters;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterVisit_occurrence_concept_filters) {
             listener.enterVisit_occurrence_concept_filters(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitVisit_occurrence_concept_filters) {
             listener.exitVisit_occurrence_concept_filters(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitVisit_occurrence_concept_filters) {
            return visitor.visitVisit_occurrence_concept_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Visit_occurrence_concept_group_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE, 0)!;
    }
    public IN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.IN, 0)!;
    }
    public concept_group_selection(): Concept_group_selectionContext {
        return this.getRuleContext(0, Concept_group_selectionContext)!;
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_visit_occurrence_concept_group_filter;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterVisit_occurrence_concept_group_filter) {
             listener.enterVisit_occurrence_concept_group_filter(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitVisit_occurrence_concept_group_filter) {
             listener.exitVisit_occurrence_concept_group_filter(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitVisit_occurrence_concept_group_filter) {
            return visitor.visitVisit_occurrence_concept_group_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Visit_occurrence_concept_filterContext extends antlr.ParserRuleContext {
    public _op?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE, 0)!;
    }
    public CONCEPT(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.CONCEPT, 0)!;
    }
    public EQ(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.EQ, 0);
    }
    public NEQ(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.NEQ, 0);
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_visit_occurrence_concept_filter;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterVisit_occurrence_concept_filter) {
             listener.enterVisit_occurrence_concept_filter(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitVisit_occurrence_concept_filter) {
             listener.exitVisit_occurrence_concept_filter(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitVisit_occurrence_concept_filter) {
            return visitor.visitVisit_occurrence_concept_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Visit_occurrence_uniqueness_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public UF(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.UF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.OPEN_PAREN, 0)!;
    }
    public visit_occurrence_uniqueness_filter(): Visit_occurrence_uniqueness_filterContext {
        return this.getRuleContext(0, Visit_occurrence_uniqueness_filterContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_visit_occurrence_uniqueness_filters;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterVisit_occurrence_uniqueness_filters) {
             listener.enterVisit_occurrence_uniqueness_filters(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitVisit_occurrence_uniqueness_filters) {
             listener.exitVisit_occurrence_uniqueness_filters(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitVisit_occurrence_uniqueness_filters) {
            return visitor.visitVisit_occurrence_uniqueness_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Visit_occurrence_uniqueness_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public VISIT_OCCURRENCE_DATE_ATTRIBUTE(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.VISIT_OCCURRENCE_DATE_ATTRIBUTE, 0)!;
    }
    public simple_uniqueness_filter(): Simple_uniqueness_filterContext | null {
        return this.getRuleContext(0, Simple_uniqueness_filterContext);
    }
    public simple_uniqueness_filter_window(): Simple_uniqueness_filter_windowContext | null {
        return this.getRuleContext(0, Simple_uniqueness_filter_windowContext);
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_visit_occurrence_uniqueness_filter;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterVisit_occurrence_uniqueness_filter) {
             listener.enterVisit_occurrence_uniqueness_filter(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitVisit_occurrence_uniqueness_filter) {
             listener.exitVisit_occurrence_uniqueness_filter(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitVisit_occurrence_uniqueness_filter) {
            return visitor.visitVisit_occurrence_uniqueness_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Visit_occurrence_related_entity_filtersContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public RF(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.RF, 0)!;
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.OPEN_PAREN, 0)!;
    }
    public visit_occurrence_related_entity_filter(): Visit_occurrence_related_entity_filterContext {
        return this.getRuleContext(0, Visit_occurrence_related_entity_filterContext)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.CLOSE_PAREN, 0)!;
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_visit_occurrence_related_entity_filters;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterVisit_occurrence_related_entity_filters) {
             listener.enterVisit_occurrence_related_entity_filters(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitVisit_occurrence_related_entity_filters) {
             listener.exitVisit_occurrence_related_entity_filters(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitVisit_occurrence_related_entity_filters) {
            return visitor.visitVisit_occurrence_related_entity_filters(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Visit_occurrence_related_entity_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public provider_sub_filter(): Provider_sub_filterContext | null {
        return this.getRuleContext(0, Provider_sub_filterContext);
    }
    public condition_occurrence_sub_filter(): Condition_occurrence_sub_filterContext | null {
        return this.getRuleContext(0, Condition_occurrence_sub_filterContext);
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_visit_occurrence_related_entity_filter;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterVisit_occurrence_related_entity_filter) {
             listener.enterVisit_occurrence_related_entity_filter(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitVisit_occurrence_related_entity_filter) {
             listener.exitVisit_occurrence_related_entity_filter(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitVisit_occurrence_related_entity_filter) {
            return visitor.visitVisit_occurrence_related_entity_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Visit_occurrence_sub_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public VISIT_OCCURRENCE(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.VISIT_OCCURRENCE, 0)!;
    }
    public visit_occurrence_concept_group_filter(): Visit_occurrence_concept_group_filterContext | null {
        return this.getRuleContext(0, Visit_occurrence_concept_group_filterContext);
    }
    public visit_occurrence_concept_filter(): Visit_occurrence_concept_filterContext | null {
        return this.getRuleContext(0, Visit_occurrence_concept_filterContext);
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_visit_occurrence_sub_filter;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterVisit_occurrence_sub_filter) {
             listener.enterVisit_occurrence_sub_filter(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitVisit_occurrence_sub_filter) {
             listener.exitVisit_occurrence_sub_filter(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitVisit_occurrence_sub_filter) {
            return visitor.visitVisit_occurrence_sub_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Visit_occurrence_error_sub_filterContext extends antlr.ParserRuleContext {
    public _op?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public VISIT_OCCURRENCE(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.VISIT_OCCURRENCE, 0);
    }
    public VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE, 0);
    }
    public IN(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.IN, 0);
    }
    public EQ(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.EQ, 0);
    }
    public NEQ(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.NEQ, 0);
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_visit_occurrence_error_sub_filter;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterVisit_occurrence_error_sub_filter) {
             listener.enterVisit_occurrence_error_sub_filter(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitVisit_occurrence_error_sub_filter) {
             listener.exitVisit_occurrence_error_sub_filter(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitVisit_occurrence_error_sub_filter) {
            return visitor.visitVisit_occurrence_error_sub_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Visit_occurrence_error_filterContext extends antlr.ParserRuleContext {
    public _op?: Token | null;
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CF(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.CF, 0);
    }
    public OPEN_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.OPEN_PAREN, 0)!;
    }
    public CLOSE_PAREN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.CLOSE_PAREN, 0)!;
    }
    public VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.VISIT_OCCURRENCE_CONCEPT_ATTRIBUTE, 0);
    }
    public IN(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.IN, 0);
    }
    public EQ(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.EQ, 0);
    }
    public NEQ(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.NEQ, 0);
    }
    public UF(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.UF, 0);
    }
    public MINIMUM_BETWEEN(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.MINIMUM_BETWEEN, 0);
    }
    public simple_event_int(): Simple_event_intContext | null {
        return this.getRuleContext(0, Simple_event_intContext);
    }
    public TIME_UNIT(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.TIME_UNIT, 0);
    }
    public FIXED_WINDOW(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.FIXED_WINDOW, 0);
    }
    public ROLLING_WINDOW(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.ROLLING_WINDOW, 0);
    }
    public RF(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.RF, 0);
    }
    public provider_error_sub_filter(): Provider_error_sub_filterContext | null {
        return this.getRuleContext(0, Provider_error_sub_filterContext);
    }
    public condition_occurrence_error_sub_filter(): Condition_occurrence_error_sub_filterContext | null {
        return this.getRuleContext(0, Condition_occurrence_error_sub_filterContext);
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_visit_occurrence_error_filter;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterVisit_occurrence_error_filter) {
             listener.enterVisit_occurrence_error_filter(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitVisit_occurrence_error_filter) {
             listener.exitVisit_occurrence_error_filter(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitVisit_occurrence_error_filter) {
            return visitor.visitVisit_occurrence_error_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Comparison_opContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public EQ(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.EQ, 0);
    }
    public LT(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.LT, 0);
    }
    public GT(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.GT, 0);
    }
    public LTE(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.LTE, 0);
    }
    public GTE(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.GTE, 0);
    }
    public NEQ(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.NEQ, 0);
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_comparison_op;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterComparison_op) {
             listener.enterComparison_op(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitComparison_op) {
             listener.exitComparison_op(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitComparison_op) {
            return visitor.visitComparison_op(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Simple_uniqueness_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public MINIMUM_BETWEEN(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.MINIMUM_BETWEEN, 0)!;
    }
    public simple_event_int(): Simple_event_intContext {
        return this.getRuleContext(0, Simple_event_intContext)!;
    }
    public TIME_UNIT(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.TIME_UNIT, 0)!;
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_simple_uniqueness_filter;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterSimple_uniqueness_filter) {
             listener.enterSimple_uniqueness_filter(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitSimple_uniqueness_filter) {
             listener.exitSimple_uniqueness_filter(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitSimple_uniqueness_filter) {
            return visitor.visitSimple_uniqueness_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Simple_uniqueness_filter_windowContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public fixed_window_uniqueness_filter(): Fixed_window_uniqueness_filterContext | null {
        return this.getRuleContext(0, Fixed_window_uniqueness_filterContext);
    }
    public rolling_window_uniqueness_filter(): Rolling_window_uniqueness_filterContext | null {
        return this.getRuleContext(0, Rolling_window_uniqueness_filterContext);
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_simple_uniqueness_filter_window;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterSimple_uniqueness_filter_window) {
             listener.enterSimple_uniqueness_filter_window(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitSimple_uniqueness_filter_window) {
             listener.exitSimple_uniqueness_filter_window(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitSimple_uniqueness_filter_window) {
            return visitor.visitSimple_uniqueness_filter_window(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Fixed_window_uniqueness_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public FIXED_WINDOW(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.FIXED_WINDOW, 0)!;
    }
    public simple_event_int(): Simple_event_intContext {
        return this.getRuleContext(0, Simple_event_intContext)!;
    }
    public TIME_UNIT(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.TIME_UNIT, 0)!;
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_fixed_window_uniqueness_filter;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterFixed_window_uniqueness_filter) {
             listener.enterFixed_window_uniqueness_filter(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitFixed_window_uniqueness_filter) {
             listener.exitFixed_window_uniqueness_filter(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitFixed_window_uniqueness_filter) {
            return visitor.visitFixed_window_uniqueness_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Rolling_window_uniqueness_filterContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public ROLLING_WINDOW(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.ROLLING_WINDOW, 0)!;
    }
    public simple_event_int(): Simple_event_intContext {
        return this.getRuleContext(0, Simple_event_intContext)!;
    }
    public TIME_UNIT(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.TIME_UNIT, 0)!;
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_rolling_window_uniqueness_filter;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterRolling_window_uniqueness_filter) {
             listener.enterRolling_window_uniqueness_filter(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitRolling_window_uniqueness_filter) {
             listener.exitRolling_window_uniqueness_filter(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitRolling_window_uniqueness_filter) {
            return visitor.visitRolling_window_uniqueness_filter(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Simple_event_floatContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public simple_event_int(): Simple_event_intContext | null {
        return this.getRuleContext(0, Simple_event_intContext);
    }
    public PERIOD(): antlr.TerminalNode | null {
        return this.getToken(StudyPeriod.PERIOD, 0);
    }
    public INT(): antlr.TerminalNode[];
    public INT(i: number): antlr.TerminalNode | null;
    public INT(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(StudyPeriod.INT);
    	} else {
    		return this.getToken(StudyPeriod.INT, i);
    	}
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_simple_event_float;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterSimple_event_float) {
             listener.enterSimple_event_float(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitSimple_event_float) {
             listener.exitSimple_event_float(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitSimple_event_float) {
            return visitor.visitSimple_event_float(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Simple_event_intContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public INT(): antlr.TerminalNode {
        return this.getToken(StudyPeriod.INT, 0)!;
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_simple_event_int;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterSimple_event_int) {
             listener.enterSimple_event_int(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitSimple_event_int) {
             listener.exitSimple_event_int(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitSimple_event_int) {
            return visitor.visitSimple_event_int(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}


export class Concept_group_selectionContext extends antlr.ParserRuleContext {
    public constructor(parent: antlr.ParserRuleContext | null, invokingState: number) {
        super(parent, invokingState);
    }
    public CONCEPT_GROUP(): antlr.TerminalNode[];
    public CONCEPT_GROUP(i: number): antlr.TerminalNode | null;
    public CONCEPT_GROUP(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(StudyPeriod.CONCEPT_GROUP);
    	} else {
    		return this.getToken(StudyPeriod.CONCEPT_GROUP, i);
    	}
    }
    public COMMA(): antlr.TerminalNode[];
    public COMMA(i: number): antlr.TerminalNode | null;
    public COMMA(i?: number): antlr.TerminalNode | null | antlr.TerminalNode[] {
    	if (i === undefined) {
    		return this.getTokens(StudyPeriod.COMMA);
    	} else {
    		return this.getToken(StudyPeriod.COMMA, i);
    	}
    }
    public override get ruleIndex(): number {
        return StudyPeriod.RULE_concept_group_selection;
    }
    public override enterRule(listener: StudyPeriodListener): void {
        if(listener.enterConcept_group_selection) {
             listener.enterConcept_group_selection(this);
        }
    }
    public override exitRule(listener: StudyPeriodListener): void {
        if(listener.exitConcept_group_selection) {
             listener.exitConcept_group_selection(this);
        }
    }
    public override accept<Result>(visitor: StudyPeriodVisitor<Result>): Result | null {
        if (visitor.visitConcept_group_selection) {
            return visitor.visitConcept_group_selection(this);
        } else {
            return visitor.visitChildren(this);
        }
    }
}
